/* OZ Toner - Ink & Toner Finder data
   s = series names (referenced by index)
   b = brands > models > [type, [series indexes]]
   type: 0 = all-ink-cartridges, 1 = all-toner-cartridges
   Series is derived from the model name, so each model sits in
   exactly one series bucket. Models with no series are reachable
   via the All models option.
   4889 models, 123 series */
window.PF = {
s: ["Brother DCP Series","Brother FAX Series","Brother HL Series","Brother MFC Series","Brother MFC-J Series","Brother SP Series","Canon BJC Series","Canon FAX-L Series","Canon I Series","Canon Laser Shot Series","Canon MAXIFY Series","Canon Maxify Series","Canon MultiPASS Series","Canon NP Series","Canon PC Series","Canon PIXMA Endurance Series","Canon PIXMA G Series","Canon PIXMA MG Series","Canon PIXMA MP Series","Canon PIXMA MX Series","Canon PIXMA MZ Series","Canon PIXMA PRO Series","Canon PIXMA TR Series","Canon PIXMA TS Series","Canon PIXMA iP Series","Canon PIXMA iX Series","Canon S Series","Canon SELPHY Series","Canon TR Series","Canon TS Series","Canon imageCLASS D Series","Canon imageCLASS LBP Series","Canon imageCLASS MF Series","Canon imagePROGRAF Series","Canon imageRUNNER ADVANCE Series","Canon imageRUNNER Series","Epson Artisan Series","Epson ColorWorks Series","Epson Discproducer Series","Epson EcoTank Series","Epson Expression Home Series","Epson Expression Photo Series","Epson Expression Series","Epson L Series","Epson PictureMate Series","Epson Stylus Photo Series","Epson Stylus Series","Epson SureColor Series","Epson WorkForce Series","FujiFilm Apeos Print Series","FujiFilm Apeos Series","FujiFilm ApeosPort Print Series","FujiFilm ApeosPort Series","HP AMP Series","HP Business Inkjet Series","HP Color Laser Series","HP Color LaserJet Enterprise Series","HP Color LaserJet Pro MFP Series","HP Color LaserJet Pro Series","HP Color LaserJet Series","HP DesignJet Series","HP Deskjet Series","HP Envy Series","HP Fax Series","HP Industrial Inkjet Series","HP Laser MFP Series","HP LaserJet Enterprise MFP Series","HP LaserJet Enterprise Series","HP LaserJet Managed E Series","HP LaserJet Series","HP Neverstop Laser Series","HP Neverstop Series","HP OfficeJet Pro Series","HP Officejet Pro Series","HP Officejet Series","HP PSC Series","HP PageWide Enterprise Series","HP PageWide Managed Series","HP Pagewide Pro Series","HP PhotoSmart Series","HP Smart Card Printer Series","HP Smart Tank Series","HP TANGO Series","Kyocera ECOSYS Series","Kyocera KM Series","Kyocera TASKalfa Series","Lexmark ApeosPort Print Series","Lexmark ApeosPort Series","Lexmark B Series","Lexmark C Series","Lexmark CS Series","Lexmark CX Series","Lexmark Color Jetprinter Series","Lexmark E Series","Lexmark M Series","Lexmark MB Series","Lexmark MC Series","Lexmark MS Series","Lexmark MX Series","Lexmark Optra Series","Lexmark P Series","Lexmark Pro Series","Lexmark S Series","Lexmark T Series","Lexmark W Series","Lexmark X Series","Lexmark XC Series","Lexmark XM Series","Lexmark XS Series","Lexmark Z Series","OKI B Series","OKI C Series","OKI ES Series","OKI Legacy Series","OKI MB Series","OKI MC Series","OKI PRO Series","Samsung CLP Series","Samsung CLX Series","Samsung ML Series","Samsung MultiXpress SL Series","Samsung MultiXpress Series","Samsung SCX Series"],
b: {
"Brother": {
"DCP-110C":[0,[0]],
"DCP-115C":[0,[0]],
"DCP-120C":[0,[0]],
"DCP-130C":[0,[0]],
"DCP-135C":[0,[0]],
"DCP-145C":[0,[0]],
"DCP-150C":[0,[0]],
"DCP-1510":[1,[0]],
"DCP-165C":[0,[0]],
"DCP-185C":[0,[0]],
"DCP-195C":[0,[0]],
"DCP-235C":[0,[0]],
"DCP-260C":[0,[0]],
"DCP-330C":[0,[0]],
"DCP-350C":[0,[0]],
"DCP-375CW":[0,[0]],
"DCP-385C":[0,[0]],
"DCP-395CN":[0,[0]],
"DCP-465CN":[0,[0]],
"DCP-540CN":[0,[0]],
"DCP-5460CN":[0,[0]],
"DCP-560CN":[0,[0]],
"DCP-585CW":[0,[0]],
"DCP-5860CN":[0,[0]],
"DCP-6690CW":[0,[0]],
"DCP-685CW":[0,[0]],
"DCP-7040":[1,[0]],
"DCP-7055":[1,[0]],
"DCP-7060D":[1,[0]],
"DCP-7065DN":[1,[0]],
"DCP-8020":[1,[0]],
"DCP-8025D":[1,[0]],
"DCP-8070D":[1,[0]],
"DCP-8085DN":[1,[0]],
"DCP-8155DN":[1,[0]],
"DCP-885CW":[0,[0]],
"DCP-9010CN":[1,[0]],
"DCP-9015CDW":[1,[0]],
"DCP-9040CN":[1,[0]],
"DCP-9042CDN":[1,[0]],
"DCP-9055CDN":[1,[0]],
"DCP-J1050DW":[0,[0]],
"DCP-J1100DW":[0,[0]],
"DCP-J1140DW":[0,[0]],
"DCP-J1180DW":[0,[0]],
"DCP-J1200W":[0,[0]],
"DCP-J125":[0,[0]],
"DCP-J1260W":[0,[0]],
"DCP-J1310DW":[0,[0]],
"DCP-J1360DW":[0,[0]],
"DCP-J140W":[0,[0]],
"DCP-J152W":[0,[0]],
"DCP-J172W":[0,[0]],
"DCP-J1800DW":[0,[0]],
"DCP-J315W":[0,[0]],
"DCP-J4110DW":[0,[0]],
"DCP-J4120DW":[0,[0]],
"DCP-J515W":[0,[0]],
"DCP-J525DW":[0,[0]],
"DCP-J525W":[0,[0]],
"DCP-J552DW":[0,[0]],
"DCP-J562DW":[0,[0]],
"DCP-J615W":[0,[0]],
"DCP-J715W":[0,[0]],
"DCP-J725DW":[0,[0]],
"DCP-J752DW":[0,[0]],
"DCP-J772DW":[0,[0]],
"DCP-J925DW":[0,[0]],
"DCP-L1630W":[1,[0]],
"DCP-L2640DW":[1,[0]],
"DCP-L3510CDW":[1,[0]],
"DCP-L3520CDW":[1,[0]],
"DCP-L3551CDW":[1,[0]],
"DCP-L3560CDW":[1,[0]],
"DCP-T580DW":[0,[0]],
"DCP-T780DW":[0,[0]],
"DCPJ125":[0,[0]],
"DCPJ140W":[0,[0]],
"DCPJ315W":[0,[0]],
"DCPJ515W":[0,[0]],
"FAX-1360":[0,[1]],
"FAX-1820C":[0,[1]],
"FAX-1840C":[0,[1]],
"FAX-1920CN":[0,[1]],
"FAX-2480C":[0,[1]],
"FAX-2820":[1,[1]],
"FAX-2840":[1,[1]],
"FAX-2850":[1,[1]],
"FAX-2890":[1,[1]],
"FAX-2920":[1,[1]],
"FAX-2950":[1,[1]],
"FAX-4750":[1,[1]],
"FAX-5750":[1,[1]],
"FAX-8360P":[1,[1]],
"HL-1110":[1,[2]],
"HL-1210W":[1,[2]],
"HL-1230":[1,[2]],
"HL-1240":[1,[2]],
"HL-1250":[1,[2]],
"HL-1270N":[1,[2]],
"HL-1430":[1,[2]],
"HL-1440":[1,[2]],
"HL-1450":[1,[2]],
"HL-1470N":[1,[2]],
"HL-1650":[1,[2]],
"HL-1670N":[1,[2]],
"HL-1850":[1,[2]],
"HL-1870N":[1,[2]],
"HL-2040":[1,[2]],
"HL-2070N":[1,[2]],
"HL-2130":[1,[2]],
"HL-2132":[1,[2]],
"HL-2135W":[1,[2]],
"HL-2140":[1,[2]],
"HL-2142":[1,[2]],
"HL-2150N":[1,[2]],
"HL-2170W":[1,[2]],
"HL-2240D":[1,[2]],
"HL-2242D":[1,[2]],
"HL-2250DN":[1,[2]],
"HL-2270DW":[1,[2]],
"HL-3040CN":[1,[2]],
"HL-3045CN":[1,[2]],
"HL-3070CW":[1,[2]],
"HL-3075CW":[1,[2]],
"HL-3150CDN":[1,[2]],
"HL-3170CDW":[1,[2]],
"HL-3210CW":[1,[2]],
"HL-4040CN":[1,[2]],
"HL-4050CDN":[1,[2]],
"HL-4050CN":[1,[2]],
"HL-4150CDN":[1,[2]],
"HL-4570CDW":[1,[2]],
"HL-5040":[1,[2]],
"HL-5050":[1,[2]],
"HL-5070N":[1,[2]],
"HL-5140":[1,[2]],
"HL-5150D":[1,[2]],
"HL-5170DN":[1,[2]],
"HL-5240":[1,[2]],
"HL-5250DN":[1,[2]],
"HL-5270DN":[1,[2]],
"HL-5340D":[1,[2]],
"HL-5350DN":[1,[2]],
"HL-5370DW":[1,[2]],
"HL-5380DN":[1,[2]],
"HL-5440D":[1,[2]],
"HL-5450DN":[1,[2]],
"HL-5470DW":[1,[2]],
"HL-6180DW":[1,[2]],
"HL-L1230W":[1,[2]],
"HL-L2300D":[1,[2]],
"HL-L2305W":[1,[2]],
"HL-L2310D":[1,[2]],
"HL-L2340DW":[1,[2]],
"HL-L2350DW":[1,[2]],
"HL-L2365DW":[1,[2]],
"HL-L2375DW":[1,[2]],
"HL-L2380DW":[1,[2]],
"HL-L2395DW":[1,[2]],
"HL-L2400DW":[1,[2]],
"HL-L2445DW":[1,[2]],
"HL-L2460DW":[1,[2]],
"HL-L2460DWXL":[1,[2]],
"HL-L2464DW":[1,[2]],
"HL-L2480DW":[1,[2]],
"HL-L3210CW":[1,[2]],
"HL-L3230CDW":[1,[2]],
"HL-L3240CDW":[1,[2]],
"HL-L3270CDW":[1,[2]],
"HL-L3280CDW":[1,[2]],
"HL-L5100DN":[1,[2]],
"HL-L5200DW":[1,[2]],
"HL-L5210DN":[1,[2]],
"HL-L5210DW":[1,[2]],
"HL-L6200DW":[1,[2]],
"HL-L6210DW":[1,[2]],
"HL-L6400CDW":[1,[2]],
"HL-L6400DW":[1,[2]],
"HL-L6415DW":[1,[2]],
"HL-L8240CDW":[1,[2]],
"HL-L8250CDN":[1,[2]],
"HL-L8250CDW":[1,[2]],
"HL-L8260CDW":[1,[2]],
"HL-L8350CDN":[1,[2]],
"HL-L8350CDW":[1,[2]],
"HL-L8360CDW":[1,[2]],
"HL-L8430CDW":[1,[2]],
"HL-L9200CDW":[1,[2]],
"HL-L9310CDW":[1,[2]],
"HL-L9430CDN":[1,[2]],
"HL-L9470CDN":[1,[2]],
"HL-L9630CDN":[1,[2]],
"HL-P2500":[1,[2]],
"HL-S7000DN":[0,[2]],
"HL3150CDN":[1,[2]],
"HL3170CDW":[1,[2]],
"HL5340D":[1,[2]],
"HL5350DN":[1,[2]],
"HL5370DW":[1,[2]],
"HL5380DN":[1,[2]],
"HLL8250CDN":[1,[2]],
"HLL8350CDW":[1,[2]],
"HLL8360CDW":[1,[2]],
"HLL9310CDW":[1,[2]],
"MFC-1810":[1,[3]],
"MFC-210C":[0,[3]],
"MFC-215C":[0,[3]],
"MFC-235C":[0,[3]],
"MFC-240C":[0,[3]],
"MFC-250C":[0,[3]],
"MFC-255CW":[0,[3]],
"MFC-257CW":[0,[3]],
"MFC-260C":[0,[3]],
"MFC-290C":[0,[3]],
"MFC-295CN":[0,[3]],
"MFC-3220C":[0,[3]],
"MFC-3240C":[0,[3]],
"MFC-3360C":[0,[3]],
"MFC-3420C":[0,[3]],
"MFC-3820CN":[0,[3]],
"MFC-410CN":[0,[3]],
"MFC-425CN":[0,[3]],
"MFC-440CN":[0,[3]],
"MFC-4620DW":[0,[3]],
"MFC-465CN":[0,[3]],
"MFC-4800":[1,[3]],
"MFC-490CW":[0,[3]],
"MFC-5440CN":[0,[3]],
"MFC-5460CN":[0,[3]],
"MFC-5490CN":[0,[3]],
"MFC-5840CN":[0,[3]],
"MFC-5860CN":[0,[3]],
"MFC-5890CN":[0,[3]],
"MFC-6180DW":[1,[3]],
"MFC-620CN":[0,[3]],
"MFC-640CW":[0,[3]],
"MFC-6490CW":[0,[3]],
"MFC-665CW":[0,[3]],
"MFC-6690CW":[0,[3]],
"MFC-685CW":[0,[3]],
"MFC-6890CDW":[0,[3]],
"MFC-7220":[1,[3]],
"MFC-7240":[1,[3]],
"MFC-7340":[1,[3]],
"MFC-7360N":[1,[3]],
"MFC-7362N":[1,[3]],
"MFC-7420":[1,[3]],
"MFC-7440N":[1,[3]],
"MFC-7460DN":[1,[3]],
"MFC-7460N":[1,[3]],
"MFC-7820N":[1,[3]],
"MFC-7840":[1,[3]],
"MFC-7840W":[1,[3]],
"MFC-7860DW":[1,[3]],
"MFC-790CW":[0,[3]],
"MFC-795CW":[0,[3]],
"MFC-8220":[1,[3]],
"MFC-8370DN":[1,[3]],
"MFC-8380DN":[1,[3]],
"MFC-8440":[1,[3]],
"MFC-8460DN":[1,[3]],
"MFC-8460N":[1,[3]],
"MFC-8510DN":[1,[3]],
"MFC-8600":[1,[3]],
"MFC-8820D":[1,[3]],
"MFC-8840D":[1,[3]],
"MFC-885CW":[0,[3]],
"MFC-8860DN":[1,[3]],
"MFC-8880DN":[1,[3]],
"MFC-8890DW":[1,[3]],
"MFC-8910DW":[1,[3]],
"MFC-8950DW":[1,[3]],
"MFC-9120CN":[1,[3]],
"MFC-9125CN":[1,[3]],
"MFC-9140CDN":[1,[3]],
"MFC-9160":[1,[3]],
"MFC-9180":[1,[3]],
"MFC-9320CW":[1,[3]],
"MFC-9325CW":[1,[3]],
"MFC-9330CDW":[1,[3]],
"MFC-9335CDW":[1,[3]],
"MFC-9340CDW":[1,[3]],
"MFC-9440CN":[1,[3]],
"MFC-9450CDN":[1,[3]],
"MFC-9460CDN":[1,[3]],
"MFC-9600":[1,[3]],
"MFC-9660":[1,[3]],
"MFC-9840CDW":[1,[3]],
"MFC-9880":[1,[3]],
"MFC-990CW":[0,[3]],
"MFC-9970CDW":[1,[3]],
"MFC-J1010DW":[0,[4]],
"MFC-J1300DW":[0,[4]],
"MFC-J1800DW":[0,[4]],
"MFC-J220":[0,[4]],
"MFC-J2340DW":[0,[4]],
"MFC-J245":[0,[4]],
"MFC-J265W":[0,[4]],
"MFC-J3540DW":[0,[4]],
"MFC-J410":[0,[4]],
"MFC-J415W":[0,[4]],
"MFC-J430W":[0,[4]],
"MFC-J432W":[0,[4]],
"MFC-J4340DW":[0,[4]],
"MFC-J4340DWXL":[0,[4]],
"MFC-J4355DW":[0,[4]],
"MFC-J4410DW":[0,[4]],
"MFC-J4440DW":[0,[4]],
"MFC-J4510DW":[0,[4]],
"MFC-J4540DW":[0,[4]],
"MFC-J4555DW":[0,[4]],
"MFC-J4620DW":[0,[4]],
"MFC-J470DW":[0,[4]],
"MFC-J4710DW":[0,[4]],
"MFC-J475DW":[0,[4]],
"MFC-J480DW":[0,[4]],
"MFC-J491DW":[0,[4]],
"MFC-J5115DW":[0,[4]],
"MFC-J5320DW":[0,[4]],
"MFC-J5330DW":[0,[4]],
"MFC-J5340DW":[0,[4]],
"MFC-J5720DW":[0,[4]],
"MFC-J5730DW":[0,[4]],
"MFC-J5740DW":[0,[4]],
"MFC-J5845DW":[0,[4]],
"MFC-J5855DW":[0,[4]],
"MFC-J5910DW":[0,[4]],
"MFC-J5920DW":[0,[4]],
"MFC-J5930DW":[0,[4]],
"MFC-J5945DW":[0,[4]],
"MFC-J5955DW":[0,[4]],
"MFC-J625DW":[0,[4]],
"MFC-J650DW":[0,[4]],
"MFC-J6510DW":[0,[4]],
"MFC-J6520DW":[0,[4]],
"MFC-J6530DW":[0,[4]],
"MFC-J6540DW":[0,[4]],
"MFC-J6545DW":[0,[4]],
"MFC-J6555DW":[0,[4]],
"MFC-J6560DW":[0,[4]],
"MFC-J6710DW":[0,[4]],
"MFC-J6720DW":[0,[4]],
"MFC-J6730DW":[0,[4]],
"MFC-J6740DW":[0,[4]],
"MFC-J680DW":[0,[4]],
"MFC-J6910DW":[0,[4]],
"MFC-J6920DW":[0,[4]],
"MFC-J6930DW":[0,[4]],
"MFC-J6935DW":[0,[4]],
"MFC-J6940DW":[0,[4]],
"MFC-J6945DW":[0,[4]],
"MFC-J6955DW":[0,[4]],
"MFC-J6957DW":[0,[4]],
"MFC-J6960DW":[0,[4]],
"MFC-J6975DW":[0,[4]],
"MFC-J825DW":[0,[4]],
"MFC-J870DW":[0,[4]],
"MFC-J875DW":[0,[4]],
"MFC-J880DW":[0,[4]],
"MFC-J890DW":[0,[4]],
"MFC-J925DW":[0,[4]],
"MFC-L2700DW":[1,[3]],
"MFC-L2703DW":[1,[3]],
"MFC-L2710DW":[1,[3]],
"MFC-L2713DW":[1,[3]],
"MFC-L2720DW":[1,[3]],
"MFC-L2730DW":[1,[3]],
"MFC-L2740DW":[1,[3]],
"MFC-L2750DW":[1,[3]],
"MFC-L2770DW":[1,[3]],
"MFC-L2800DW":[1,[3]],
"MFC-L2820DW":[1,[3]],
"MFC-L2880DW":[1,[3]],
"MFC-L2880DWXL":[1,[3]],
"MFC-L2920DW":[1,[3]],
"MFC-L3710CW":[1,[3]],
"MFC-L3745CDW":[1,[3]],
"MFC-L3750CDW":[1,[3]],
"MFC-L3755CDW":[1,[3]],
"MFC-L3760CDW":[1,[3]],
"MFC-L3770CDW":[1,[3]],
"MFC-L3780CDW":[1,[3]],
"MFC-L5710DW":[1,[3]],
"MFC-L5755DW":[1,[3]],
"MFC-L5915DW":[1,[3]],
"MFC-L6700DW":[1,[3]],
"MFC-L6720DW":[1,[3]],
"MFC-L6900CDW":[1,[3]],
"MFC-L6900DW":[1,[3]],
"MFC-L6915DW":[1,[3]],
"MFC-L8240CDW":[1,[3]],
"MFC-L8390CDW":[1,[3]],
"MFC-L8600CDW":[1,[3]],
"MFC-L8690CDW":[1,[3]],
"MFC-L8730CDW":[1,[3]],
"MFC-L8850CDW":[1,[3]],
"MFC-L8900CDW":[1,[3]],
"MFC-L8930CDW":[1,[3]],
"MFC-L8970CDW":[1,[3]],
"MFC-L9470CDN":[1,[3]],
"MFC-L9550CDW":[1,[3]],
"MFC-L9570CDW":[1,[3]],
"MFC-L9630CDN":[1,[3]],
"MFC-L9670CDN":[1,[3]],
"MFC8370DN":[1,[3]],
"MFC8880DN":[1,[3]],
"MFC8890DW":[1,[3]],
"MFC9140CDN":[1,[3]],
"MFC9335CDW":[1,[3]],
"MFC9340CDW":[1,[3]],
"MFCJ220":[0,[4]],
"MFCJ265W":[0,[4]],
"MFCJ410":[0,[4]],
"MFCJ415W":[0,[4]],
"MFCJ4355DW":[0,[4]],
"MFCJ4555DW":[0,[4]],
"MFCJ6560DW":[0,[4]],
"MFCJ6960DW":[0,[4]],
"MFCL8600CDW":[1,[3]],
"MFCL8850CDW":[1,[3]],
"MFCL8900CDW":[1,[3]],
"MFCL9570CDW":[1,[3]],
"SP-1 Sublimation Printer":[0,[5]]
},
"Canon": {
"BJC3000":[0,[6]],
"BJC6000":[0,[6]],
"BJC6200":[0,[6]],
"BJC6500":[0,[6]],
"FAX-L200":[1,[7]],
"FAX-L220":[1,[7]],
"FAX-L240":[1,[7]],
"FAX-L250":[1,[7]],
"FAX-L260":[1,[7]],
"FAX-L280":[1,[7]],
"FAX-L290":[1,[7]],
"FAX-L295":[1,[7]],
"FAX-L300":[1,[7]],
"FAX-L350":[1,[7]],
"FAX-L3500":[1,[7]],
"FAX-L360":[1,[7]],
"FAX-L4000":[1,[7]],
"FAX-L450":[1,[7]],
"FAX-L4500":[1,[7]],
"FAX-L6000":[1,[7]],
"G3620":[0,[16]],
"G3625":[0,[16]],
"G3630":[0,[16]],
"G3660":[0,[16]],
"G3665":[0,[16]],
"G3670":[0,[16]],
"G3675":[0,[16]],
"G3680":[0,[16]],
"G3690":[0,[16]],
"G4670":[0,[16]],
"G4680":[0,[16]],
"Laser Shot LBP1210":[1,[9]],
"Laser Shot LBP1260":[1,[9]],
"Laser Shot LBP2900":[1,[9]],
"Laser Shot LBP3000":[1,[9]],
"Laser Shot LBP3018":[1,[9]],
"Laser Shot LBP3050":[1,[9]],
"Laser Shot LBP3100":[1,[9]],
"Laser Shot LBP3100B":[1,[9]],
"Laser Shot LBP3150":[1,[9]],
"Laser Shot LBP3200":[1,[9]],
"Laser Shot LBP3310":[1,[9]],
"Laser Shot LBP3370":[1,[9]],
"Laser Shot LBP3500":[1,[9]],
"Laser Shot LBP430":[1,[9]],
"Laser Shot LBP5000":[1,[9]],
"Laser Shot LBP5050N":[1,[9]],
"Laser Shot LBP5100":[1,[9]],
"Laser Shot LBP5200":[1,[9]],
"Laser Shot LBP5360":[1,[9]],
"Laser Shot LBP6000":[1,[9]],
"Laser Shot LBP6200D":[1,[9]],
"Laser Shot LBP6300DN":[1,[9]],
"Laser Shot LBP6650DN":[1,[9]],
"Laser Shot LBP6750DN":[1,[9]],
"Laser Shot LBP7018C":[1,[9]],
"Laser Shot LBP7200Cdn":[1,[9]],
"Laser Shot LBP7680CX":[1,[9]],
"Laser Shot LBP7750Cdn":[1,[9]],
"Laser Shot LBP7780CX":[1,[9]],
"Laser Shot LBP860":[1,[9]],
"Laser Shot LBP9100Cdn":[1,[9]],
"MAXIFY GX1060":[0,[10]],
"MAXIFY GX2060":[0,[10]],
"MAXIFY GX3060":[0,[10]],
"MAXIFY GX4060":[0,[10]],
"MAXIFY GX5060":[0,[10]],
"MAXIFY GX5560":[0,[10]],
"MAXIFY GX6060":[0,[10]],
"MAXIFY GX6160":[0,[10]],
"MAXIFY GX6560":[0,[10]],
"MAXIFY GX7060":[0,[10]],
"MAXIFY GX7160":[0,[10]],
"MAXIFY MB2060":[0,[10]],
"MAXIFY MB2160":[0,[10]],
"MAXIFY MB2360":[0,[10]],
"MAXIFY MB2760":[0,[10]],
"MAXIFY MB5060":[0,[10]],
"MAXIFY MB5160":[0,[10]],
"MAXIFY MB5360":[0,[10]],
"MAXIFY MB5460":[0,[10]],
"MAXIFY iB4060":[0,[10]],
"MB2060":[0,[11]],
"MB2160":[0,[11]],
"MB2360":[0,[11]],
"MB2760":[0,[11]],
"MultiPASS MP700":[0,[12]],
"MultiPASS MPC100":[0,[12]],
"MultiPASS MPC400":[0,[12]],
"NP1015":[1,[13]],
"NP1215":[1,[13]],
"NP1318":[1,[13]],
"NP1518":[1,[13]],
"NP1520":[1,[13]],
"NP2020":[1,[13]],
"NP2120":[1,[13]],
"NP3030":[1,[13]],
"NP3050":[1,[13]],
"NP3070":[1,[13]],
"NP4050":[1,[13]],
"NP4080":[1,[13]],
"NP6016":[1,[13]],
"NP6025":[1,[13]],
"NP6028":[1,[13]],
"NP6030":[1,[13]],
"NP6035":[1,[13]],
"NP6045":[1,[13]],
"NP6218":[1,[13]],
"NP6241":[1,[13]],
"NP6250":[1,[13]],
"NP6330":[1,[13]],
"NP6350":[1,[13]],
"NP6360":[1,[13]],
"NP6521":[1,[13]],
"NP6545":[1,[13]],
"NP6551":[1,[13]],
"NP6560":[1,[13]],
"NP6621":[1,[13]],
"NP7160":[1,[13]],
"NP7161":[1,[13]],
"NP7163":[1,[13]],
"NP7164":[1,[13]],
"NP7210":[1,[13]],
"PC1210":[1,[14]],
"PC1230":[1,[14]],
"PC1250":[1,[14]],
"PC1270":[1,[14]],
"PC300":[1,[14]],
"PC310":[1,[14]],
"PC320":[1,[14]],
"PC330":[1,[14]],
"PC400":[1,[14]],
"PC420":[1,[14]],
"PC430":[1,[14]],
"PC500":[1,[14]],
"PC530":[1,[14]],
"PC550":[1,[14]],
"PC700":[1,[14]],
"PC710":[1,[14]],
"PC720":[1,[14]],
"PC730":[1,[14]],
"PC735":[1,[14]],
"PC740":[1,[14]],
"PC745":[1,[14]],
"PC760":[1,[14]],
"PC770":[1,[14]],
"PC775":[1,[14]],
"PC785":[1,[14]],
"PC790":[1,[14]],
"PC795":[1,[14]],
"PC860":[1,[14]],
"PC880":[1,[14]],
"PC890":[1,[14]],
"PC920":[1,[14]],
"PC921":[1,[14]],
"PC940":[1,[14]],
"PC941":[1,[14]],
"PC950":[1,[14]],
"PC970":[1,[14]],
"PC980":[1,[14]],
"PIXMA Endurance G2600":[0,[15]],
"PIXMA Endurance G3610":[0,[15]],
"PIXMA Endurance G4610":[0,[15]],
"PIXMA Endurance G6060":[0,[15]],
"PIXMA Endurance G6065":[0,[15]],
"PIXMA Endurance G7060":[0,[15]],
"PIXMA Endurance G7065":[0,[15]],
"PIXMA G3600":[0,[16]],
"PIXMA G3620":[0,[16]],
"PIXMA G3625":[0,[16]],
"PIXMA G3630":[0,[16]],
"PIXMA G3660":[0,[16]],
"PIXMA G3665":[0,[16]],
"PIXMA G3670":[0,[16]],
"PIXMA G3675":[0,[16]],
"PIXMA G3680":[0,[16]],
"PIXMA G3690":[0,[16]],
"PIXMA G4600":[0,[16]],
"PIXMA G4670":[0,[16]],
"PIXMA G4680":[0,[16]],
"PIXMA G660":[0,[16]],
"PIXMA MG2160":[0,[17]],
"PIXMA MG2260":[0,[17]],
"PIXMA MG2460":[0,[17]],
"PIXMA MG2560":[0,[17]],
"PIXMA MG2960":[0,[17]],
"PIXMA MG2965":[0,[17]],
"PIXMA MG3060":[0,[17]],
"PIXMA MG3160":[0,[17]],
"PIXMA MG3260":[0,[17]],
"PIXMA MG3560":[0,[17]],
"PIXMA MG3660":[0,[17]],
"PIXMA MG4160":[0,[17]],
"PIXMA MG4260":[0,[17]],
"PIXMA MG5150":[0,[17]],
"PIXMA MG5250":[0,[17]],
"PIXMA MG5350":[0,[17]],
"PIXMA MG5460":[0,[17]],
"PIXMA MG5560":[0,[17]],
"PIXMA MG5660":[0,[17]],
"PIXMA MG5760":[0,[17]],
"PIXMA MG5765":[0,[17]],
"PIXMA MG5766":[0,[17]],
"PIXMA MG6150":[0,[17]],
"PIXMA MG6250":[0,[17]],
"PIXMA MG6360":[0,[17]],
"PIXMA MG6460":[0,[17]],
"PIXMA MG6660":[0,[17]],
"PIXMA MG6860":[0,[17]],
"PIXMA MG6865":[0,[17]],
"PIXMA MG6866":[0,[17]],
"PIXMA MG7160":[0,[17]],
"PIXMA MG7560":[0,[17]],
"PIXMA MG7760":[0,[17]],
"PIXMA MG7765":[0,[17]],
"PIXMA MG7766":[0,[17]],
"PIXMA MG8150":[0,[17]],
"PIXMA MG8250":[0,[17]],
"PIXMA MP140":[0,[18]],
"PIXMA MP150":[0,[18]],
"PIXMA MP160":[0,[18]],
"PIXMA MP170":[0,[18]],
"PIXMA MP180":[0,[18]],
"PIXMA MP190":[0,[18]],
"PIXMA MP210":[0,[18]],
"PIXMA MP220":[0,[18]],
"PIXMA MP230":[0,[18]],
"PIXMA MP240":[0,[18]],
"PIXMA MP250":[0,[18]],
"PIXMA MP260":[0,[18]],
"PIXMA MP270":[0,[18]],
"PIXMA MP280":[0,[18]],
"PIXMA MP282":[0,[18]],
"PIXMA MP450":[0,[18]],
"PIXMA MP460":[0,[18]],
"PIXMA MP470":[0,[18]],
"PIXMA MP480":[0,[18]],
"PIXMA MP490":[0,[18]],
"PIXMA MP492":[0,[18]],
"PIXMA MP495":[0,[18]],
"PIXMA MP500":[0,[18]],
"PIXMA MP510":[0,[18]],
"PIXMA MP520":[0,[18]],
"PIXMA MP530":[0,[18]],
"PIXMA MP540":[0,[18]],
"PIXMA MP550":[0,[18]],
"PIXMA MP560":[0,[18]],
"PIXMA MP600":[0,[18]],
"PIXMA MP610":[0,[18]],
"PIXMA MP620":[0,[18]],
"PIXMA MP630":[0,[18]],
"PIXMA MP640":[0,[18]],
"PIXMA MP730":[0,[18]],
"PIXMA MP750":[0,[18]],
"PIXMA MP760":[0,[18]],
"PIXMA MP780":[0,[18]],
"PIXMA MP800":[0,[18]],
"PIXMA MP810":[0,[18]],
"PIXMA MP830":[0,[18]],
"PIXMA MP960":[0,[18]],
"PIXMA MP970":[0,[18]],
"PIXMA MP980":[0,[18]],
"PIXMA MP990":[0,[18]],
"PIXMA MX300":[0,[19]],
"PIXMA MX310":[0,[19]],
"PIXMA MX320":[0,[19]],
"PIXMA MX330":[0,[19]],
"PIXMA MX340":[0,[19]],
"PIXMA MX350":[0,[19]],
"PIXMA MX360":[0,[19]],
"PIXMA MX376":[0,[19]],
"PIXMA MX396":[0,[19]],
"PIXMA MX410":[0,[19]],
"PIXMA MX420":[0,[19]],
"PIXMA MX436":[0,[19]],
"PIXMA MX456":[0,[19]],
"PIXMA MX476":[0,[19]],
"PIXMA MX496":[0,[19]],
"PIXMA MX516":[0,[19]],
"PIXMA MX526":[0,[19]],
"PIXMA MX536":[0,[19]],
"PIXMA MX610":[0,[19]],
"PIXMA MX700":[0,[19]],
"PIXMA MX715":[0,[19]],
"PIXMA MX726":[0,[19]],
"PIXMA MX850":[0,[19]],
"PIXMA MX860":[0,[19]],
"PIXMA MX870":[0,[19]],
"PIXMA MX885":[0,[19]],
"PIXMA MX895":[0,[19]],
"PIXMA MX926":[0,[19]],
"PIXMA MZ550":[0,[20]],
"PIXMA PRO-1":[0,[21]],
"PIXMA PRO-10":[0,[21]],
"PIXMA PRO-100":[0,[21]],
"PIXMA PRO-100S":[0,[21]],
"PIXMA PRO-10S":[0,[21]],
"PIXMA PRO-200":[0,[21]],
"PIXMA PRO9000":[0,[21]],
"PIXMA TR150":[0,[22]],
"PIXMA TR160":[0,[22]],
"PIXMA TR4560":[0,[22]],
"PIXMA TR4660":[0,[22]],
"PIXMA TR4665":[0,[22]],
"PIXMA TR7060":[0,[22]],
"PIXMA TR7060a":[0,[22]],
"PIXMA TR7560":[0,[22]],
"PIXMA TR7660":[0,[22]],
"PIXMA TR7660a":[0,[22]],
"PIXMA TR7860":[0,[22]],
"PIXMA TR8560":[0,[22]],
"PIXMA TR8660":[0,[22]],
"PIXMA TR8660a":[0,[22]],
"PIXMA TR9560":[0,[22]],
"PIXMA TR9565":[0,[22]],
"PIXMA TS3160":[0,[23]],
"PIXMA TS3165":[0,[23]],
"PIXMA TS3166":[0,[23]],
"PIXMA TS3360":[0,[23]],
"PIXMA TS3365":[0,[23]],
"PIXMA TS3460":[0,[23]],
"PIXMA TS3465":[0,[23]],
"PIXMA TS3660":[0,[23]],
"PIXMA TS3665":[0,[23]],
"PIXMA TS5060":[0,[23]],
"PIXMA TS5160":[0,[23]],
"PIXMA TS5360":[0,[23]],
"PIXMA TS5360a":[0,[23]],
"PIXMA TS5365":[0,[23]],
"PIXMA TS6060":[0,[23]],
"PIXMA TS6160":[0,[23]],
"PIXMA TS6160W":[0,[23]],
"PIXMA TS6260":[0,[23]],
"PIXMA TS6360":[0,[23]],
"PIXMA TS6360a":[0,[23]],
"PIXMA TS6365":[0,[23]],
"PIXMA TS706":[0,[23]],
"PIXMA TS7650i":[0,[23]],
"PIXMA TS7750i":[0,[23]],
"PIXMA TS7760":[0,[23]],
"PIXMA TS8060":[0,[23]],
"PIXMA TS8160":[0,[23]],
"PIXMA TS8160R":[0,[23]],
"PIXMA TS8160W":[0,[23]],
"PIXMA TS8260":[0,[23]],
"PIXMA TS8360":[0,[23]],
"PIXMA TS8360a":[0,[23]],
"PIXMA TS9060":[0,[23]],
"PIXMA TS9160":[0,[23]],
"PIXMA TS9160R":[0,[23]],
"PIXMA TS9560":[0,[23]],
"PIXMA TS9565":[0,[23]],
"PIXMA iP100":[0,[24]],
"PIXMA iP110":[0,[24]],
"PIXMA iP110W":[0,[24]],
"PIXMA iP1200":[0,[24]],
"PIXMA iP1300":[0,[24]],
"PIXMA iP1600":[0,[24]],
"PIXMA iP1700":[0,[24]],
"PIXMA iP1800":[0,[24]],
"PIXMA iP1900":[0,[24]],
"PIXMA iP2200":[0,[24]],
"PIXMA iP2400":[0,[24]],
"PIXMA iP2600":[0,[24]],
"PIXMA iP2700":[0,[24]],
"PIXMA iP3000":[0,[24]],
"PIXMA iP3300":[0,[24]],
"PIXMA iP3500":[0,[24]],
"PIXMA iP3600":[0,[24]],
"PIXMA iP4000":[0,[24]],
"PIXMA iP4200":[0,[24]],
"PIXMA iP4300":[0,[24]],
"PIXMA iP4500":[0,[24]],
"PIXMA iP4600":[0,[24]],
"PIXMA iP4700":[0,[24]],
"PIXMA iP4800":[0,[24]],
"PIXMA iP4850":[0,[24]],
"PIXMA iP4950":[0,[24]],
"PIXMA iP5000":[0,[24]],
"PIXMA iP5200":[0,[24]],
"PIXMA iP5300":[0,[24]],
"PIXMA iP7260":[0,[24]],
"PIXMA iP8760":[0,[24]],
"PIXMA iP90":[0,[24]],
"PIXMA iX4000":[0,[25]],
"PIXMA iX5000":[0,[25]],
"PIXMA iX6550":[0,[25]],
"PIXMA iX6860":[0,[25]],
"S400":[0,[26]],
"S400SP":[0,[26]],
"S450":[0,[26]],
"S4500":[0,[26]],
"S520":[0,[26]],
"S530D":[0,[26]],
"S600":[0,[26]],
"S6300":[0,[26]],
"S750":[0,[26]],
"SELPHY CP100":[0,[27]],
"SELPHY CP1200":[0,[27]],
"SELPHY CP1300":[0,[27]],
"SELPHY CP1500":[0,[27]],
"SELPHY CP200":[0,[27]],
"SELPHY CP220":[0,[27]],
"SELPHY CP300":[0,[27]],
"SELPHY CP330":[0,[27]],
"SELPHY CP400":[0,[27]],
"SELPHY CP500":[0,[27]],
"SELPHY CP510":[0,[27]],
"SELPHY CP600":[0,[27]],
"SELPHY CP710":[0,[27]],
"SELPHY CP720":[0,[27]],
"SELPHY CP730":[0,[27]],
"SELPHY CP740":[0,[27]],
"SELPHY CP750":[0,[27]],
"SELPHY CP760":[0,[27]],
"SELPHY CP780":[0,[27]],
"SELPHY CP790":[0,[27]],
"SELPHY CP910":[0,[27]],
"TR7160":[0,[28]],
"TS4060":[0,[29]],
"TS4150i":[0,[29]],
"TS5560":[0,[29]],
"TS6550i":[0,[29]],
"TS7550i":[0,[29]],
"i50":[0,[8]],
"i550":[0,[8]],
"i560":[0,[8]],
"i6100":[0,[8]],
"i6500":[0,[8]],
"i671":[0,[8]],
"i70":[0,[8]],
"i80":[0,[8]],
"i850":[0,[8]],
"i865":[0,[8]],
"imageCLASS D620":[1,[30]],
"imageCLASS D660":[1,[30]],
"imageCLASS D680":[1,[30]],
"imageCLASS LBP212dw":[1,[31]],
"imageCLASS LBP215x":[1,[31]],
"imageCLASS LBP223dw":[1,[31]],
"imageCLASS LBP226dw":[1,[31]],
"imageCLASS LBP228x":[1,[31]],
"imageCLASS LBP243dw":[1,[31]],
"imageCLASS LBP243dwII":[1,[31]],
"imageCLASS LBP251dw":[1,[31]],
"imageCLASS LBP253x":[1,[31]],
"imageCLASS LBP312x":[1,[31]],
"imageCLASS LBP351x":[1,[31]],
"imageCLASS LBP352x":[1,[31]],
"imageCLASS LBP445dw":[1,[31]],
"imageCLASS LBP5970":[1,[31]],
"imageCLASS LBP5975":[1,[31]],
"imageCLASS LBP654Cx":[1,[31]],
"imageCLASS LBP664Cx":[1,[31]],
"imageCLASS LBP6680x":[1,[31]],
"imageCLASS LBP674Cx":[1,[31]],
"imageCLASS LBP6780x":[1,[31]],
"imageCLASS LBP710C":[1,[31]],
"imageCLASS LBP712Cx":[1,[31]],
"imageCLASS LBP8100n":[1,[31]],
"imageCLASS LBP841Cdn":[1,[31]],
"imageCLASS LBP843Cx":[1,[31]],
"imageCLASS LBP8780x":[1,[31]],
"imageCLASS MF229dw":[1,[32]],
"imageCLASS MF249dw":[1,[32]],
"imageCLASS MF269dw":[1,[32]],
"imageCLASS MF3010":[1,[32]],
"imageCLASS MF3110":[1,[32]],
"imageCLASS MF3240":[1,[32]],
"imageCLASS MF416dw":[1,[32]],
"imageCLASS MF419x":[1,[32]],
"imageCLASS MF426dw":[1,[32]],
"imageCLASS MF429x":[1,[32]],
"imageCLASS MF445dw":[1,[32]],
"imageCLASS MF448dw":[1,[32]],
"imageCLASS MF449dw":[1,[32]],
"imageCLASS MF449x":[1,[32]],
"imageCLASS MF465dw":[1,[32]],
"imageCLASS MF515x":[1,[32]],
"imageCLASS MF525x":[1,[32]],
"imageCLASS MF543x":[1,[32]],
"imageCLASS MF5600":[1,[32]],
"imageCLASS MF5630":[1,[32]],
"imageCLASS MF5650":[1,[32]],
"imageCLASS MF5700":[1,[32]],
"imageCLASS MF5730":[1,[32]],
"imageCLASS MF5750":[1,[32]],
"imageCLASS MF5770":[1,[32]],
"imageCLASS MF5870dn":[1,[32]],
"imageCLASS MF5980dw":[1,[32]],
"imageCLASS MF6180dw":[1,[32]],
"imageCLASS MF724Cdw":[1,[32]],
"imageCLASS MF726Cdw":[1,[32]],
"imageCLASS MF729Cx":[1,[32]],
"imageCLASS MF735Cx":[1,[32]],
"imageCLASS MF746Cx":[1,[32]],
"imageCLASS MF754Cdw":[1,[32]],
"imageCLASS MF754CdwII":[1,[32]],
"imageCLASS MF756Cx":[1,[32]],
"imageCLASS MF8050Cn":[1,[32]],
"imageCLASS MF8080Cw":[1,[32]],
"imageCLASS MF810Cdn":[1,[32]],
"imageCLASS MF8180C":[1,[32]],
"imageCLASS MF8350Cdn":[1,[32]],
"imageCLASS MF8380Cdw":[1,[32]],
"imageCLASS MF8450C":[1,[32]],
"imageCLASS MF8580Cdn":[1,[32]],
"imageCLASS MF8580Cdw":[1,[32]],
"imageCLASS MF9170C":[1,[32]],
"imageCLASS MF9220Cdn":[1,[32]],
"imageCLASS MF9280Cdn":[1,[32]],
"imageCLASS MF9300":[1,[32]],
"imagePROGRAF GP-200":[0,[33]],
"imagePROGRAF GP-300":[0,[33]],
"imagePROGRAF GP-4600S":[0,[33]],
"imagePROGRAF GP-6600S":[0,[33]],
"imagePROGRAF PRO-1000":[0,[33]],
"imagePROGRAF PRO-1100":[0,[33]],
"imagePROGRAF PRO-2000":[0,[33]],
"imagePROGRAF PRO-2100":[0,[33]],
"imagePROGRAF PRO-2600":[0,[33]],
"imagePROGRAF PRO-300":[0,[33]],
"imagePROGRAF PRO-310":[0,[33]],
"imagePROGRAF PRO-4000":[0,[33]],
"imagePROGRAF PRO-4000S":[0,[33]],
"imagePROGRAF PRO-4100":[0,[33]],
"imagePROGRAF PRO-4600":[0,[33]],
"imagePROGRAF PRO-6000":[0,[33]],
"imagePROGRAF PRO-6000S":[0,[33]],
"imagePROGRAF PRO-6100":[0,[33]],
"imagePROGRAF PRO-6600":[0,[33]],
"imagePROGRAF TA-20":[0,[33]],
"imagePROGRAF TA-30":[0,[33]],
"imagePROGRAF TC-20":[0,[33]],
"imagePROGRAF TC-20M":[0,[33]],
"imagePROGRAF TC-21":[0,[33]],
"imagePROGRAF TC-21M":[0,[33]],
"imagePROGRAF TM-200":[0,[33]],
"imagePROGRAF TM-205":[0,[33]],
"imagePROGRAF TM-240":[0,[33]],
"imagePROGRAF TM-240LM":[0,[33]],
"imagePROGRAF TM-250":[0,[33]],
"imagePROGRAF TM-250LM":[0,[33]],
"imagePROGRAF TM-255":[0,[33]],
"imagePROGRAF TM-300":[0,[33]],
"imagePROGRAF TM-305":[0,[33]],
"imagePROGRAF TM-340":[0,[33]],
"imagePROGRAF TM-340LM":[0,[33]],
"imagePROGRAF TM-350":[0,[33]],
"imagePROGRAF TM-350LM":[0,[33]],
"imagePROGRAF TM-355":[0,[33]],
"imagePROGRAF TX-2000":[0,[33]],
"imagePROGRAF TX-2100":[0,[33]],
"imagePROGRAF TX-3000":[0,[33]],
"imagePROGRAF TX-3100":[0,[33]],
"imagePROGRAF TX-4000":[0,[33]],
"imagePROGRAF TX-4100":[0,[33]],
"imagePROGRAF iPF500":[0,[33]],
"imagePROGRAF iPF5000":[0,[33]],
"imagePROGRAF iPF510":[0,[33]],
"imagePROGRAF iPF5100":[0,[33]],
"imagePROGRAF iPF600":[0,[33]],
"imagePROGRAF iPF6000S":[0,[33]],
"imagePROGRAF iPF605":[0,[33]],
"imagePROGRAF iPF610":[0,[33]],
"imagePROGRAF iPF6100":[0,[33]],
"imagePROGRAF iPF6200":[0,[33]],
"imagePROGRAF iPF6300":[0,[33]],
"imagePROGRAF iPF6300S":[0,[33]],
"imagePROGRAF iPF6350":[0,[33]],
"imagePROGRAF iPF6400":[0,[33]],
"imagePROGRAF iPF6400S":[0,[33]],
"imagePROGRAF iPF6400SE":[0,[33]],
"imagePROGRAF iPF6450":[0,[33]],
"imagePROGRAF iPF650":[0,[33]],
"imagePROGRAF iPF655":[0,[33]],
"imagePROGRAF iPF670":[0,[33]],
"imagePROGRAF iPF670E":[0,[33]],
"imagePROGRAF iPF680":[0,[33]],
"imagePROGRAF iPF685":[0,[33]],
"imagePROGRAF iPF700":[0,[33]],
"imagePROGRAF iPF710":[0,[33]],
"imagePROGRAF iPF720":[0,[33]],
"imagePROGRAF iPF750":[0,[33]],
"imagePROGRAF iPF755":[0,[33]],
"imagePROGRAF iPF760":[0,[33]],
"imagePROGRAF iPF765":[0,[33]],
"imagePROGRAF iPF770":[0,[33]],
"imagePROGRAF iPF780":[0,[33]],
"imagePROGRAF iPF785":[0,[33]],
"imagePROGRAF iPF8000":[0,[33]],
"imagePROGRAF iPF8300":[0,[33]],
"imagePROGRAF iPF8300S":[0,[33]],
"imagePROGRAF iPF8400":[0,[33]],
"imagePROGRAF iPF8400S":[0,[33]],
"imagePROGRAF iPF8400SE":[0,[33]],
"imagePROGRAF iPF9000":[0,[33]],
"imagePROGRAF iPF9400":[0,[33]],
"imagePROGRAF iPF9400S":[0,[33]],
"imageRUNNER 1133":[1,[35]],
"imageRUNNER 1133A":[1,[35]],
"imageRUNNER 1133iF":[1,[35]],
"imageRUNNER 2520i":[1,[35]],
"imageRUNNER 2525i":[1,[35]],
"imageRUNNER 2530":[1,[35]],
"imageRUNNER 4725":[1,[35]],
"imageRUNNER 4735":[1,[35]],
"imageRUNNER 4751":[1,[35]],
"imageRUNNER 5055":[1,[35]],
"imageRUNNER 5056":[1,[35]],
"imageRUNNER 5065":[1,[35]],
"imageRUNNER 5075":[1,[35]],
"imageRUNNER 5570":[1,[35]],
"imageRUNNER 6555":[1,[35]],
"imageRUNNER 6565":[1,[35]],
"imageRUNNER 6570":[1,[35]],
"imageRUNNER 6575":[1,[35]],
"imageRUNNER 6755":[1,[35]],
"imageRUNNER 6780":[1,[35]],
"imageRUNNER 7086":[1,[35]],
"imageRUNNER 7095":[1,[35]],
"imageRUNNER 7105":[1,[35]],
"imageRUNNER 8505":[1,[35]],
"imageRUNNER 8585":[1,[35]],
"imageRUNNER 8595":[1,[35]],
"imageRUNNER 8705":[1,[35]],
"imageRUNNER 8786":[1,[35]],
"imageRUNNER 8795":[1,[35]],
"imageRUNNER ADVANCE 1730i":[1,[34]],
"imageRUNNER ADVANCE 1740i":[1,[34]],
"imageRUNNER ADVANCE 1750i":[1,[34]],
"imageRUNNER ADVANCE 400i":[1,[34]],
"imageRUNNER ADVANCE 4045":[1,[34]],
"imageRUNNER ADVANCE 4051":[1,[34]],
"imageRUNNER ADVANCE 4245":[1,[34]],
"imageRUNNER ADVANCE 4251":[1,[34]],
"imageRUNNER ADVANCE 4525":[1,[34]],
"imageRUNNER ADVANCE 4535":[1,[34]],
"imageRUNNER ADVANCE 4545":[1,[34]],
"imageRUNNER ADVANCE 4551":[1,[34]],
"imageRUNNER ADVANCE 500i":[1,[34]],
"imageRUNNER ADVANCE 6055":[1,[34]],
"imageRUNNER ADVANCE 6065":[1,[34]],
"imageRUNNER ADVANCE 6075":[1,[34]],
"imageRUNNER ADVANCE 8085":[1,[34]],
"imageRUNNER ADVANCE 8095":[1,[34]],
"imageRUNNER ADVANCE 8105":[1,[34]],
"imageRUNNER ADVANCE C2020":[1,[34]],
"imageRUNNER ADVANCE C2030":[1,[34]],
"imageRUNNER ADVANCE C2220":[1,[34]],
"imageRUNNER ADVANCE C2230":[1,[34]],
"imageRUNNER ADVANCE C250i":[1,[34]],
"imageRUNNER ADVANCE C255i":[1,[34]],
"imageRUNNER ADVANCE C256i":[1,[34]],
"imageRUNNER ADVANCE C257i":[1,[34]],
"imageRUNNER ADVANCE C3320":[1,[34]],
"imageRUNNER ADVANCE C3330":[1,[34]],
"imageRUNNER ADVANCE C350i":[1,[34]],
"imageRUNNER ADVANCE C3520":[1,[34]],
"imageRUNNER ADVANCE C3530":[1,[34]],
"imageRUNNER ADVANCE C355i":[1,[34]],
"imageRUNNER ADVANCE C356i":[1,[34]],
"imageRUNNER ADVANCE C357i":[1,[34]],
"imageRUNNER ADVANCE C3720i":[1,[34]],
"imageRUNNER ADVANCE C3730i":[1,[34]],
"imageRUNNER ADVANCE C5030":[1,[34]],
"imageRUNNER ADVANCE C5035":[1,[34]],
"imageRUNNER ADVANCE C5235":[1,[34]],
"imageRUNNER ADVANCE C5240":[1,[34]],
"imageRUNNER ADVANCE C5735i":[1,[34]],
"imageRUNNER ADVANCE C5740i":[1,[34]],
"imageRUNNER ADVANCE C5750i":[1,[34]],
"imageRUNNER ADVANCE C5760i":[1,[34]],
"imageRUNNER ADVANCE DX C3922i":[1,[34]],
"imageRUNNER ADVANCE DX C3926i":[1,[34]],
"imageRUNNER ADVANCE DX C3930i":[1,[34]],
"imageRUNNER ADVANCE DX C3935i":[1,[34]],
"imageRUNNER ADVANCE DX C5840i":[1,[34]],
"imageRUNNER ADVANCE DX C5850i":[1,[34]],
"imageRUNNER ADVANCE DX C5860i":[1,[34]],
"imageRUNNER ADVANCE DX C5870i":[1,[34]],
"imageRUNNER C1021i":[1,[35]],
"imageRUNNER C1028":[1,[35]],
"imageRUNNER C1028iF":[1,[35]],
"imageRUNNER C2110":[1,[35]],
"imageRUNNER C5535":[1,[35]],
"imageRUNNER C5540":[1,[35]],
"imageRUNNER C5550":[1,[35]],
"imageRUNNER C5560":[1,[35]],
"imageRUNNER iRC2620":[1,[35]],
"imageRUNNER iRC3200":[1,[35]],
"imageRUNNER iRC3220":[1,[35]],
"imageRUNNER iRC3225":[1,[35]],
"imageRUNNER iRC3250":[1,[35]]
},
"Epson": {
"Artisan 1430":[0,[36]],
"Artisan 635":[0,[36]],
"Artisan 725":[0,[36]],
"Artisan 730":[0,[36]],
"Artisan 835":[0,[36]],
"Artisan 837":[0,[36]],
"ColorWorks EM-C800":[0,[37]],
"ColorWorks EP-C800":[0,[37]],
"Discproducer PP-100":[0,[38]],
"Discproducer PP-100AP":[0,[38]],
"Discproducer PP-100II":[0,[38]],
"Discproducer PP-100IIBD":[0,[38]],
"Discproducer PP-100III":[0,[38]],
"Discproducer PP-100N":[0,[38]],
"Discproducer PP-50":[0,[38]],
"Discproducer PP-50BD":[0,[38]],
"Discproducer PP-50II":[0,[38]],
"EcoTank ET-1110":[0,[39]],
"EcoTank ET-16500":[0,[39]],
"EcoTank ET-1810":[0,[39]],
"EcoTank ET-1910":[0,[39]],
"EcoTank ET-2500":[0,[39]],
"EcoTank ET-2550":[0,[39]],
"EcoTank ET-2610":[0,[39]],
"EcoTank ET-2650":[0,[39]],
"EcoTank ET-2700":[0,[39]],
"EcoTank ET-2710":[0,[39]],
"EcoTank ET-2720":[0,[39]],
"EcoTank ET-2750":[0,[39]],
"EcoTank ET-2810":[0,[39]],
"EcoTank ET-2811":[0,[39]],
"EcoTank ET-2820":[0,[39]],
"EcoTank ET-2850":[0,[39]],
"EcoTank ET-2910":[0,[39]],
"EcoTank ET-2911":[0,[39]],
"EcoTank ET-2950":[0,[39]],
"EcoTank ET-3600":[0,[39]],
"EcoTank ET-3700":[0,[39]],
"EcoTank ET-3750":[0,[39]],
"EcoTank ET-3800":[0,[39]],
"EcoTank ET-3900":[0,[39]],
"EcoTank ET-3950":[0,[39]],
"EcoTank ET-4500":[0,[39]],
"EcoTank ET-4550":[0,[39]],
"EcoTank ET-4700":[0,[39]],
"EcoTank ET-4750":[0,[39]],
"EcoTank ET-4800":[0,[39]],
"EcoTank ET-4810":[0,[39]],
"EcoTank ET-4850":[0,[39]],
"EcoTank ET-4900":[0,[39]],
"EcoTank ET-4950":[0,[39]],
"EcoTank ET-5800":[0,[39]],
"EcoTank ET-8500":[0,[39]],
"EcoTank ET-8550":[0,[39]],
"EcoTank ET-M1100":[0,[39]],
"EcoTank ET-M1120":[0,[39]],
"EcoTank ET-M1170":[0,[39]],
"EcoTank ET-M1180":[0,[39]],
"EcoTank ET-M2170":[0,[39]],
"EcoTank ET-M3170":[0,[39]],
"EcoTank ET-M3180":[0,[39]],
"EcoTank Pro ET-16600":[0,[39]],
"EcoTank Pro ET-5150":[0,[39]],
"EcoTank Pro ET-5170":[0,[39]],
"Expression Home XP-100":[0,[40]],
"Expression Home XP-200":[0,[40]],
"Expression Home XP-2100":[0,[40]],
"Expression Home XP-2105":[0,[40]],
"Expression Home XP-220":[0,[40]],
"Expression Home XP-2200":[0,[40]],
"Expression Home XP-2205":[0,[40]],
"Expression Home XP-235":[0,[40]],
"Expression Home XP-240":[0,[40]],
"Expression Home XP-245":[0,[40]],
"Expression Home XP-300":[0,[40]],
"Expression Home XP-310":[0,[40]],
"Expression Home XP-3100":[0,[40]],
"Expression Home XP-3105":[0,[40]],
"Expression Home XP-314":[0,[40]],
"Expression Home XP-320":[0,[40]],
"Expression Home XP-3200":[0,[40]],
"Expression Home XP-324":[0,[40]],
"Expression Home XP-340":[0,[40]],
"Expression Home XP-344":[0,[40]],
"Expression Home XP-400":[0,[40]],
"Expression Home XP-410":[0,[40]],
"Expression Home XP-4100":[0,[40]],
"Expression Home XP-4105":[0,[40]],
"Expression Home XP-420":[0,[40]],
"Expression Home XP-4200":[0,[40]],
"Expression Home XP-4205":[0,[40]],
"Expression Home XP-432":[0,[40]],
"Expression Home XP-440":[0,[40]],
"Expression Home XP-442":[0,[40]],
"Expression Home XP-5100":[0,[40]],
"Expression Home XP-5200":[0,[40]],
"Expression Photo HD XP-15000":[0,[41]],
"Expression Photo XP-850":[0,[41]],
"Expression Photo XP-8500":[0,[41]],
"Expression Photo XP-860":[0,[41]],
"Expression Photo XP-8600":[0,[41]],
"Expression Photo XP-8700":[0,[41]],
"Expression Photo XP-950":[0,[41]],
"Expression Photo XP-960":[0,[41]],
"Expression Photo XP-970":[0,[41]],
"Expression Photo XP-980":[0,[41]],
"Expression Premium ET-7700":[0,[42]],
"Expression Premium ET-7750":[0,[42]],
"Expression Premium XP-510":[0,[42]],
"Expression Premium XP-520":[0,[42]],
"Expression Premium XP-530":[0,[42]],
"Expression Premium XP-540":[0,[42]],
"Expression Premium XP-600":[0,[42]],
"Expression Premium XP-6000":[0,[42]],
"Expression Premium XP-610":[0,[42]],
"Expression Premium XP-6100":[0,[42]],
"Expression Premium XP-620":[0,[42]],
"Expression Premium XP-630":[0,[42]],
"Expression Premium XP-640":[0,[42]],
"Expression Premium XP-700":[0,[42]],
"Expression Premium XP-710":[0,[42]],
"Expression Premium XP-720":[0,[42]],
"Expression Premium XP-800":[0,[42]],
"Expression Premium XP-820":[0,[42]],
"Expression Premium XP-900":[0,[42]],
"L1110":[0,[43]],
"L1118":[0,[43]],
"L3100":[0,[43]],
"L3101":[0,[43]],
"L3110":[0,[43]],
"L3150":[0,[43]],
"L5190":[0,[43]],
"PictureMate 210":[0,[44]],
"PictureMate 250":[0,[44]],
"PictureMate 270":[0,[44]],
"PictureMate PM-215":[0,[44]],
"PictureMate PM-235":[0,[44]],
"PictureMate PM-245":[0,[44]],
"PictureMate PM-310":[0,[44]],
"Stylus C110":[0,[46]],
"Stylus C67":[0,[46]],
"Stylus C79":[0,[46]],
"Stylus C87":[0,[46]],
"Stylus C90":[0,[46]],
"Stylus CX3700":[0,[46]],
"Stylus CX3900":[0,[46]],
"Stylus CX4100":[0,[46]],
"Stylus CX4700":[0,[46]],
"Stylus CX4900":[0,[46]],
"Stylus CX5500":[0,[46]],
"Stylus CX5700F":[0,[46]],
"Stylus CX5900":[0,[46]],
"Stylus CX6900F":[0,[46]],
"Stylus CX7300":[0,[46]],
"Stylus CX8300":[0,[46]],
"Stylus CX9300F":[0,[46]],
"Stylus N11":[0,[46]],
"Stylus N130":[0,[46]],
"Stylus NX125":[0,[46]],
"Stylus NX130":[0,[46]],
"Stylus NX220":[0,[46]],
"Stylus NX230":[0,[46]],
"Stylus NX420":[0,[46]],
"Stylus NX430":[0,[46]],
"Stylus NX635":[0,[46]],
"Stylus Office T30":[0,[46]],
"Stylus Office TX300F":[0,[46]],
"Stylus Office TX510FN":[0,[46]],
"Stylus Office TX600FW":[0,[46]],
"Stylus Office TX610FW":[0,[46]],
"Stylus Photo 1410":[0,[45]],
"Stylus Photo R1800":[0,[45]],
"Stylus Photo R1900":[0,[45]],
"Stylus Photo R2000":[0,[45]],
"Stylus Photo R2400":[0,[45]],
"Stylus Photo R250":[0,[45]],
"Stylus Photo R2880":[0,[45]],
"Stylus Photo R290":[0,[45]],
"Stylus Photo R3000":[0,[45]],
"Stylus Photo R390":[0,[45]],
"Stylus Photo R800":[0,[45]],
"Stylus Photo RX250":[0,[45]],
"Stylus Photo RX430":[0,[45]],
"Stylus Photo RX530":[0,[45]],
"Stylus Photo RX590":[0,[45]],
"Stylus Photo RX610":[0,[45]],
"Stylus Photo RX690":[0,[45]],
"Stylus Photo T50":[0,[45]],
"Stylus Photo TX650":[0,[45]],
"Stylus Photo TX700W":[0,[45]],
"Stylus Photo TX710W":[0,[45]],
"Stylus Photo TX800FW":[0,[45]],
"Stylus Photo TX810FW":[0,[45]],
"Stylus Pro 3800":[0,[46]],
"Stylus Pro 3880":[0,[46]],
"Stylus Pro 7700":[0,[46]],
"Stylus Pro 7890":[0,[46]],
"Stylus Pro 7900":[0,[46]],
"Stylus Pro 9700":[0,[46]],
"Stylus Pro 9890":[0,[46]],
"Stylus Pro 9900":[0,[46]],
"Stylus Pro WT7900":[0,[46]],
"Stylus T20":[0,[46]],
"Stylus T21":[0,[46]],
"Stylus TX100":[0,[46]],
"Stylus TX110":[0,[46]],
"Stylus TX200":[0,[46]],
"Stylus TX210":[0,[46]],
"Stylus TX400":[0,[46]],
"Stylus TX410":[0,[46]],
"Stylus TX550W":[0,[46]],
"SureColor F160":[0,[47]],
"SureColor F560":[0,[47]],
"SureColor F561":[0,[47]],
"SureColor P706":[0,[47]],
"SureColor P906":[0,[47]],
"SureColor SC-P405":[0,[47]],
"SureColor SC-P600":[0,[47]],
"SureColor T3160":[0,[47]],
"SureColor T3160M":[0,[47]],
"SureColor T3160N":[0,[47]],
"SureColor T3460":[0,[47]],
"SureColor T3465":[0,[47]],
"SureColor T5160":[0,[47]],
"SureColor T5160M":[0,[47]],
"SureColor T5160N":[0,[47]],
"SureColor T5460":[0,[47]],
"SureColor T5465":[0,[47]],
"WorkForce 320":[0,[48]],
"WorkForce 325":[0,[48]],
"WorkForce 435":[0,[48]],
"WorkForce 525":[0,[48]],
"WorkForce 545":[0,[48]],
"WorkForce 60":[0,[48]],
"WorkForce 625":[0,[48]],
"WorkForce 630":[0,[48]],
"WorkForce 633":[0,[48]],
"WorkForce 645":[0,[48]],
"WorkForce 840":[0,[48]],
"WorkForce 845":[0,[48]],
"WorkForce Pro WF-3720":[0,[48]],
"WorkForce Pro WF-3725":[0,[48]],
"WorkForce Pro WF-3730":[0,[48]],
"WorkForce Pro WF-3820":[0,[48]],
"WorkForce Pro WF-3825":[0,[48]],
"WorkForce Pro WF-4630":[0,[48]],
"WorkForce Pro WF-4640":[0,[48]],
"WorkForce Pro WF-4720":[0,[48]],
"WorkForce Pro WF-4740":[0,[48]],
"WorkForce Pro WF-4745":[0,[48]],
"WorkForce Pro WF-4830":[0,[48]],
"WorkForce Pro WF-4835":[0,[48]],
"WorkForce Pro WF-5190":[0,[48]],
"WorkForce Pro WF-5690":[0,[48]],
"WorkForce Pro WF-C20590":[0,[48]],
"WorkForce Pro WF-C5290":[0,[48]],
"WorkForce Pro WF-C529R":[0,[48]],
"WorkForce Pro WF-C5390":[0,[48]],
"WorkForce Pro WF-C5790":[0,[48]],
"WorkForce Pro WF-C579R":[0,[48]],
"WorkForce Pro WF-C5890":[0,[48]],
"WorkForce Pro WF-C869R":[0,[48]],
"WorkForce Pro WF-C869RTC":[0,[48]],
"WorkForce Pro WF-M5299":[0,[48]],
"WorkForce Pro WF-M5799":[0,[48]],
"WorkForce Pro WF-R5190":[0,[48]],
"WorkForce Pro WF-R5690":[0,[48]],
"WorkForce Pro WP-4090":[0,[48]],
"WorkForce Pro WP-4530":[0,[48]],
"WorkForce Pro WP-4540":[0,[48]],
"WorkForce Pro WP-4590":[0,[48]],
"WorkForce WF-100":[0,[48]],
"WorkForce WF-2510":[0,[48]],
"WorkForce WF-2520":[0,[48]],
"WorkForce WF-2530":[0,[48]],
"WorkForce WF-2540":[0,[48]],
"WorkForce WF-2630":[0,[48]],
"WorkForce WF-2650":[0,[48]],
"WorkForce WF-2660":[0,[48]],
"WorkForce WF-2750":[0,[48]],
"WorkForce WF-2760":[0,[48]],
"WorkForce WF-2810":[0,[48]],
"WorkForce WF-2830":[0,[48]],
"WorkForce WF-2850":[0,[48]],
"WorkForce WF-2860":[0,[48]],
"WorkForce WF-2910":[0,[48]],
"WorkForce WF-2930":[0,[48]],
"WorkForce WF-2950":[0,[48]],
"WorkForce WF-2960":[0,[48]],
"WorkForce WF-3520":[0,[48]],
"WorkForce WF-3530":[0,[48]],
"WorkForce WF-3540":[0,[48]],
"WorkForce WF-3620":[0,[48]],
"WorkForce WF-3640":[0,[48]],
"WorkForce WF-7010":[0,[48]],
"WorkForce WF-7510":[0,[48]],
"WorkForce WF-7520":[0,[48]],
"WorkForce WF-7610":[0,[48]],
"WorkForce WF-7620":[0,[48]],
"WorkForce WF-7710":[0,[48]],
"WorkForce WF-7720":[0,[48]],
"WorkForce WF-7725":[0,[48]],
"WorkForce WF-7830":[0,[48]],
"WorkForce WF-7840":[0,[48]],
"WorkForce WF-7845":[0,[48]],
"XP-8500":[0,[41]],
"XP-8600":[0,[41]],
"XP-8700":[0,[41]]
},
"FujiFilm": {
"Apeos C325":[1,[50]],
"Apeos C325 dw":[1,[50]],
"Apeos C325 z":[1,[50]],
"Apeos C325dw":[1,[50]],
"Apeos C325z":[1,[50]],
"Apeos C5240":[1,[50]],
"Apeos C5240EX":[1,[50]],
"ApeosPort C3320SD":[1,[52]],
"ApeosPort C3830SD":[1,[52]],
"ApeosPort Print C3320SD":[1,[51]],
"ApeosPort Print C3830SD":[1,[51]],
"ApeosPrint C325":[1,[49]],
"ApeosPrint C325 dw":[1,[49]],
"ApeosPrint C325dw":[1,[49]],
"ApeosPrint C5240":[1,[49]],
"C325":[1,[]],
"C325dw":[1,[]],
"C325z":[1,[]],
"FujiFilm Apeos C2061":[1,[50]],
"FujiFilm Apeos C2561":[1,[50]],
"FujiFilm Apeos C3061":[1,[50]]
},
"HP": {
"#1918 Black Dye Print Cartridge":[0,[64]],
"#2510 Smart Card Cartridge":[0,[80]],
"#2520 Smart Card Cartridge":[0,[80]],
"1001":[1,[71]],
"1001nw":[1,[71]],
"15":[1,[]],
"210":[0,[81]],
"4201":[1,[58]],
"4201dn":[1,[]],
"4201dw":[1,[]],
"4301":[1,[58]],
"4301dw":[1,[58]],
"4301fdw":[1,[58]],
"450":[0,[81]],
"455":[0,[81]],
"5105":[0,[81]],
"5106":[0,[81]],
"551":[0,[81]],
"555":[0,[81]],
"559":[0,[81]],
"570":[0,[81]],
"571":[0,[81]],
"6005":[0,[81]],
"651":[0,[81]],
"655":[0,[81]],
"7005":[0,[81]],
"7305":[0,[81]],
"7605":[0,[81]],
"8010":[0,[72]],
"8010e":[0,[72]],
"8012":[0,[72]],
"8020":[0,[72]],
"8020e":[0,[72]],
"8022":[0,[72]],
"8026":[0,[72]],
"8028":[0,[72]],
"AMP 120":[0,[53]],
"AMP 125":[0,[53]],
"AMP 130":[0,[53]],
"Business Inkjet 1000":[0,[54]],
"Business Inkjet 1100":[0,[54]],
"Business Inkjet 1100d":[0,[54]],
"Business Inkjet 1100dtn":[0,[54]],
"Business Inkjet 1200":[0,[54]],
"Business Inkjet 1200d":[0,[54]],
"Business Inkjet 1200dn":[0,[54]],
"Business Inkjet 1200dtn":[0,[54]],
"Business Inkjet 1200dtwn":[0,[54]],
"Business Inkjet 2200":[0,[54]],
"Business Inkjet 2200se":[0,[54]],
"Business Inkjet 2200xi":[0,[54]],
"Business Inkjet 2230":[0,[54]],
"Business Inkjet 2230dtn":[0,[54]],
"Business Inkjet 2250":[0,[54]],
"Business Inkjet 2250tn":[0,[54]],
"Business Inkjet 2280":[0,[54]],
"Business Inkjet 2280tn":[0,[54]],
"Business Inkjet 2300":[0,[54]],
"Business Inkjet 2300dtn":[0,[54]],
"Business Inkjet 2300n":[0,[54]],
"Business Inkjet 2600":[0,[54]],
"Business Inkjet 2600dn":[0,[54]],
"Business Inkjet 2800":[0,[54]],
"Business Inkjet 2800dtn":[0,[54]],
"Business Inkjet 3000":[0,[54]],
"Business Inkjet 3000dtn":[0,[54]],
"Business Inkjet 3000n":[0,[54]],
"C6119A 600dpi Bulk Ink System":[0,[64]],
"C6195A 600dpi Bulk Ink System":[0,[64]],
"C6602A Reduced Height Black Cartridge":[0,[64]],
"Color Laser 150":[1,[55]],
"Color Laser 150a":[1,[55]],
"Color Laser 150nw":[1,[55]],
"Color Laser MFP 178":[1,[55]],
"Color Laser MFP 178nw":[1,[55]],
"Color Laser MFP 179":[1,[55]],
"Color Laser MFP 179fnw":[1,[55]],
"Color LaserJet 1500":[1,[59]],
"Color LaserJet 1500L":[1,[59]],
"Color LaserJet 1500Lxi":[1,[59]],
"Color LaserJet 1600":[1,[59]],
"Color LaserJet 2500":[1,[59]],
"Color LaserJet 2500L":[1,[59]],
"Color LaserJet 2500Lse":[1,[59]],
"Color LaserJet 2500N":[1,[59]],
"Color LaserJet 2500TN":[1,[59]],
"Color LaserJet 2550L":[1,[59]],
"Color LaserJet 2550LN":[1,[59]],
"Color LaserJet 2550N":[1,[59]],
"Color LaserJet 2600n":[1,[59]],
"Color LaserJet 2605":[1,[59]],
"Color LaserJet 2605dn":[1,[59]],
"Color LaserJet 2605dtn":[1,[59]],
"Color LaserJet 2700":[1,[59]],
"Color LaserJet 2700n":[1,[59]],
"Color LaserJet 2820":[1,[59]],
"Color LaserJet 2830":[1,[59]],
"Color LaserJet 2840":[1,[59]],
"Color LaserJet 3000":[1,[59]],
"Color LaserJet 3000dn":[1,[59]],
"Color LaserJet 3000dtn":[1,[59]],
"Color LaserJet 3000n":[1,[59]],
"Color LaserJet 3500":[1,[59]],
"Color LaserJet 3500n":[1,[59]],
"Color LaserJet 3550":[1,[59]],
"Color LaserJet 3550n":[1,[59]],
"Color LaserJet 3600":[1,[59]],
"Color LaserJet 3600dn":[1,[59]],
"Color LaserJet 3600n":[1,[59]],
"Color LaserJet 3700":[1,[59]],
"Color LaserJet 3700DN":[1,[59]],
"Color LaserJet 3700DTN":[1,[59]],
"Color LaserJet 3700N":[1,[59]],
"Color LaserJet 3800":[1,[59]],
"Color LaserJet 3800dn":[1,[59]],
"Color LaserJet 3800dtn":[1,[59]],
"Color LaserJet 3800n":[1,[59]],
"Color LaserJet 4500":[1,[59]],
"Color LaserJet 4500SE":[1,[59]],
"Color LaserJet 4500dn":[1,[59]],
"Color LaserJet 4500hdn":[1,[59]],
"Color LaserJet 4500n":[1,[59]],
"Color LaserJet 4550":[1,[59]],
"Color LaserJet 4550dn":[1,[59]],
"Color LaserJet 4550hdn":[1,[59]],
"Color LaserJet 4550n":[1,[59]],
"Color LaserJet 4600":[1,[59]],
"Color LaserJet 4600dn":[1,[59]],
"Color LaserJet 4600dtn":[1,[59]],
"Color LaserJet 4600hdn":[1,[59]],
"Color LaserJet 4600n":[1,[59]],
"Color LaserJet 4610":[1,[59]],
"Color LaserJet 4650":[1,[59]],
"Color LaserJet 4650dn":[1,[59]],
"Color LaserJet 4650dtn":[1,[59]],
"Color LaserJet 4650hdn":[1,[59]],
"Color LaserJet 4650n":[1,[59]],
"Color LaserJet 4700":[1,[59]],
"Color LaserJet 4700dn":[1,[59]],
"Color LaserJet 4700dtn":[1,[59]],
"Color LaserJet 4700n":[1,[59]],
"Color LaserJet 4700ph":[1,[59]],
"Color LaserJet 4730":[1,[59]],
"Color LaserJet 4730x":[1,[59]],
"Color LaserJet 4730xm":[1,[59]],
"Color LaserJet 4730xs":[1,[59]],
"Color LaserJet 5500":[1,[59]],
"Color LaserJet 5500DTN":[1,[59]],
"Color LaserJet 5500HDN":[1,[59]],
"Color LaserJet 5500N":[1,[59]],
"Color LaserJet 5500dn":[1,[59]],
"Color LaserJet 5550":[1,[59]],
"Color LaserJet 5550dn":[1,[59]],
"Color LaserJet 5550dtn":[1,[59]],
"Color LaserJet 5550hdn":[1,[59]],
"Color LaserJet 5550n":[1,[59]],
"Color LaserJet 8500":[1,[59]],
"Color LaserJet 8500dn":[1,[59]],
"Color LaserJet 8500n":[1,[59]],
"Color LaserJet 8550":[1,[59]],
"Color LaserJet 8550dn":[1,[59]],
"Color LaserJet 8550gn":[1,[59]],
"Color LaserJet 8550n":[1,[59]],
"Color LaserJet 9500":[1,[59]],
"Color LaserJet 9500gp":[1,[59]],
"Color LaserJet 9500hdn":[1,[59]],
"Color LaserJet 9500n":[1,[59]],
"Color LaserJet CM1015":[1,[59]],
"Color LaserJet CM1017":[1,[59]],
"Color LaserJet CM1300":[1,[59]],
"Color LaserJet CM1312":[1,[59]],
"Color LaserJet CM1312nfi":[1,[59]],
"Color LaserJet CM1415fn":[1,[59]],
"Color LaserJet CM1415fnw":[1,[59]],
"Color LaserJet CM2320fxi":[1,[59]],
"Color LaserJet CM2320n":[1,[59]],
"Color LaserJet CM2320nf":[1,[59]],
"Color LaserJet CM3530":[1,[59]],
"Color LaserJet CM3530fs":[1,[59]],
"Color LaserJet CM4540":[1,[59]],
"Color LaserJet CM4540f":[1,[59]],
"Color LaserJet CM4540fskm":[1,[59]],
"Color LaserJet CM4730":[1,[59]],
"Color LaserJet CM4730f":[1,[59]],
"Color LaserJet CM4730fm":[1,[59]],
"Color LaserJet CM4730fsk":[1,[59]],
"Color LaserJet CM6030":[1,[59]],
"Color LaserJet CM6030f":[1,[59]],
"Color LaserJet CM6040":[1,[59]],
"Color LaserJet CM6040f":[1,[59]],
"Color LaserJet CP1025":[1,[59]],
"Color LaserJet CP1025nw":[1,[59]],
"Color LaserJet CP1215":[1,[59]],
"Color LaserJet CP1515n":[1,[59]],
"Color LaserJet CP1518ni":[1,[59]],
"Color LaserJet CP1523":[1,[59]],
"Color LaserJet CP1525":[1,[59]],
"Color LaserJet CP1525n":[1,[59]],
"Color LaserJet CP1525nw":[1,[59]],
"Color LaserJet CP2025":[1,[59]],
"Color LaserJet CP2025dn":[1,[59]],
"Color LaserJet CP2025n":[1,[59]],
"Color LaserJet CP2025x":[1,[59]],
"Color LaserJet CP3505":[1,[59]],
"Color LaserJet CP3505dn":[1,[59]],
"Color LaserJet CP3505n":[1,[59]],
"Color LaserJet CP3505x":[1,[59]],
"Color LaserJet CP3525":[1,[59]],
"Color LaserJet CP3525dn":[1,[59]],
"Color LaserJet CP3525n":[1,[59]],
"Color LaserJet CP3525x":[1,[59]],
"Color LaserJet CP4005":[1,[59]],
"Color LaserJet CP4005dn":[1,[59]],
"Color LaserJet CP4005n":[1,[59]],
"Color LaserJet CP4025dn":[1,[59]],
"Color LaserJet CP4025n":[1,[59]],
"Color LaserJet CP4525":[1,[59]],
"Color LaserJet CP4525dn":[1,[59]],
"Color LaserJet CP4525n":[1,[59]],
"Color LaserJet CP4525x":[1,[59]],
"Color LaserJet CP4525xh":[1,[59]],
"Color LaserJet CP5220":[1,[59]],
"Color LaserJet CP5221":[1,[59]],
"Color LaserJet CP5221dn":[1,[59]],
"Color LaserJet CP5221n":[1,[59]],
"Color LaserJet CP5223":[1,[59]],
"Color LaserJet CP5223dn":[1,[59]],
"Color LaserJet CP5223n":[1,[59]],
"Color LaserJet CP5225":[1,[59]],
"Color LaserJet CP5225dn":[1,[59]],
"Color LaserJet CP5225n":[1,[59]],
"Color LaserJet CP5227":[1,[59]],
"Color LaserJet CP5227dn":[1,[59]],
"Color LaserJet CP5227n":[1,[59]],
"Color LaserJet CP5229":[1,[59]],
"Color LaserJet CP5229dn":[1,[59]],
"Color LaserJet CP5229n":[1,[59]],
"Color LaserJet CP5520":[1,[59]],
"Color LaserJet CP5525dn":[1,[59]],
"Color LaserJet CP5525n":[1,[59]],
"Color LaserJet CP5525xh":[1,[59]],
"Color LaserJet CP6015":[1,[59]],
"Color LaserJet CP6015de":[1,[59]],
"Color LaserJet CP6015dn":[1,[59]],
"Color LaserJet CP6015n":[1,[59]],
"Color LaserJet CP6015x":[1,[59]],
"Color LaserJet CP6015xh":[1,[59]],
"Color LaserJet Enterprise X55745":[1,[56]],
"Color LaserJet Enterprise X55745dn":[1,[56]],
"Color LaserJet Enterprise X55745z":[1,[56]],
"Color LaserJet Enterprise X57945":[1,[56]],
"Color LaserJet Managed E87740":[1,[59]],
"Color LaserJet Managed E87740dn":[1,[59]],
"Color LaserJet Managed E87740z":[1,[59]],
"Color LaserJet Managed E87750":[1,[59]],
"Color LaserJet Managed E87750dn":[1,[59]],
"Color LaserJet Managed E87750z":[1,[59]],
"Color LaserJet Managed E87760":[1,[59]],
"Color LaserJet Managed E87760dn":[1,[59]],
"Color LaserJet Managed E87760z":[1,[59]],
"Color LaserJet Managed E87770":[1,[59]],
"Color LaserJet Managed E87770dn":[1,[59]],
"Color LaserJet Managed E87770z":[1,[59]],
"Color LaserJet Managed MFP E52545c":[1,[59]],
"Color LaserJet Managed MFP E78323":[1,[59]],
"Color LaserJet Managed MFP E78325":[1,[59]],
"Color LaserJet Managed MFP E78325dn":[1,[59]],
"Color LaserJet Managed MFP E78325z":[1,[59]],
"Color LaserJet Managed MFP E78330":[1,[59]],
"Color LaserJet Managed MFP E78330dn":[1,[59]],
"Color LaserJet Managed MFP E78330z":[1,[59]],
"Color LaserJet Managed MFP E78625dn":[1,[59]],
"Color LaserJet Managed MFP E78625z":[1,[59]],
"Color LaserJet Managed MFP E78630dn":[1,[59]],
"Color LaserJet Managed MFP E78635dn":[1,[59]],
"Color LaserJet Managed MFP E82540dn":[1,[59]],
"Color LaserJet Managed MFP E82540z":[1,[59]],
"Color LaserJet Managed MFP E82550dn":[1,[59]],
"Color LaserJet Managed MFP E82550z":[1,[59]],
"Color LaserJet Managed MFP E82560dn":[1,[59]],
"Color LaserJet Managed MFP E82560z":[1,[59]],
"Color LaserJet Managed MFP E87640":[1,[59]],
"Color LaserJet Managed MFP E87640dn":[1,[59]],
"Color LaserJet Managed MFP E87640z":[1,[59]],
"Color LaserJet Managed MFP E87650":[1,[59]],
"Color LaserJet Managed MFP E87650dn":[1,[59]],
"Color LaserJet Managed MFP E87650z":[1,[59]],
"Color LaserJet Managed MFP E87660":[1,[59]],
"Color LaserJet Managed MFP E87660dn":[1,[59]],
"Color LaserJet Managed MFP E87660z":[1,[59]],
"DesignJet 1000":[0,[60]],
"DesignJet 712":[0,[60]],
"DesignJet 712B":[0,[60]],
"DesignJet T100":[0,[60]],
"DesignJet T1120":[0,[60]],
"DesignJet T1530":[0,[60]],
"DesignJet T210":[0,[60]],
"DesignJet T2530":[0,[60]],
"DesignJet T610":[0,[60]],
"DesignJet T630":[0,[60]],
"DesignJet XL 3600":[0,[60]],
"Designjet 1050c":[0,[60]],
"Designjet 10ps":[0,[60]],
"Designjet 111":[0,[60]],
"Designjet 120":[0,[60]],
"Designjet 20ps":[0,[60]],
"Designjet 4000":[0,[60]],
"Designjet 4020":[0,[60]],
"Designjet 4500":[0,[60]],
"Designjet 4520":[0,[60]],
"Designjet 500":[0,[60]],
"Designjet 50ps":[0,[60]],
"Designjet 510":[0,[60]],
"Designjet 800":[0,[60]],
"Designjet 815mfp":[0,[60]],
"Designjet 820mfp":[0,[60]],
"Designjet T1100":[0,[60]],
"Designjet T1120":[0,[60]],
"Designjet T120":[0,[60]],
"Designjet T1200":[0,[60]],
"Designjet T125":[0,[60]],
"Designjet T130":[0,[60]],
"Designjet T1300":[0,[60]],
"Designjet T1500":[0,[60]],
"Designjet T230":[0,[60]],
"Designjet T2300":[0,[60]],
"Designjet T250":[0,[60]],
"Designjet T2500":[0,[60]],
"Designjet T3500":[0,[60]],
"Designjet T520":[0,[60]],
"Designjet T525":[0,[60]],
"Designjet T530":[0,[60]],
"Designjet T620":[0,[60]],
"Designjet T650":[0,[60]],
"Designjet T730":[0,[60]],
"Designjet T770":[0,[60]],
"Designjet T790":[0,[60]],
"Designjet T795":[0,[60]],
"Designjet T920":[0,[60]],
"Designjet T930":[0,[60]],
"Designjet Z2100":[0,[60]],
"Designjet Z3100":[0,[60]],
"Designjet Z3200":[0,[60]],
"Designjet Z5200":[0,[60]],
"Designjet Z5400":[0,[60]],
"Designjet Z6100":[0,[60]],
"Designjet Z6200":[0,[60]],
"Designjet Z6600":[0,[60]],
"Designjet Z6610":[0,[60]],
"Designjet Z6800":[0,[60]],
"Designjet Z6810":[0,[60]],
"DeskJet 1000cse":[0,[61]],
"DeskJet 1100c":[0,[61]],
"DeskJet 2300":[0,[61]],
"DeskJet 2700":[0,[61]],
"DeskJet 2720":[0,[61]],
"DeskJet 2720e":[0,[61]],
"DeskJet 2721":[0,[61]],
"DeskJet 2721e":[0,[61]],
"DeskJet 2722":[0,[61]],
"DeskJet 2722e":[0,[61]],
"DeskJet 2723":[0,[61]],
"DeskJet 2723e":[0,[61]],
"DeskJet 2820":[0,[61]],
"DeskJet 2820e":[0,[61]],
"DeskJet 2823":[0,[61]],
"DeskJet 2823e":[0,[61]],
"DeskJet 3420v":[0,[61]],
"DeskJet 3520v":[0,[61]],
"DeskJet 3520w":[0,[61]],
"DeskJet 3918":[0,[61]],
"DeskJet 3938":[0,[61]],
"DeskJet 4120e":[0,[61]],
"DeskJet 4121e":[0,[61]],
"DeskJet 4122e":[0,[61]],
"DeskJet 4123e":[0,[61]],
"DeskJet 460wbt":[0,[61]],
"DeskJet 5100":[0,[61]],
"DeskJet 5420v":[0,[61]],
"DeskJet 5438":[0,[61]],
"DeskJet 5440xi":[0,[61]],
"DeskJet 5443":[0,[61]],
"DeskJet 5500":[0,[61]],
"DeskJet 5600":[0,[61]],
"DeskJet 5650v":[0,[61]],
"DeskJet 5650w":[0,[61]],
"DeskJet 5655":[0,[61]],
"DeskJet 5748":[0,[61]],
"DeskJet 5800":[0,[61]],
"DeskJet 6548":[0,[61]],
"DeskJet 6620":[0,[61]],
"DeskJet 6620xi":[0,[61]],
"DeskJet 6623":[0,[61]],
"DeskJet 6800":[0,[61]],
"DeskJet 6840dt":[0,[61]],
"DeskJet 6840xi":[0,[61]],
"DeskJet 6843":[0,[61]],
"DeskJet 6848":[0,[61]],
"DeskJet 6940dt":[0,[61]],
"DeskJet 6980":[0,[61]],
"DeskJet 6980dt":[0,[61]],
"DeskJet 820cse":[0,[61]],
"DeskJet 825cxi":[0,[61]],
"DeskJet 855c":[0,[61]],
"DeskJet 855cse":[0,[61]],
"DeskJet 855cxi":[0,[61]],
"DeskJet 870cse":[0,[61]],
"DeskJet 920cxi":[0,[61]],
"DeskJet 932c":[0,[61]],
"DeskJet 933c":[0,[61]],
"DeskJet 934c":[0,[61]],
"DeskJet 935c":[0,[61]],
"DeskJet 957c":[0,[61]],
"DeskJet 9800d":[0,[61]],
"DeskJet 995c":[0,[61]],
"DeskJet 995ck":[0,[61]],
"DeskJet D1400":[0,[61]],
"DeskJet D1663":[0,[61]],
"DeskJet D1668":[0,[61]],
"DeskJet D2400":[0,[61]],
"DeskJet D2563":[0,[61]],
"DeskJet D2566":[0,[61]],
"DeskJet D2568":[0,[61]],
"DeskJet D4200":[0,[61]],
"DeskJet D4245":[0,[61]],
"DeskJet D4268":[0,[61]],
"DeskJet D5563":[0,[61]],
"DeskJet F2100":[0,[61]],
"DeskJet F2238":[0,[61]],
"DeskJet F2276":[0,[61]],
"DeskJet F4100":[0,[61]],
"DeskJet F4224":[0,[61]],
"Deskjet 1000":[0,[61]],
"Deskjet 1000cxi":[0,[61]],
"Deskjet 1010":[0,[61]],
"Deskjet 1050":[0,[61]],
"Deskjet 1110":[0,[61]],
"Deskjet 1112":[0,[61]],
"Deskjet 1120c":[0,[61]],
"Deskjet 1120cse":[0,[61]],
"Deskjet 1120cxi":[0,[61]],
"Deskjet 1125c":[0,[61]],
"Deskjet 1180c":[0,[61]],
"Deskjet 1220c":[0,[61]],
"Deskjet 1220cse":[0,[61]],
"Deskjet 1220cxi":[0,[61]],
"Deskjet 1280":[0,[61]],
"Deskjet 1500":[0,[61]],
"Deskjet 1510":[0,[61]],
"Deskjet 2000":[0,[61]],
"Deskjet 2050":[0,[61]],
"Deskjet 2130":[0,[61]],
"Deskjet 2131":[0,[61]],
"Deskjet 2132":[0,[61]],
"Deskjet 2330":[0,[61]],
"Deskjet 2332":[0,[61]],
"Deskjet 2510":[0,[61]],
"Deskjet 2540":[0,[61]],
"Deskjet 2620":[0,[61]],
"Deskjet 2621":[0,[61]],
"Deskjet 2623":[0,[61]],
"Deskjet 2624":[0,[61]],
"Deskjet 2655":[0,[61]],
"Deskjet 3000":[0,[61]],
"Deskjet 3050":[0,[61]],
"Deskjet 3070A":[0,[61]],
"Deskjet 3320":[0,[61]],
"Deskjet 3325":[0,[61]],
"Deskjet 3420":[0,[61]],
"Deskjet 3425":[0,[61]],
"Deskjet 3520 EAllinOne":[0,[61]],
"Deskjet 3535":[0,[61]],
"Deskjet 3550":[0,[61]],
"Deskjet 3550v":[0,[61]],
"Deskjet 3550w":[0,[61]],
"Deskjet 3558":[0,[61]],
"Deskjet 3620":[0,[61]],
"Deskjet 3630":[0,[61]],
"Deskjet 3632":[0,[61]],
"Deskjet 3650":[0,[61]],
"Deskjet 3650v":[0,[61]],
"Deskjet 3653":[0,[61]],
"Deskjet 3658":[0,[61]],
"Deskjet 3720":[0,[61]],
"Deskjet 3721":[0,[61]],
"Deskjet 3723":[0,[61]],
"Deskjet 3724":[0,[61]],
"Deskjet 3740":[0,[61]],
"Deskjet 3744":[0,[61]],
"Deskjet 3745":[0,[61]],
"Deskjet 3810":[0,[61]],
"Deskjet 3816":[0,[61]],
"Deskjet 3820":[0,[61]],
"Deskjet 3820c":[0,[61]],
"Deskjet 3820v":[0,[61]],
"Deskjet 3820w":[0,[61]],
"Deskjet 3822":[0,[61]],
"Deskjet 3843":[0,[61]],
"Deskjet 3845":[0,[61]],
"Deskjet 3845xi":[0,[61]],
"Deskjet 3847":[0,[61]],
"Deskjet 3848":[0,[61]],
"Deskjet 3910":[0,[61]],
"Deskjet 3920":[0,[61]],
"Deskjet 3930":[0,[61]],
"Deskjet 3930v":[0,[61]],
"Deskjet 3940v":[0,[61]],
"Deskjet 4100e":[0,[61]],
"Deskjet 450":[0,[61]],
"Deskjet 450cbi":[0,[61]],
"Deskjet 450ci":[0,[61]],
"Deskjet 450wbt":[0,[61]],
"Deskjet 460":[0,[61]],
"Deskjet 460cb":[0,[61]],
"Deskjet 460wf":[0,[61]],
"Deskjet 5075":[0,[61]],
"Deskjet 5160":[0,[61]],
"Deskjet 5440":[0,[61]],
"Deskjet 5442":[0,[61]],
"Deskjet 5550":[0,[61]],
"Deskjet 5650":[0,[61]],
"Deskjet 5652":[0,[61]],
"Deskjet 5740":[0,[61]],
"Deskjet 5740xi":[0,[61]],
"Deskjet 5743":[0,[61]],
"Deskjet 5745":[0,[61]],
"Deskjet 5850":[0,[61]],
"Deskjet 5940":[0,[61]],
"Deskjet 5940xi":[0,[61]],
"Deskjet 5943":[0,[61]],
"Deskjet 6122":[0,[61]],
"Deskjet 6127":[0,[61]],
"Deskjet 6520":[0,[61]],
"Deskjet 6540":[0,[61]],
"Deskjet 6540d":[0,[61]],
"Deskjet 6540dt":[0,[61]],
"Deskjet 6540xi":[0,[61]],
"Deskjet 6830":[0,[61]],
"Deskjet 6840":[0,[61]],
"Deskjet 6940":[0,[61]],
"Deskjet 710c":[0,[61]],
"Deskjet 712c":[0,[61]],
"Deskjet 720c":[0,[61]],
"Deskjet 722c":[0,[61]],
"Deskjet 810c":[0,[61]],
"Deskjet 812c":[0,[61]],
"Deskjet 815c":[0,[61]],
"Deskjet 816":[0,[61]],
"Deskjet 820cxi":[0,[61]],
"Deskjet 825c":[0,[61]],
"Deskjet 825cse":[0,[61]],
"Deskjet 825cvr":[0,[61]],
"Deskjet 827":[0,[61]],
"Deskjet 830c":[0,[61]],
"Deskjet 840c":[0,[61]],
"Deskjet 841c":[0,[61]],
"Deskjet 842c":[0,[61]],
"Deskjet 843c":[0,[61]],
"Deskjet 845c":[0,[61]],
"Deskjet 845cse":[0,[61]],
"Deskjet 845cvr":[0,[61]],
"Deskjet 845cxi":[0,[61]],
"Deskjet 848c":[0,[61]],
"Deskjet 850c":[0,[61]],
"Deskjet 870cxi":[0,[61]],
"Deskjet 880c":[0,[61]],
"Deskjet 882c":[0,[61]],
"Deskjet 890c":[0,[61]],
"Deskjet 890cm":[0,[61]],
"Deskjet 890cse":[0,[61]],
"Deskjet 890cxi":[0,[61]],
"Deskjet 895cse":[0,[61]],
"Deskjet 895cxi":[0,[61]],
"Deskjet 916c":[0,[61]],
"Deskjet 920c":[0,[61]],
"Deskjet 920cvr":[0,[61]],
"Deskjet 920cw":[0,[61]],
"Deskjet 922c":[0,[61]],
"Deskjet 9300":[0,[61]],
"Deskjet 930c":[0,[61]],
"Deskjet 930cm":[0,[61]],
"Deskjet 940c":[0,[61]],
"Deskjet 940cvr":[0,[61]],
"Deskjet 940cw":[0,[61]],
"Deskjet 940cxi":[0,[61]],
"Deskjet 948c":[0,[61]],
"Deskjet 950c":[0,[61]],
"Deskjet 952c":[0,[61]],
"Deskjet 955c":[0,[61]],
"Deskjet 959c":[0,[61]],
"Deskjet 9600":[0,[61]],
"Deskjet 960cse":[0,[61]],
"Deskjet 960cxi":[0,[61]],
"Deskjet 9650":[0,[61]],
"Deskjet 9680":[0,[61]],
"Deskjet 970c":[0,[61]],
"Deskjet 970cse":[0,[61]],
"Deskjet 970cxi":[0,[61]],
"Deskjet 9800":[0,[61]],
"Deskjet 9803":[0,[61]],
"Deskjet 9803d":[0,[61]],
"Deskjet 9808":[0,[61]],
"Deskjet 9808d":[0,[61]],
"Deskjet 980c":[0,[61]],
"Deskjet 980cxi":[0,[61]],
"Deskjet 9868":[0,[61]],
"Deskjet 990c":[0,[61]],
"Deskjet 990cm":[0,[61]],
"Deskjet 990cse":[0,[61]],
"Deskjet 990cxi":[0,[61]],
"Deskjet D1360":[0,[61]],
"Deskjet D1460":[0,[61]],
"Deskjet D1470":[0,[61]],
"Deskjet D1558":[0,[61]],
"Deskjet D1560":[0,[61]],
"Deskjet D1660":[0,[61]],
"Deskjet D2360":[0,[61]],
"Deskjet D2460":[0,[61]],
"Deskjet D2560":[0,[61]],
"Deskjet D2660":[0,[61]],
"Deskjet D4160":[0,[61]],
"Deskjet D4260":[0,[61]],
"Deskjet D4360":[0,[61]],
"Deskjet D5560":[0,[61]],
"Deskjet F2110":[0,[61]],
"Deskjet F2120":[0,[61]],
"Deskjet F2179":[0,[61]],
"Deskjet F2180":[0,[61]],
"Deskjet F2224":[0,[61]],
"Deskjet F2235":[0,[61]],
"Deskjet F2275":[0,[61]],
"Deskjet F2280":[0,[61]],
"Deskjet F2288":[0,[61]],
"Deskjet F2400":[0,[61]],
"Deskjet F2410":[0,[61]],
"Deskjet F2480":[0,[61]],
"Deskjet F2483":[0,[61]],
"Deskjet F340":[0,[61]],
"Deskjet F350":[0,[61]],
"Deskjet F370":[0,[61]],
"Deskjet F380":[0,[61]],
"Deskjet F4185":[0,[61]],
"Deskjet F4200":[0,[61]],
"Deskjet F4230":[0,[61]],
"Deskjet F4250":[0,[61]],
"Deskjet F4280":[0,[61]],
"Deskjet F4400":[0,[61]],
"Deskjet F4470":[0,[61]],
"Deskjet F4472":[0,[61]],
"Deskjet F4473":[0,[61]],
"Deskjet F4480":[0,[61]],
"Deskjet F4492":[0,[61]],
"ENVY 6030e":[0,[62]],
"ENVY 6034e":[0,[62]],
"ENVY Inspire 7220e":[0,[62]],
"ENVY Inspire 7221e":[0,[62]],
"ENVY Inspire 7920e":[0,[62]],
"ENVY Inspire 7921e":[0,[62]],
"Envy 100":[0,[62]],
"Envy 110":[0,[62]],
"Envy 120":[0,[62]],
"Envy 4500":[0,[62]],
"Envy 4504":[0,[62]],
"Envy 4510":[0,[62]],
"Envy 4520":[0,[62]],
"Envy 4522":[0,[62]],
"Envy 4523":[0,[62]],
"Envy 4524":[0,[62]],
"Envy 5020":[0,[62]],
"Envy 5030":[0,[62]],
"Envy 5032":[0,[62]],
"Envy 5034":[0,[62]],
"Envy 5052":[0,[62]],
"Envy 5055":[0,[62]],
"Envy 5058":[0,[62]],
"Envy 5075":[0,[62]],
"Envy 5424":[0,[62]],
"Envy 5530":[0,[62]],
"Envy 5540":[0,[62]],
"Envy 5542":[0,[62]],
"Envy 5640":[0,[62]],
"Envy 5642":[0,[62]],
"Envy 6020":[0,[62]],
"Envy 6020e":[0,[62]],
"Envy 6030":[0,[62]],
"Envy 6032":[0,[62]],
"Envy 6032e":[0,[62]],
"Envy 6034":[0,[62]],
"Envy 6100":[0,[62]],
"Envy 6120e":[0,[62]],
"Envy 6130e":[0,[62]],
"Envy 6131e":[0,[62]],
"Envy 6134e":[0,[62]],
"Envy 6220":[0,[62]],
"Envy 6420e":[0,[62]],
"Envy 6430e":[0,[62]],
"Envy 6500":[0,[62]],
"Envy 6530e":[0,[62]],
"Envy 6531e":[0,[62]],
"Envy 7640":[0,[62]],
"Envy 7643":[0,[62]],
"Envy Photo 6220":[0,[62]],
"Envy Photo 6222":[0,[62]],
"Envy Photo 7120":[0,[62]],
"Envy Photo 7820":[0,[62]],
"Envy Photo 7822":[0,[62]],
"Envy Pro 6420":[0,[62]],
"Envy Pro 6430":[0,[62]],
"Envy Pro 6520e":[0,[62]],
"Fax 1240":[0,[63]],
"Fax 1250":[0,[63]],
"HP Color LaserJet CM6030 MFP":[1,[59]],
"HP Color LaserJet CM6030f MFP":[1,[59]],
"HP Color LaserJet CM6040 MFP":[1,[59]],
"HP Color LaserJet CM6040f MFP":[1,[59]],
"HP Color LaserJet CP6015":[1,[59]],
"HP Color LaserJet CP6015de":[1,[59]],
"HP Color LaserJet CP6015dn":[1,[59]],
"HP Color LaserJet CP6015n":[1,[59]],
"HP Color LaserJet CP6015x":[1,[59]],
"HP Color LaserJet CP6015xh":[1,[59]],
"HP LaserJet Enterprise M605dn":[1,[67]],
"HP LaserJet Enterprise M605n":[1,[67]],
"HP LaserJet Enterprise M605x":[1,[67]],
"HP LaserJet Enterprise M606":[1,[67]],
"HP LaserJet Enterprise M606dn":[1,[67]],
"HP LaserJet Enterprise M630":[1,[67]],
"HP LaserJet Enterprise M630dn":[1,[67]],
"HP LaserJet Enterprise M630f":[1,[67]],
"HP LaserJet Enterprise M630h":[1,[67]],
"HP LaserJet Enterprise M630z":[1,[67]],
"HP PageWide Managed P55250dw":[0,[77]],
"HP PageWide Managed P57750dw":[0,[77]],
"HP PageWide Pro 552dw":[0,[78]],
"HP PageWide Pro 577dw / 577z":[0,[78]],
"HPColorLaserJetPro3201dw":[1,[]],
"HPColorLaserJetProMFP3301cdw":[1,[]],
"HPColorLaserJetProMFP3301fdw":[1,[]],
"HPColorLaserJetProMFP3301sdw":[1,[]],
"HPLaserJetM110":[1,[]],
"HPLaserJetM110a":[1,[]],
"HPLaserJetM110w":[1,[]],
"HPLaserJetM111a":[1,[]],
"HPLaserJetM111w":[1,[]],
"HPLaserJetM209":[1,[]],
"HPLaserJetM209d":[1,[]],
"HPLaserJetM209dw":[1,[]],
"HPLaserJetMFPM139":[1,[]],
"HPLaserJetMFPM139a":[1,[]],
"HPLaserJetMFPM139w":[1,[]],
"HPLaserJetMFPM140":[1,[]],
"HPLaserJetMFPM140a":[1,[]],
"HPLaserJetMFPM140w":[1,[]],
"HPLaserJetMFPM141a":[1,[]],
"HPLaserJetMFPM141w":[1,[]],
"HPLaserJetMFPM142w":[1,[]],
"HPLaserJetMFPM234":[1,[]],
"HPLaserJetMFPM234d":[1,[]],
"HPLaserJetMFPM234dw":[1,[]],
"HPLaserJetMFPM234sdn":[1,[]],
"HPLaserJetMFPM234sdw":[1,[]],
"HPiJetColor 1175":[0,[]],
"HPiJetColor 1175C":[0,[]],
"HPiJetColor 1175Pro":[0,[]],
"Laser MFP 178":[1,[65]],
"Laser MFP 178nw":[1,[65]],
"Laser MFP 179":[1,[65]],
"Laser MFP 179fnw":[1,[65]],
"LaserJet 1000":[1,[69]],
"LaserJet 1005":[1,[69]],
"LaserJet 1010":[1,[69]],
"LaserJet 1012":[1,[69]],
"LaserJet 1015":[1,[69]],
"LaserJet 1018":[1,[69]],
"LaserJet 1020":[1,[69]],
"LaserJet 1022":[1,[69]],
"LaserJet 1022n":[1,[69]],
"LaserJet 1022nw":[1,[69]],
"LaserJet 1100":[0,[69]],
"LaserJet 1100Ase":[0,[69]],
"LaserJet 1100Axi":[0,[69]],
"LaserJet 1100a":[0,[69]],
"LaserJet 1100se":[0,[69]],
"LaserJet 1100xi":[0,[69]],
"LaserJet 1150":[1,[69]],
"LaserJet 1160":[1,[69]],
"LaserJet 1160Le":[1,[69]],
"LaserJet 1200":[1,[69]],
"LaserJet 1200n":[1,[69]],
"LaserJet 1200se":[1,[69]],
"LaserJet 1220":[1,[69]],
"LaserJet 1220se":[1,[69]],
"LaserJet 1300":[1,[69]],
"LaserJet 1300N":[1,[69]],
"LaserJet 1300xi":[1,[69]],
"LaserJet 1320":[1,[69]],
"LaserJet 1320n":[1,[69]],
"LaserJet 1320nw":[1,[69]],
"LaserJet 1320t":[1,[69]],
"LaserJet 1320tn":[1,[69]],
"LaserJet 1600":[1,[69]],
"LaserJet 2100":[1,[69]],
"LaserJet 2100m":[1,[69]],
"LaserJet 2100se":[1,[69]],
"LaserJet 2100tn":[1,[69]],
"LaserJet 2100xi":[1,[69]],
"LaserJet 2200":[1,[69]],
"LaserJet 2200d":[1,[69]],
"LaserJet 2200dn":[1,[69]],
"LaserJet 2200dse":[1,[69]],
"LaserJet 2200dt":[1,[69]],
"LaserJet 2200dtn":[1,[69]],
"LaserJet 2300":[1,[69]],
"LaserJet 2300L":[1,[69]],
"LaserJet 2300d":[1,[69]],
"LaserJet 2300dn":[1,[69]],
"LaserJet 2300dtn":[1,[69]],
"LaserJet 2300n":[1,[69]],
"LaserJet 2410":[1,[69]],
"LaserJet 2420":[1,[69]],
"LaserJet 2420d":[1,[69]],
"LaserJet 2420dn":[1,[69]],
"LaserJet 2420n":[1,[69]],
"LaserJet 2430":[1,[69]],
"LaserJet 2430dtn":[1,[69]],
"LaserJet 2430n":[1,[69]],
"LaserJet 2430t":[1,[69]],
"LaserJet 2430tn":[1,[69]],
"LaserJet 3015":[1,[69]],
"LaserJet 3020":[1,[69]],
"LaserJet 3030":[1,[69]],
"LaserJet 3050":[1,[69]],
"LaserJet 3050z":[1,[69]],
"LaserJet 3052":[1,[69]],
"LaserJet 3055":[1,[69]],
"LaserJet 3100":[1,[69]],
"LaserJet 3100se":[1,[69]],
"LaserJet 3100xi":[1,[69]],
"LaserJet 3150":[1,[69]],
"LaserJet 3150se":[1,[69]],
"LaserJet 3150xi":[1,[69]],
"LaserJet 3200":[0,[69]],
"LaserJet 3200Se":[0,[69]],
"LaserJet 3200m":[0,[69]],
"LaserJet 3200rf":[0,[69]],
"LaserJet 3300":[1,[69]],
"LaserJet 3310":[1,[69]],
"LaserJet 3320":[1,[69]],
"LaserJet 3320n":[1,[69]],
"LaserJet 3330":[1,[69]],
"LaserJet 3380":[1,[69]],
"LaserJet 3390":[1,[69]],
"LaserJet 3392":[1,[69]],
"LaserJet 4":[1,[69]],
"LaserJet 4000":[1,[69]],
"LaserJet 4000n":[1,[69]],
"LaserJet 4000se":[1,[69]],
"LaserJet 4000t":[1,[69]],
"LaserJet 4000tn":[1,[69]],
"LaserJet 4050":[1,[69]],
"LaserJet 4050n":[1,[69]],
"LaserJet 4050se":[1,[69]],
"LaserJet 4050t":[1,[69]],
"LaserJet 4050tn":[1,[69]],
"LaserJet 4100":[1,[69]],
"LaserJet 4100dtn":[1,[69]],
"LaserJet 4100n":[1,[69]],
"LaserJet 4100tn":[1,[69]],
"LaserJet 4101":[1,[69]],
"LaserJet 4200":[1,[69]],
"LaserJet 4200DTN":[1,[69]],
"LaserJet 4200DTNS":[1,[69]],
"LaserJet 4200DTNSL":[1,[69]],
"LaserJet 4200L":[1,[69]],
"LaserJet 4200Ln":[1,[69]],
"LaserJet 4200Lvn":[1,[69]],
"LaserJet 4200N":[1,[69]],
"LaserJet 4200TN":[1,[69]],
"LaserJet 4201dn":[1,[69]],
"LaserJet 4201dw":[1,[69]],
"LaserJet 4240":[1,[69]],
"LaserJet 4240n":[1,[69]],
"LaserJet 4250":[1,[69]],
"LaserJet 4250dtn":[1,[69]],
"LaserJet 4250dtnsl":[1,[69]],
"LaserJet 4250n":[1,[69]],
"LaserJet 4250tn":[1,[69]],
"LaserJet 4300":[1,[69]],
"LaserJet 4300DTN":[1,[69]],
"LaserJet 4300DTNS":[1,[69]],
"LaserJet 4300DTNSL":[1,[69]],
"LaserJet 4300N":[1,[69]],
"LaserJet 4300TN":[1,[69]],
"LaserJet 4350":[1,[69]],
"LaserJet 4350dtn":[1,[69]],
"LaserJet 4350dtnsl":[1,[69]],
"LaserJet 4350n":[1,[69]],
"LaserJet 4350tn":[1,[69]],
"LaserJet 4500":[1,[69]],
"LaserJet 4700":[1,[69]],
"LaserJet 4700dn":[1,[69]],
"LaserJet 4700n":[1,[69]],
"LaserJet 4L":[1,[69]],
"LaserJet 4M":[1,[69]],
"LaserJet 4PJ":[1,[69]],
"LaserJet 4Plus":[1,[69]],
"LaserJet 4mL":[1,[69]],
"LaserJet 4mp":[1,[69]],
"LaserJet 4mv":[1,[69]],
"LaserJet 4p":[1,[69]],
"LaserJet 4si":[0,[69]],
"LaserJet 4v":[1,[69]],
"LaserJet 5":[1,[69]],
"LaserJet 5000":[1,[69]],
"LaserJet 5000dn":[1,[69]],
"LaserJet 5000gn":[1,[69]],
"LaserJet 5000n":[1,[69]],
"LaserJet 5100":[1,[69]],
"LaserJet 5100DTN":[1,[69]],
"LaserJet 5100LE":[1,[69]],
"LaserJet 5100SE":[1,[69]],
"LaserJet 5100TN":[1,[69]],
"LaserJet 5200":[1,[69]],
"LaserJet 5200DTN":[1,[69]],
"LaserJet 5200L":[1,[69]],
"LaserJet 5200n":[1,[69]],
"LaserJet 5200tn":[1,[69]],
"LaserJet 5L":[1,[69]],
"LaserJet 5N":[1,[69]],
"LaserJet 5m":[1,[69]],
"LaserJet 5mp":[1,[69]],
"LaserJet 5p":[1,[69]],
"LaserJet 5se":[1,[69]],
"LaserJet 5si":[1,[69]],
"LaserJet 6":[1,[69]],
"LaserJet 6L":[1,[69]],
"LaserJet 6Pxi":[1,[69]],
"LaserJet 6p":[1,[69]],
"LaserJet 8000":[1,[69]],
"LaserJet 8000dn":[1,[69]],
"LaserJet 8000n":[1,[69]],
"LaserJet 8100":[1,[69]],
"LaserJet 8100dn":[1,[69]],
"LaserJet 8100n":[1,[69]],
"LaserJet 8150":[1,[69]],
"LaserJet 8150dn":[1,[69]],
"LaserJet 8150hn":[1,[69]],
"LaserJet 8150n":[1,[69]],
"LaserJet 9000":[1,[69]],
"LaserJet 9000L":[1,[69]],
"LaserJet 9000dn":[1,[69]],
"LaserJet 9000hnf":[1,[69]],
"LaserJet 9000hns":[1,[69]],
"LaserJet 9000n":[1,[69]],
"LaserJet 9040":[1,[69]],
"LaserJet 9040dn":[1,[69]],
"LaserJet 9040n":[1,[69]],
"LaserJet 9050":[1,[69]],
"LaserJet 9050dn":[1,[69]],
"LaserJet 9050n":[1,[69]],
"LaserJet Enterprise 500 Color M521dn":[1,[67]],
"LaserJet Enterprise 500 Color M521dw":[1,[67]],
"LaserJet Enterprise 500 Color M551dn":[1,[67]],
"LaserJet Enterprise 500 Color M551n":[1,[67]],
"LaserJet Enterprise 500 Color M551xh":[1,[67]],
"LaserJet Enterprise 500 Color MFP M525c":[1,[67]],
"LaserJet Enterprise 500 Color MFP M525dn":[1,[67]],
"LaserJet Enterprise 500 Color MFP M525f":[1,[67]],
"LaserJet Enterprise 500 Color MFP M570dw":[1,[67]],
"LaserJet Enterprise 500 Color MFP M575c":[1,[67]],
"LaserJet Enterprise 500 Color MFP M575dn":[1,[67]],
"LaserJet Enterprise 500 Color MFP M575f":[1,[67]],
"LaserJet Enterprise 500 M551DN":[1,[67]],
"LaserJet Enterprise 5700dn":[1,[67]],
"LaserJet Enterprise 5800dn":[1,[67]],
"LaserJet Enterprise 5800zf":[1,[67]],
"LaserJet Enterprise 600 Color M651dn":[1,[67]],
"LaserJet Enterprise 600 M601dn":[1,[67]],
"LaserJet Enterprise 600 M601n":[1,[67]],
"LaserJet Enterprise 600 M602dn":[1,[67]],
"LaserJet Enterprise 600 M602n":[1,[67]],
"LaserJet Enterprise 600 M602x":[1,[67]],
"LaserJet Enterprise 600 M603dn":[1,[67]],
"LaserJet Enterprise 600 M603n":[1,[67]],
"LaserJet Enterprise 600 M603xh":[1,[67]],
"LaserJet Enterprise 6700dn":[1,[67]],
"LaserJet Enterprise 6701dn":[1,[67]],
"LaserJet Enterprise 6800dn":[1,[67]],
"LaserJet Enterprise 6800zf":[1,[67]],
"LaserJet Enterprise 6800zfw":[1,[67]],
"LaserJet Enterprise 700 Color M712":[1,[67]],
"LaserJet Enterprise 700 Color M712dn":[1,[67]],
"LaserJet Enterprise 700 Color M712n":[1,[67]],
"LaserJet Enterprise 700 Color M712xh":[1,[67]],
"LaserJet Enterprise 700 Color MFP M725":[1,[67]],
"LaserJet Enterprise 700 Color MFP M725dn":[1,[67]],
"LaserJet Enterprise 700 Color MFP M725n":[1,[67]],
"LaserJet Enterprise 700 Color MFP M725xh":[1,[67]],
"LaserJet Enterprise 700 Color MFP M775":[1,[67]],
"LaserJet Enterprise 700 Color MFP M775dn":[1,[67]],
"LaserJet Enterprise 700 Color MFP M775f":[1,[67]],
"LaserJet Enterprise 700 Color MFP M775z":[1,[67]],
"LaserJet Enterprise 700 M712":[1,[67]],
"LaserJet Enterprise 700 M712dn":[1,[67]],
"LaserJet Enterprise 700 M712n":[1,[67]],
"LaserJet Enterprise 700 M712xh":[1,[67]],
"LaserJet Enterprise 700 MFP M725":[1,[67]],
"LaserJet Enterprise 700 MFP M725dn":[1,[67]],
"LaserJet Enterprise 700 MFP M725n":[1,[67]],
"LaserJet Enterprise 700 MFP M725xh":[1,[67]],
"LaserJet Enterprise Color Flow MFP M577c":[1,[67]],
"LaserJet Enterprise Color M451dn":[1,[67]],
"LaserJet Enterprise Color M451dw":[1,[67]],
"LaserJet Enterprise Color M451nw":[1,[67]],
"LaserJet Enterprise Color M651n":[1,[67]],
"LaserJet Enterprise Color M651xh":[1,[67]],
"LaserJet Enterprise Color MFP M775dn":[1,[67]],
"LaserJet Enterprise Color MFP M775f":[1,[67]],
"LaserJet Enterprise Color MFP M775z":[1,[67]],
"LaserJet Enterprise Flow MFP M528c":[1,[67]],
"LaserJet Enterprise M406":[1,[67]],
"LaserJet Enterprise M406dn":[1,[67]],
"LaserJet Enterprise M455dn":[1,[67]],
"LaserJet Enterprise M506dn":[1,[67]],
"LaserJet Enterprise M506x":[1,[67]],
"LaserJet Enterprise M507dn":[1,[67]],
"LaserJet Enterprise M507x":[1,[67]],
"LaserJet Enterprise M521dn":[1,[67]],
"LaserJet Enterprise M521dw":[1,[67]],
"LaserJet Enterprise M525":[1,[67]],
"LaserJet Enterprise M525c":[1,[67]],
"LaserJet Enterprise M525dn":[1,[67]],
"LaserJet Enterprise M525f":[1,[67]],
"LaserJet Enterprise M527c":[1,[67]],
"LaserJet Enterprise M527dn":[1,[67]],
"LaserJet Enterprise M527f":[1,[67]],
"LaserJet Enterprise M527z":[1,[67]],
"LaserJet Enterprise M551dn":[1,[67]],
"LaserJet Enterprise M552DN":[1,[67]],
"LaserJet Enterprise M552dn":[1,[67]],
"LaserJet Enterprise M553DN":[1,[67]],
"LaserJet Enterprise M553N":[1,[67]],
"LaserJet Enterprise M553X":[1,[67]],
"LaserJet Enterprise M553dn":[1,[67]],
"LaserJet Enterprise M553n":[1,[67]],
"LaserJet Enterprise M553x":[1,[67]],
"LaserJet Enterprise M554dn":[1,[67]],
"LaserJet Enterprise M555dn":[1,[67]],
"LaserJet Enterprise M555x":[1,[67]],
"LaserJet Enterprise M577Z":[1,[67]],
"LaserJet Enterprise M601dn":[1,[67]],
"LaserJet Enterprise M602dn":[1,[67]],
"LaserJet Enterprise M602n":[1,[67]],
"LaserJet Enterprise M602x":[1,[67]],
"LaserJet Enterprise M603dn":[1,[67]],
"LaserJet Enterprise M603n":[1,[67]],
"LaserJet Enterprise M603xh":[1,[67]],
"LaserJet Enterprise M604n":[1,[67]],
"LaserJet Enterprise M605dn":[1,[67]],
"LaserJet Enterprise M605n":[1,[67]],
"LaserJet Enterprise M605x":[1,[67]],
"LaserJet Enterprise M606dn":[1,[67]],
"LaserJet Enterprise M607dn":[1,[67]],
"LaserJet Enterprise M607n":[1,[67]],
"LaserJet Enterprise M608dn":[1,[67]],
"LaserJet Enterprise M608n":[1,[67]],
"LaserJet Enterprise M608x":[1,[67]],
"LaserJet Enterprise M609dn":[1,[67]],
"LaserJet Enterprise M609x":[1,[67]],
"LaserJet Enterprise M610dn":[1,[67]],
"LaserJet Enterprise M611dn":[1,[67]],
"LaserJet Enterprise M611x":[1,[67]],
"LaserJet Enterprise M612dn":[1,[67]],
"LaserJet Enterprise M612x":[1,[67]],
"LaserJet Enterprise M630dn":[1,[67]],
"LaserJet Enterprise M630f":[1,[67]],
"LaserJet Enterprise M630h":[1,[67]],
"LaserJet Enterprise M630z":[1,[67]],
"LaserJet Enterprise M631dn":[1,[67]],
"LaserJet Enterprise M631h":[1,[67]],
"LaserJet Enterprise M631z":[1,[67]],
"LaserJet Enterprise M632fht":[1,[67]],
"LaserJet Enterprise M632h":[1,[67]],
"LaserJet Enterprise M632z":[1,[67]],
"LaserJet Enterprise M633fh":[1,[67]],
"LaserJet Enterprise M633z":[1,[67]],
"LaserJet Enterprise M651dn":[1,[67]],
"LaserJet Enterprise M651n":[1,[67]],
"LaserJet Enterprise M651xh":[1,[67]],
"LaserJet Enterprise M652dn":[1,[67]],
"LaserJet Enterprise M653dn":[1,[67]],
"LaserJet Enterprise M653x":[1,[67]],
"LaserJet Enterprise M680dn":[1,[67]],
"LaserJet Enterprise M680f":[1,[67]],
"LaserJet Enterprise M680z":[1,[67]],
"LaserJet Enterprise M681dn":[1,[67]],
"LaserJet Enterprise M681f":[1,[67]],
"LaserJet Enterprise M681z":[1,[67]],
"LaserJet Enterprise M682z":[1,[67]],
"LaserJet Enterprise M712dn":[1,[67]],
"LaserJet Enterprise M712n":[1,[67]],
"LaserJet Enterprise M712xh":[1,[67]],
"LaserJet Enterprise M725dn":[1,[67]],
"LaserJet Enterprise M725n":[1,[67]],
"LaserJet Enterprise M725xh":[1,[67]],
"LaserJet Enterprise M750dn":[1,[67]],
"LaserJet Enterprise M750n":[1,[67]],
"LaserJet Enterprise M750xh":[1,[67]],
"LaserJet Enterprise M751dn":[1,[67]],
"LaserJet Enterprise M751n":[1,[67]],
"LaserJet Enterprise M856dn":[1,[67]],
"LaserJet Enterprise M856x":[1,[67]],
"LaserJet Enterprise M880z":[1,[67]],
"LaserJet Enterprise MFP 6800zfsw":[1,[66]],
"LaserJet Enterprise MFP 6800zfwf":[1,[66]],
"LaserJet Enterprise MFP M430f":[1,[66]],
"LaserJet Enterprise MFP M480f":[1,[66]],
"LaserJet Enterprise MFP M528dn":[1,[66]],
"LaserJet Enterprise MFP M528f":[1,[66]],
"LaserJet Enterprise MFP M528z":[1,[66]],
"LaserJet Enterprise MFP M577dn":[1,[66]],
"LaserJet Enterprise MFP M577f":[1,[66]],
"LaserJet Enterprise MFP M577z":[1,[66]],
"LaserJet Enterprise MFP M578dn":[1,[66]],
"LaserJet Enterprise MFP M578f":[1,[66]],
"LaserJet Enterprise MFP M578z":[1,[66]],
"LaserJet Enterprise MFP M634dn":[1,[66]],
"LaserJet Enterprise MFP M634h":[1,[66]],
"LaserJet Enterprise MFP M634z":[1,[66]],
"LaserJet Enterprise MFP M635fht":[1,[66]],
"LaserJet Enterprise MFP M635h":[1,[66]],
"LaserJet Enterprise MFP M635z":[1,[66]],
"LaserJet Enterprise MFP M636fh":[1,[66]],
"LaserJet Enterprise MFP M636z":[1,[66]],
"LaserJet Enterprise MFP M776dn":[1,[66]],
"LaserJet Enterprise MFP M776z":[1,[66]],
"LaserJet Enterprise MFP M776zs":[1,[66]],
"LaserJet II":[1,[69]],
"LaserJet III":[1,[69]],
"LaserJet IIId":[1,[69]],
"LaserJet IIIp":[1,[69]],
"LaserJet IIIsi":[0,[69]],
"LaserJet IId":[1,[69]],
"LaserJet IIp":[1,[69]],
"LaserJet M1005":[1,[69]],
"LaserJet M110w":[1,[69]],
"LaserJet M110we":[1,[69]],
"LaserJet M1132":[1,[69]],
"LaserJet M12a":[1,[69]],
"LaserJet M12w":[1,[69]],
"LaserJet M1300":[1,[69]],
"LaserJet M1319f":[1,[69]],
"LaserJet M1536dnf":[1,[69]],
"LaserJet M155nw":[1,[69]],
"LaserJet M15a":[1,[69]],
"LaserJet M15w":[1,[69]],
"LaserJet M209dw":[1,[69]],
"LaserJet M209dwe":[1,[69]],
"LaserJet M2727nf":[1,[69]],
"LaserJet M2727nfs":[1,[69]],
"LaserJet M3027x":[1,[69]],
"LaserJet M3035xs":[1,[69]],
"LaserJet M3050":[1,[69]],
"LaserJet M4555f":[1,[69]],
"LaserJet M4555fskm":[1,[69]],
"LaserJet M4555h":[1,[69]],
"LaserJet M507":[1,[69]],
"LaserJet M528":[1,[69]],
"LaserJet M601n":[1,[69]],
"LaserJet M604dn":[1,[69]],
"LaserJet M775":[1,[69]],
"LaserJet M855dn":[1,[69]],
"LaserJet M855x":[1,[69]],
"LaserJet M855xh":[1,[69]],
"LaserJet M9040":[1,[69]],
"LaserJet M9050":[1,[69]],
"LaserJet MFP M234dwe":[1,[69]],
"LaserJet MFP M234sdw":[1,[69]],
"LaserJet MFP M234sdwe":[1,[69]],
"LaserJet MFP M26a":[1,[69]],
"LaserJet MFP M26nw":[1,[69]],
"LaserJet MFP M26w":[1,[69]],
"LaserJet MFP M2727nf":[1,[69]],
"LaserJet MFP M28a":[1,[69]],
"LaserJet MFP M28w":[1,[69]],
"LaserJet MFP M766z":[1,[69]],
"LaserJet Managed E40040":[1,[68]],
"LaserJet Managed E42540":[1,[68]],
"LaserJet Managed E50045":[1,[68]],
"LaserJet Managed E50045dw":[1,[68]],
"LaserJet Managed E52545":[1,[68]],
"LaserJet Managed E52545dn":[1,[68]],
"LaserJet Managed E60055":[1,[68]],
"LaserJet Managed E60055dn":[1,[68]],
"LaserJet Managed E60065":[1,[68]],
"LaserJet Managed E60065dn":[1,[68]],
"LaserJet Managed E60065x":[1,[68]],
"LaserJet Managed E60075":[1,[68]],
"LaserJet Managed E60075dn":[1,[68]],
"LaserJet Managed E60075x":[1,[68]],
"LaserJet Managed E60155dn":[1,[68]],
"LaserJet Managed E60165":[1,[68]],
"LaserJet Managed E60165dn":[1,[68]],
"LaserJet Managed E62555":[1,[68]],
"LaserJet Managed E62555dn":[1,[68]],
"LaserJet Managed E62565":[1,[68]],
"LaserJet Managed E62575":[1,[68]],
"LaserJet Managed E62575z":[1,[68]],
"LaserJet Managed E62665h":[1,[68]],
"LaserJet Managed E65060":[1,[68]],
"LaserJet Managed MFP E45028dn":[1,[69]],
"LaserJet Managed MFP E47528f":[1,[69]],
"LaserJet Managed MFP E55040":[1,[69]],
"LaserJet Managed MFP E55040dn":[1,[69]],
"LaserJet Managed MFP E55040dw":[1,[69]],
"LaserJet Managed MFP E57540":[1,[69]],
"LaserJet Managed MFP E57540c":[1,[69]],
"LaserJet Managed MFP E57540dn":[1,[69]],
"LaserJet Managed MFP E67550":[1,[69]],
"LaserJet Managed MFP E67550dh":[1,[69]],
"LaserJet Managed MFP E67560z":[1,[69]],
"LaserJet Managed MFP E67650":[1,[69]],
"LaserJet Managed MFP E67650dh":[1,[69]],
"LaserJet Managed MFP E67650dn":[1,[69]],
"LaserJet Managed MFP E67660":[1,[69]],
"LaserJet Managed MFP E67660z":[1,[69]],
"LaserJet Managed MFP E77822dn":[1,[69]],
"LaserJet Managed MFP E77822z":[1,[69]],
"LaserJet Managed MFP E77825dn":[1,[69]],
"LaserJet Managed MFP E77825z":[1,[69]],
"LaserJet Managed MFP E77830dn":[1,[69]],
"LaserJet Managed MFP E77830z":[1,[69]],
"LaserJet Managed X58045":[1,[69]],
"LaserJet P1005":[1,[69]],
"LaserJet P1006":[1,[69]],
"LaserJet P1008":[1,[69]],
"LaserJet P1560":[1,[69]],
"LaserJet P2010":[1,[69]],
"LaserJet P2014":[1,[69]],
"LaserJet P2014n":[1,[69]],
"LaserJet P2015d":[1,[69]],
"LaserJet P2035":[1,[69]],
"LaserJet P2035n":[1,[69]],
"LaserJet P2055":[1,[69]],
"LaserJet P2055D":[1,[69]],
"LaserJet P2055DN":[1,[69]],
"LaserJet P2055X":[1,[69]],
"LaserJet P2055d":[1,[69]],
"LaserJet P2055dn":[1,[69]],
"LaserJet P3005":[1,[69]],
"LaserJet P3005d":[1,[69]],
"LaserJet P3005dn":[1,[69]],
"LaserJet P3005n":[1,[69]],
"LaserJet P3005x":[1,[69]],
"LaserJet P3010":[1,[69]],
"LaserJet P3015":[1,[69]],
"LaserJet P3015d":[1,[69]],
"LaserJet P3015dn":[1,[69]],
"LaserJet P3015x":[1,[69]],
"LaserJet P4014":[1,[69]],
"LaserJet P4014n":[1,[69]],
"LaserJet P4015n":[1,[69]],
"LaserJet P4015tn":[1,[69]],
"LaserJet P4015x":[1,[69]],
"LaserJet P4515n":[1,[69]],
"LaserJet P4515tn":[1,[69]],
"LaserJet P4515x":[1,[69]],
"LaserJet P4515xm":[1,[69]],
"LaserJet Pro 3001dw":[1,[69]],
"LaserJet Pro 3008dn":[1,[69]],
"LaserJet Pro 3008dne":[1,[69]],
"LaserJet Pro 3201dw":[1,[69]],
"LaserJet Pro 400 Color M475dn":[1,[69]],
"LaserJet Pro 400 Color M475dw":[1,[69]],
"LaserJet Pro 400 M401":[1,[69]],
"LaserJet Pro 400 M401d":[1,[69]],
"LaserJet Pro 400 M401dn":[1,[69]],
"LaserJet Pro 400 M401dne":[1,[69]],
"LaserJet Pro 400 M401dw":[1,[69]],
"LaserJet Pro 400 M401n":[1,[69]],
"LaserJet Pro 400 MFP M425dn":[1,[69]],
"LaserJet Pro 400 MFP M425dw":[1,[69]],
"LaserJet Pro 4001dn":[1,[69]],
"LaserJet Pro 4001dne":[1,[69]],
"LaserJet Pro 4001dw":[1,[69]],
"LaserJet Pro 4001dwe":[1,[69]],
"LaserJet Pro 4001ne":[1,[69]],
"LaserJet Pro 4201dn":[1,[69]],
"LaserJet Pro 4201dw":[1,[69]],
"LaserJet Pro Color M175a":[1,[69]],
"LaserJet Pro Color M175nw":[1,[69]],
"LaserJet Pro Color M275ncew":[1,[69]],
"LaserJet Pro Color M275nw":[1,[69]],
"LaserJet Pro Color M375nw":[1,[69]],
"LaserJet Pro M102A":[1,[69]],
"LaserJet Pro M102W":[1,[69]],
"LaserJet Pro M1132":[1,[69]],
"LaserJet Pro M118dw":[1,[69]],
"LaserJet Pro M1212NF":[1,[69]],
"LaserJet Pro M12w":[1,[69]],
"LaserJet Pro M148dw":[1,[69]],
"LaserJet Pro M148fdw":[1,[69]],
"LaserJet Pro M149":[1,[69]],
"LaserJet Pro M15":[1,[69]],
"LaserJet Pro M1536DNF":[1,[69]],
"LaserJet Pro M154a":[1,[69]],
"LaserJet Pro M154nw":[1,[69]],
"LaserJet Pro M155":[1,[69]],
"LaserJet Pro M15A":[1,[69]],
"LaserJet Pro M15W":[1,[69]],
"LaserJet Pro M203D":[1,[69]],
"LaserJet Pro M203DN":[1,[69]],
"LaserJet Pro M203DW":[1,[69]],
"LaserJet Pro M225dw":[1,[69]],
"LaserJet Pro M251n":[1,[69]],
"LaserJet Pro M251nw":[1,[69]],
"LaserJet Pro M252DW":[1,[69]],
"LaserJet Pro M252N":[1,[69]],
"LaserJet Pro M254DW":[1,[69]],
"LaserJet Pro M254nw":[1,[69]],
"LaserJet Pro M255DW":[1,[69]],
"LaserJet Pro M255NW":[1,[69]],
"LaserJet Pro M274dn":[1,[69]],
"LaserJet Pro M276n":[1,[69]],
"LaserJet Pro M276nw":[1,[69]],
"LaserJet Pro M277DW":[1,[69]],
"LaserJet Pro M277N":[1,[69]],
"LaserJet Pro M28":[1,[69]],
"LaserJet Pro M28A":[1,[69]],
"LaserJet Pro M351a":[1,[69]],
"LaserJet Pro M377DW":[1,[69]],
"LaserJet Pro M401d":[1,[69]],
"LaserJet Pro M401dn":[1,[69]],
"LaserJet Pro M401dne":[1,[69]],
"LaserJet Pro M401dw":[1,[69]],
"LaserJet Pro M401n":[1,[69]],
"LaserJet Pro M402":[1,[69]],
"LaserJet Pro M402dne":[1,[69]],
"LaserJet Pro M404":[1,[69]],
"LaserJet Pro M404dn":[1,[69]],
"LaserJet Pro M404dw":[1,[69]],
"LaserJet Pro M404n":[1,[69]],
"LaserJet Pro M428":[1,[69]],
"LaserJet Pro M435":[1,[69]],
"LaserJet Pro M452DN":[1,[69]],
"LaserJet Pro M452DW":[1,[69]],
"LaserJet Pro M452NW":[1,[69]],
"LaserJet Pro M454":[1,[69]],
"LaserJet Pro M477FDW":[1,[69]],
"LaserJet Pro M477FNW":[1,[69]],
"LaserJet Pro M479":[1,[69]],
"LaserJet Pro M501dn":[1,[69]],
"LaserJet Pro M501n":[1,[69]],
"LaserJet Pro M701":[1,[69]],
"LaserJet Pro M706n":[1,[69]],
"LaserJet Pro MFP 3101fdn":[1,[69]],
"LaserJet Pro MFP 3101fdw":[1,[69]],
"LaserJet Pro MFP 3108fdn":[1,[69]],
"LaserJet Pro MFP 3108fdne":[1,[69]],
"LaserJet Pro MFP 3301fdw":[1,[69]],
"LaserJet Pro MFP 3301sdw":[1,[69]],
"LaserJet Pro MFP 4101fdn":[1,[69]],
"LaserJet Pro MFP 4101fdne":[1,[69]],
"LaserJet Pro MFP 4101fdw":[1,[69]],
"LaserJet Pro MFP 4101fdwe":[1,[69]],
"LaserJet Pro MFP 4301dw":[1,[69]],
"LaserJet Pro MFP 4301fdw":[1,[69]],
"LaserJet Pro MFP M125":[1,[69]],
"LaserJet Pro MFP M125nw":[1,[69]],
"LaserJet Pro MFP M127":[1,[69]],
"LaserJet Pro MFP M127fn":[1,[69]],
"LaserJet Pro MFP M130A":[1,[69]],
"LaserJet Pro MFP M130FN":[1,[69]],
"LaserJet Pro MFP M130FW":[1,[69]],
"LaserJet Pro MFP M130NW":[1,[69]],
"LaserJet Pro MFP M153":[1,[69]],
"LaserJet Pro MFP M176n":[1,[69]],
"LaserJet Pro MFP M177fw":[1,[69]],
"LaserJet Pro MFP M180n":[1,[69]],
"LaserJet Pro MFP M181FW":[1,[69]],
"LaserJet Pro MFP M182":[1,[69]],
"LaserJet Pro MFP M182n":[1,[69]],
"LaserJet Pro MFP M183":[1,[69]],
"LaserJet Pro MFP M183fw":[1,[69]],
"LaserJet Pro MFP M201d":[1,[69]],
"LaserJet Pro MFP M201dw":[1,[69]],
"LaserJet Pro MFP M201n":[1,[69]],
"LaserJet Pro MFP M225dn":[1,[69]],
"LaserJet Pro MFP M227FDN":[1,[69]],
"LaserJet Pro MFP M227FDW":[1,[69]],
"LaserJet Pro MFP M227SDN":[1,[69]],
"LaserJet Pro MFP M227d":[1,[69]],
"LaserJet Pro MFP M252dw":[1,[69]],
"LaserJet Pro MFP M252n":[1,[69]],
"LaserJet Pro MFP M274n":[1,[69]],
"LaserJet Pro MFP M277dn":[1,[69]],
"LaserJet Pro MFP M277dw":[1,[69]],
"LaserJet Pro MFP M277n":[1,[69]],
"LaserJet Pro MFP M280NW":[1,[69]],
"LaserJet Pro MFP M281FDW":[1,[69]],
"LaserJet Pro MFP M281fdn":[1,[69]],
"LaserJet Pro MFP M282NW":[1,[69]],
"LaserJet Pro MFP M283FDN":[1,[69]],
"LaserJet Pro MFP M283FDW":[1,[69]],
"LaserJet Pro MFP M3301cdw":[1,[69]],
"LaserJet Pro MFP M3301fdw":[1,[69]],
"LaserJet Pro MFP M3301sdw":[1,[69]],
"LaserJet Pro MFP M377dw":[1,[69]],
"LaserJet Pro MFP M402dn":[1,[69]],
"LaserJet Pro MFP M402dw":[1,[69]],
"LaserJet Pro MFP M402n":[1,[69]],
"LaserJet Pro MFP M426":[1,[69]],
"LaserJet Pro MFP M426fdn":[1,[69]],
"LaserJet Pro MFP M426fdw":[1,[69]],
"LaserJet Pro MFP M428dw":[1,[69]],
"LaserJet Pro MFP M428fdn":[1,[69]],
"LaserJet Pro MFP M428fdw":[1,[69]],
"LaserJet Pro MFP M452dn":[1,[69]],
"LaserJet Pro MFP M452dw":[1,[69]],
"LaserJet Pro MFP M452nw":[1,[69]],
"LaserJet Pro MFP M454dn":[1,[69]],
"LaserJet Pro MFP M454dw":[1,[69]],
"LaserJet Pro MFP M454nw":[1,[69]],
"LaserJet Pro MFP M476":[1,[69]],
"LaserJet Pro MFP M476dn":[1,[69]],
"LaserJet Pro MFP M476dw":[1,[69]],
"LaserJet Pro MFP M476nw":[1,[69]],
"LaserJet Pro MFP M477fdw":[1,[69]],
"LaserJet Pro MFP M477fnw":[1,[69]],
"LaserJet Pro MFP M479dw":[1,[69]],
"LaserJet Pro MFP M479fdw":[1,[69]],
"LaserJet Pro MFP M479fnw":[1,[69]],
"LaserJet Pro P1102":[1,[69]],
"LaserJet Pro P1102W":[1,[69]],
"LaserJet Pro P1566":[1,[69]],
"LaserJet Pro P1606DN":[1,[69]],
"M155":[1,[58]],
"M155nw":[1,[58]],
"M476dn":[1,[57]],
"M476dw":[1,[57]],
"M476nw":[1,[57]],
"M507":[1,[67]],
"M507dn":[1,[67]],
"M507x":[1,[67]],
"M552":[1,[56]],
"M552dn":[1,[56]],
"M553":[1,[56]],
"M553dn":[1,[56]],
"M553n":[1,[56]],
"M553x":[1,[56]],
"MFP 1201":[1,[66]],
"MFP 1201n":[1,[66]],
"MFP 1202":[1,[66]],
"MFP 1202nw":[1,[66]],
"MFP 4301dw":[1,[66]],
"MFP 4301fdw":[1,[66]],
"MFP M182":[1,[66]],
"MFP M182n":[1,[66]],
"MFP M183fw":[1,[66]],
"MFP M528":[1,[66]],
"MFP M528dn":[1,[66]],
"MFP M528f":[1,[66]],
"MFP M528z":[1,[66]],
"MFP M577":[1,[66]],
"MFP M577dn":[1,[66]],
"MFP M577f":[1,[66]],
"MFP M577z":[1,[66]],
"Neverstop Laser 1001nw":[1,[70]],
"Neverstop Laser 1201n":[1,[70]],
"Neverstop Laser 1202":[1,[70]],
"Neverstop Laser 1202nw":[1,[70]],
"Officejet 100 L411a":[0,[74]],
"Officejet 1150cse":[0,[74]],
"Officejet 1175c":[0,[74]],
"Officejet 1175cse":[0,[74]],
"Officejet 1175cxi":[0,[74]],
"Officejet 150 L511a":[0,[74]],
"Officejet 200 Mobile":[0,[74]],
"Officejet 250 Mobile":[0,[74]],
"Officejet 2620":[0,[74]],
"Officejet 3830":[0,[74]],
"Officejet 4105":[0,[74]],
"Officejet 4105z":[0,[74]],
"Officejet 4110":[0,[74]],
"Officejet 4110v":[0,[74]],
"Officejet 4110xi":[0,[74]],
"Officejet 4115":[0,[74]],
"Officejet 4211":[0,[74]],
"Officejet 4212":[0,[74]],
"Officejet 4215":[0,[74]],
"Officejet 4215v":[0,[74]],
"Officejet 4215xi":[0,[74]],
"Officejet 4219":[0,[74]],
"Officejet 4255":[0,[74]],
"Officejet 4256":[0,[74]],
"Officejet 4259":[0,[74]],
"Officejet 4355":[0,[74]],
"Officejet 4500G510a":[0,[74]],
"Officejet 4500G510b":[0,[74]],
"Officejet 4500G510g":[0,[74]],
"Officejet 4500G510n":[0,[74]],
"Officejet 4610":[0,[74]],
"Officejet 4620":[0,[74]],
"Officejet 4630":[0,[74]],
"Officejet 4650":[0,[74]],
"Officejet 5110":[0,[74]],
"Officejet 5110v":[0,[74]],
"Officejet 5110xi":[0,[74]],
"Officejet 5220":[0,[74]],
"Officejet 5230":[0,[74]],
"Officejet 5510v":[0,[74]],
"Officejet 5515":[0,[74]],
"Officejet 5605":[0,[74]],
"Officejet 5610":[0,[74]],
"Officejet 5610v":[0,[74]],
"Officejet 5610xi":[0,[74]],
"Officejet 5615":[0,[74]],
"Officejet 5740":[0,[74]],
"Officejet 5742":[0,[74]],
"Officejet 5744":[0,[74]],
"Officejet 5746":[0,[74]],
"Officejet 6000":[0,[74]],
"Officejet 6100":[0,[74]],
"Officejet 6110":[0,[74]],
"Officejet 6200":[0,[74]],
"Officejet 6203":[0,[74]],
"Officejet 6205":[0,[74]],
"Officejet 6210":[0,[74]],
"Officejet 6210v":[0,[74]],
"Officejet 6210xi":[0,[74]],
"Officejet 6213":[0,[74]],
"Officejet 6215":[0,[74]],
"Officejet 6304":[0,[74]],
"Officejet 6305":[0,[74]],
"Officejet 6307":[0,[74]],
"Officejet 6308":[0,[74]],
"Officejet 6310":[0,[74]],
"Officejet 6310v":[0,[74]],
"Officejet 6310xi":[0,[74]],
"Officejet 6313":[0,[74]],
"Officejet 6315":[0,[74]],
"Officejet 6500":[0,[74]],
"Officejet 6500A":[0,[74]],
"Officejet 6600":[0,[74]],
"Officejet 6700":[0,[74]],
"Officejet 6950":[0,[74]],
"Officejet 6956":[0,[74]],
"Officejet 7000":[0,[74]],
"Officejet 7110":[0,[74]],
"Officejet 7205":[0,[74]],
"Officejet 7208":[0,[74]],
"Officejet 7210":[0,[74]],
"Officejet 7210v":[0,[74]],
"Officejet 7210xi":[0,[74]],
"Officejet 7213":[0,[74]],
"Officejet 7215":[0,[74]],
"Officejet 7310":[0,[74]],
"Officejet 7310xi":[0,[74]],
"Officejet 7313":[0,[74]],
"Officejet 7408":[0,[74]],
"Officejet 7410":[0,[74]],
"Officejet 7500A":[0,[74]],
"Officejet 7510":[0,[74]],
"Officejet 7512":[0,[74]],
"Officejet 7610":[0,[74]],
"Officejet 7612":[0,[74]],
"Officejet 8010":[0,[74]],
"Officejet 8010e":[0,[74]],
"Officejet 8012":[0,[74]],
"Officejet 8012e":[0,[74]],
"Officejet 8020":[0,[74]],
"Officejet 8022":[0,[74]],
"Officejet 8022e":[0,[74]],
"Officejet 8026":[0,[74]],
"Officejet 8028":[0,[74]],
"Officejet 8028e":[0,[74]],
"Officejet 9110":[0,[74]],
"Officejet 9120":[0,[74]],
"Officejet 9130":[0,[74]],
"Officejet G55":[0,[74]],
"Officejet G55xi":[0,[74]],
"Officejet G85":[0,[74]],
"Officejet G85xi":[0,[74]],
"Officejet H470":[0,[74]],
"Officejet H470bt":[0,[74]],
"Officejet J3508":[0,[74]],
"Officejet J3608":[0,[74]],
"Officejet J3680":[0,[74]],
"Officejet J4500":[0,[74]],
"Officejet J4524":[0,[74]],
"Officejet J4535":[0,[74]],
"Officejet J4540":[0,[74]],
"Officejet J4550":[0,[74]],
"Officejet J4580":[0,[74]],
"Officejet J4600":[0,[74]],
"Officejet J4624":[0,[74]],
"Officejet J4680":[0,[74]],
"Officejet J5508":[0,[74]],
"Officejet J5700":[0,[74]],
"Officejet J5730":[0,[74]],
"Officejet J5780":[0,[74]],
"Officejet J5785":[0,[74]],
"Officejet J6405":[0,[74]],
"Officejet J6410":[0,[74]],
"Officejet J6413":[0,[74]],
"Officejet J6415":[0,[74]],
"Officejet J6424":[0,[74]],
"Officejet J6450":[0,[74]],
"Officejet J6480":[0,[74]],
"Officejet J6488":[0,[74]],
"Officejet K7100":[0,[74]],
"Officejet K7103":[0,[74]],
"Officejet K7108":[0,[74]],
"Officejet Pro 1150c":[0,[73]],
"Officejet Pro 1170c":[0,[73]],
"Officejet Pro 1170cse":[0,[73]],
"Officejet Pro 1170cxi":[0,[73]],
"Officejet Pro 251DW":[0,[73]],
"Officejet Pro 276dw":[0,[73]],
"Officejet Pro 6230":[0,[73]],
"Officejet Pro 6820":[0,[73]],
"Officejet Pro 6830":[0,[73]],
"Officejet Pro 6960":[0,[73]],
"Officejet Pro 6970":[0,[73]],
"Officejet Pro 7720":[0,[73]],
"Officejet Pro 7730":[0,[73]],
"Officejet Pro 7740":[0,[73]],
"Officejet Pro 8020e":[0,[73]],
"Officejet Pro 8100":[0,[73]],
"Officejet Pro 8120":[0,[73]],
"Officejet Pro 8120e":[0,[73]],
"Officejet Pro 8130":[0,[73]],
"Officejet Pro 8130e":[0,[73]],
"Officejet Pro 8210":[0,[73]],
"Officejet Pro 8216":[0,[73]],
"Officejet Pro 8600":[0,[73]],
"Officejet Pro 8600 Plus":[0,[73]],
"Officejet Pro 8610":[0,[73]],
"Officejet Pro 8620":[0,[73]],
"Officejet Pro 8630":[0,[73]],
"Officejet Pro 8710":[0,[73]],
"Officejet Pro 8720":[0,[73]],
"Officejet Pro 8730":[0,[73]],
"Officejet Pro 8732M":[0,[73]],
"Officejet Pro 8740":[0,[73]],
"Officejet Pro 8745":[0,[73]],
"Officejet Pro 9000":[0,[73]],
"Officejet Pro 9010":[0,[73]],
"Officejet Pro 9010e":[0,[73]],
"Officejet Pro 9012":[0,[73]],
"Officejet Pro 9016":[0,[73]],
"Officejet Pro 9018":[0,[73]],
"Officejet Pro 9019":[0,[73]],
"Officejet Pro 9020":[0,[73]],
"Officejet Pro 9026":[0,[73]],
"Officejet Pro 9028":[0,[73]],
"Officejet Pro 9110":[0,[73]],
"Officejet Pro 9110e":[0,[73]],
"Officejet Pro 9120":[0,[73]],
"Officejet Pro 9120e":[0,[73]],
"Officejet Pro 9130":[0,[73]],
"Officejet Pro 9130e":[0,[73]],
"Officejet Pro 9720":[0,[73]],
"Officejet Pro 9720e":[0,[73]],
"Officejet Pro 9730":[0,[73]],
"Officejet Pro 9730e":[0,[73]],
"Officejet Pro K5300":[0,[73]],
"Officejet Pro K5400":[0,[73]],
"Officejet Pro K5400n":[0,[73]],
"Officejet Pro K5400tn":[0,[73]],
"Officejet Pro K550":[0,[73]],
"Officejet Pro K550dtn":[0,[73]],
"Officejet Pro K550dtwn":[0,[73]],
"Officejet Pro K850":[0,[73]],
"Officejet Pro K850dn":[0,[73]],
"Officejet Pro K8600":[0,[73]],
"Officejet Pro K8600dn":[0,[73]],
"Officejet Pro L7380":[0,[73]],
"Officejet Pro L7580":[0,[73]],
"Officejet Pro L7590":[0,[73]],
"Officejet Pro L7600":[0,[73]],
"Officejet Pro L7700":[0,[73]],
"Officejet Pro MFP X451DW":[0,[73]],
"Officejet Pro MFP X551DW":[0,[73]],
"Officejet Pro MFP X576DW":[0,[73]],
"Officejet Pro X476DW":[0,[73]],
"Officejet R45":[0,[74]],
"Officejet R65":[0,[74]],
"Officejet V30":[0,[74]],
"Officejet V40":[0,[74]],
"Officejet V40xi":[0,[74]],
"Officejet V45":[0,[74]],
"Officejet X555":[0,[74]],
"Officejet X555dn":[0,[74]],
"Officejet X555xh":[0,[74]],
"Officejet X585":[0,[74]],
"Officejet X585dn":[0,[74]],
"Officejet X585f":[0,[74]],
"Officejet X585z":[0,[74]],
"PSC 1110v":[0,[75]],
"PSC 1110xi":[0,[75]],
"PSC 1210":[0,[75]],
"PSC 1315":[0,[75]],
"PSC 1318":[0,[75]],
"PSC 1350":[0,[75]],
"PSC 1401":[0,[75]],
"PSC 1402":[0,[75]],
"PSC 1403":[0,[75]],
"PSC 1410":[0,[75]],
"PSC 1410v":[0,[75]],
"PSC 1410xi":[0,[75]],
"PSC 1415":[0,[75]],
"PSC 1503":[0,[75]],
"PSC 1504":[0,[75]],
"PSC 1506":[0,[75]],
"PSC 1507":[0,[75]],
"PSC 1508":[0,[75]],
"PSC 1510":[0,[75]],
"PSC 1510v":[0,[75]],
"PSC 1510xi":[0,[75]],
"PSC 1513":[0,[75]],
"PSC 1513s":[0,[75]],
"PSC 1514":[0,[75]],
"PSC 1600":[0,[75]],
"PSC 1603":[0,[75]],
"PSC 1605":[0,[75]],
"PSC 1608":[0,[75]],
"PSC 1610":[0,[75]],
"PSC 1610v":[0,[75]],
"PSC 1610xi":[0,[75]],
"PSC 1613":[0,[75]],
"PSC 1615":[0,[75]],
"PSC 2105":[0,[75]],
"PSC 2108":[0,[75]],
"PSC 2110":[0,[75]],
"PSC 2110v":[0,[75]],
"PSC 2110xi":[0,[75]],
"PSC 2115":[0,[75]],
"PSC 2150":[0,[75]],
"PSC 2170":[0,[75]],
"PSC 2171":[0,[75]],
"PSC 2175":[0,[75]],
"PSC 2175vV":[0,[75]],
"PSC 2175xi":[0,[75]],
"PSC 2179":[0,[75]],
"PSC 2210":[0,[75]],
"PSC 2210v":[0,[75]],
"PSC 2210xi":[0,[75]],
"PSC 2212":[0,[75]],
"PSC 2310":[0,[75]],
"PSC 2350":[0,[75]],
"PSC 2352":[0,[75]],
"PSC 2353":[0,[75]],
"PSC 2355":[0,[75]],
"PSC 2355p":[0,[75]],
"PSC 2355v":[0,[75]],
"PSC 2355xi":[0,[75]],
"PSC 2357":[0,[75]],
"PSC 2358":[0,[75]],
"PSC 2405":[0,[75]],
"PSC 2410":[0,[75]],
"PSC 2510":[0,[75]],
"PSC 500":[0,[75]],
"PSC 720":[0,[75]],
"PSC 750":[0,[75]],
"PSC 920":[0,[75]],
"PSC 950":[0,[75]],
"PSC 950c":[0,[75]],
"PSC 950xi":[0,[75]],
"PageWide Enterprise 556":[0,[76]],
"PageWide Enterprise 556dn":[0,[76]],
"PageWide Enterprise 556xh":[0,[76]],
"PageWide Enterprise 586":[0,[76]],
"PageWide Enterprise 586dn":[0,[76]],
"PageWide Enterprise 586f":[0,[76]],
"PageWide Enterprise 586z":[0,[76]],
"PageWide Enterprise E55650dn":[0,[76]],
"Pagewide 586dn":[0,[76]],
"Pagewide 993XC":[0,[]],
"Pagewide Color 755dn":[0,[]],
"Pagewide Color MFP 774dn":[0,[]],
"Pagewide Color MFP 774dns":[0,[]],
"Pagewide Managed P55250":[0,[77]],
"Pagewide Managed P55250dw":[0,[77]],
"Pagewide Managed P57750dw":[0,[77]],
"Pagewide Managed P75050dn":[0,[77]],
"Pagewide Managed P75050dw":[0,[77]],
"Pagewide Managed P77750dn":[0,[77]],
"Pagewide Managed P77750dw":[0,[77]],
"Pagewide Managed P77750z":[0,[77]],
"Pagewide Managed P77760z":[0,[77]],
"Pagewide Pro 452":[0,[78]],
"Pagewide Pro 452dw":[0,[78]],
"Pagewide Pro 477":[0,[78]],
"Pagewide Pro 477dw":[0,[78]],
"Pagewide Pro 552":[0,[78]],
"Pagewide Pro 552dw":[0,[78]],
"Pagewide Pro 577":[0,[78]],
"Pagewide Pro 577dw":[0,[78]],
"Pagewide Pro 577z":[0,[78]],
"Photosmart 1115":[0,[79]],
"Photosmart 1215":[0,[79]],
"Photosmart 1215vm":[0,[79]],
"Photosmart 1218":[0,[79]],
"Photosmart 1218xi":[0,[79]],
"Photosmart 1315":[0,[79]],
"Photosmart 2410":[0,[79]],
"Photosmart 2510":[0,[79]],
"Photosmart 2570":[0,[79]],
"Photosmart 2571":[0,[79]],
"Photosmart 2573":[0,[79]],
"Photosmart 2575":[0,[79]],
"Photosmart 2575v":[0,[79]],
"Photosmart 2575xi":[0,[79]],
"Photosmart 2577":[0,[79]],
"Photosmart 2578":[0,[79]],
"Photosmart 2608":[0,[79]],
"Photosmart 2610":[0,[79]],
"Photosmart 2610v":[0,[79]],
"Photosmart 2610xi":[0,[79]],
"Photosmart 2710":[0,[79]],
"Photosmart 2710v":[0,[79]],
"Photosmart 2710xi":[0,[79]],
"Photosmart 3107":[0,[79]],
"Photosmart 3108":[0,[79]],
"Photosmart 3110":[0,[79]],
"Photosmart 3110v":[0,[79]],
"Photosmart 3110xi":[0,[79]],
"Photosmart 3210":[0,[79]],
"Photosmart 3210a":[0,[79]],
"Photosmart 3210v":[0,[79]],
"Photosmart 3210xi":[0,[79]],
"Photosmart 3213":[0,[79]],
"Photosmart 3214":[0,[79]],
"Photosmart 325":[0,[79]],
"Photosmart 325v":[0,[79]],
"Photosmart 325xi":[0,[79]],
"Photosmart 329":[0,[79]],
"Photosmart 3308":[0,[79]],
"Photosmart 3310":[0,[79]],
"Photosmart 3310xi":[0,[79]],
"Photosmart 3313":[0,[79]],
"Photosmart 3314":[0,[79]],
"Photosmart 335":[0,[79]],
"Photosmart 335v":[0,[79]],
"Photosmart 335xi":[0,[79]],
"Photosmart 375":[0,[79]],
"Photosmart 375b":[0,[79]],
"Photosmart 375v":[0,[79]],
"Photosmart 375xi":[0,[79]],
"Photosmart 385":[0,[79]],
"Photosmart 385v":[0,[79]],
"Photosmart 385xi":[0,[79]],
"Photosmart 420":[0,[79]],
"Photosmart 422":[0,[79]],
"Photosmart 422v":[0,[79]],
"Photosmart 422xi":[0,[79]],
"Photosmart 425":[0,[79]],
"Photosmart 425v":[0,[79]],
"Photosmart 428":[0,[79]],
"Photosmart 428v":[0,[79]],
"Photosmart 428xi":[0,[79]],
"Photosmart 475":[0,[79]],
"Photosmart 475v":[0,[79]],
"Photosmart 475xi":[0,[79]],
"Photosmart 5510":[0,[79]],
"Photosmart 5520":[0,[79]],
"Photosmart 6510":[0,[79]],
"Photosmart 6520":[0,[79]],
"Photosmart 7000":[0,[79]],
"Photosmart 7150":[0,[79]],
"Photosmart 7260":[0,[79]],
"Photosmart 7450":[0,[79]],
"Photosmart 7510 EAllinOne":[0,[79]],
"Photosmart 7520 EAllinOne":[0,[79]],
"Photosmart 7550":[0,[79]],
"Photosmart 7600":[0,[79]],
"Photosmart 7660":[0,[79]],
"Photosmart 7700":[0,[79]],
"Photosmart 7760":[0,[79]],
"Photosmart 7762w":[0,[79]],
"Photosmart 7830":[0,[79]],
"Photosmart 7838":[0,[79]],
"Photosmart 7850":[0,[79]],
"Photosmart 7900":[0,[79]],
"Photosmart 7960":[0,[79]],
"Photosmart 7960gp":[0,[79]],
"Photosmart 8030":[0,[79]],
"Photosmart 8038":[0,[79]],
"Photosmart 8049":[0,[79]],
"Photosmart 8050":[0,[79]],
"Photosmart 8050v":[0,[79]],
"Photosmart 8050xi":[0,[79]],
"Photosmart 8053":[0,[79]],
"Photosmart 8100":[0,[79]],
"Photosmart 8150":[0,[79]],
"Photosmart 8150v":[0,[79]],
"Photosmart 8150w":[0,[79]],
"Photosmart 8150xi":[0,[79]],
"Photosmart 8157":[0,[79]],
"Photosmart 8230":[0,[79]],
"Photosmart 8238":[0,[79]],
"Photosmart 8250":[0,[79]],
"Photosmart 8250v":[0,[79]],
"Photosmart 8250xi":[0,[79]],
"Photosmart 8253":[0,[79]],
"Photosmart 8400":[0,[79]],
"Photosmart 8450":[0,[79]],
"Photosmart 8450v":[0,[79]],
"Photosmart 8450w":[0,[79]],
"Photosmart 8700":[0,[79]],
"Photosmart 8750":[0,[79]],
"Photosmart 8750xi":[0,[79]],
"Photosmart 8753":[0,[79]],
"Photosmart 8758":[0,[79]],
"Photosmart B010a":[0,[79]],
"Photosmart B010b":[0,[79]],
"Photosmart B109A":[0,[79]],
"Photosmart B110A":[0,[79]],
"Photosmart B209A":[0,[79]],
"Photosmart B210":[0,[79]],
"Photosmart B8330":[0,[79]],
"Photosmart C3140":[0,[79]],
"Photosmart C3150":[0,[79]],
"Photosmart C3170":[0,[79]],
"Photosmart C3175":[0,[79]],
"Photosmart C3180":[0,[79]],
"Photosmart C4175":[0,[79]],
"Photosmart C4180":[0,[79]],
"Photosmart C4188":[0,[79]],
"Photosmart C4200":[0,[79]],
"Photosmart C4280":[0,[79]],
"Photosmart C4300":[0,[79]],
"Photosmart C4345":[0,[79]],
"Photosmart C4348":[0,[79]],
"Photosmart C4380":[0,[79]],
"Photosmart C4383":[0,[79]],
"Photosmart C4385":[0,[79]],
"Photosmart C4388":[0,[79]],
"Photosmart C4424":[0,[79]],
"Photosmart C4480":[0,[79]],
"Photosmart C4488":[0,[79]],
"Photosmart C4524":[0,[79]],
"Photosmart C4580":[0,[79]],
"Photosmart C4583":[0,[79]],
"Photosmart C4585":[0,[79]],
"Photosmart C4588":[0,[79]],
"Photosmart C4599":[0,[79]],
"Photosmart C4680":[0,[79]],
"Photosmart C4683":[0,[79]],
"Photosmart C4685":[0,[79]],
"Photosmart C4780":[0,[79]],
"Photosmart C4795":[0,[79]],
"Photosmart C4799":[0,[79]],
"Photosmart C5180":[0,[79]],
"Photosmart C5200":[0,[79]],
"Photosmart C5280":[0,[79]],
"Photosmart C5288":[0,[79]],
"Photosmart C5324":[0,[79]],
"Photosmart C5370":[0,[79]],
"Photosmart C5373":[0,[79]],
"Photosmart C5380":[0,[79]],
"Photosmart C5383":[0,[79]],
"Photosmart C5388":[0,[79]],
"Photosmart C5390":[0,[79]],
"Photosmart C5393":[0,[79]],
"Photosmart C5580":[0,[79]],
"Photosmart C6180":[0,[79]],
"Photosmart C6270":[0,[79]],
"Photosmart C6280":[0,[79]],
"Photosmart C6324":[0,[79]],
"Photosmart C6375":[0,[79]],
"Photosmart C6380":[0,[79]],
"Photosmart C7180":[0,[79]],
"Photosmart C7280":[0,[79]],
"Photosmart C8180":[0,[79]],
"Photosmart C8188":[0,[79]],
"Photosmart D5156":[0,[79]],
"Photosmart D5160":[0,[79]],
"Photosmart D5360":[0,[79]],
"Photosmart D5363":[0,[79]],
"Photosmart D5368":[0,[79]],
"Photosmart D5460":[0,[79]],
"Photosmart D5463":[0,[79]],
"Photosmart D5468":[0,[79]],
"Photosmart D6100":[0,[79]],
"Photosmart D6160":[0,[79]],
"Photosmart D6163":[0,[79]],
"Photosmart D6168":[0,[79]],
"Photosmart D7160":[0,[79]],
"Photosmart D7200":[0,[79]],
"Photosmart D7260":[0,[79]],
"Photosmart D7360":[0,[79]],
"Photosmart D7400":[0,[79]],
"Photosmart D7460":[0,[79]],
"Photosmart D7468":[0,[79]],
"Photosmart D7560":[0,[79]],
"Photosmart Estation C510A":[0,[79]],
"Photosmart P1000":[0,[79]],
"Photosmart P1100":[0,[79]],
"Photosmart P1100xi":[0,[79]],
"Photosmart P1115":[0,[79]],
"Photosmart P1215":[0,[79]],
"Photosmart P1218":[0,[79]],
"Photosmart Premium C309A":[0,[79]],
"Photosmart Premium C310A":[0,[79]],
"Photosmart Premium C410A":[0,[79]],
"Photosmart Pro B8550":[0,[79]],
"Photosmart Pro B8553":[0,[79]],
"Photosmart Pro B8558":[0,[79]],
"SMART TANK 450":[0,[81]],
"SMART TANK 455":[0,[81]],
"SMART TANK 551":[0,[81]],
"SMART TANK 555":[0,[81]],
"SMART TANK 559":[0,[81]],
"SMART TANK 570":[0,[81]],
"SMART TANK 571":[0,[81]],
"SMART TANK 651":[0,[81]],
"SMART TANK 655":[0,[81]],
"SMART TANK 7005":[0,[81]],
"SMART TANK 7305":[0,[81]],
"SMART TANK 7605":[0,[81]],
"TANGO X":[0,[82]]
},
"Kyocera": {
"DC-1560":[1,[84]],
"DC-1860":[1,[84]],
"DC-2050":[1,[84]],
"DC-2360":[1,[84]],
"DC-2550":[1,[84]],
"DC-3060":[1,[84]],
"DC-4060A":[1,[84]],
"ECOSYS FS-1016MFP":[1,[83]],
"ECOSYS FS-1020D":[1,[83]],
"ECOSYS FS-1020DN":[1,[83]],
"ECOSYS FS-1028MFP":[1,[83]],
"ECOSYS FS-1030MFP":[1,[83]],
"ECOSYS FS-1035MFP":[1,[83]],
"ECOSYS FS-1041":[1,[83]],
"ECOSYS FS-1061DN":[1,[83]],
"ECOSYS FS-1100":[1,[83]],
"ECOSYS FS-1118MFP":[1,[83]],
"ECOSYS FS-1120D":[1,[83]],
"ECOSYS FS-1128MFP":[1,[83]],
"ECOSYS FS-1130MFP":[1,[83]],
"ECOSYS FS-1135MFP":[1,[83]],
"ECOSYS FS-1200":[1,[83]],
"ECOSYS FS-1300D":[1,[83]],
"ECOSYS FS-1320D":[1,[83]],
"ECOSYS FS-1320MFP":[1,[83]],
"ECOSYS FS-1320MFPT":[1,[83]],
"ECOSYS FS-1325MFP":[1,[83]],
"ECOSYS FS-1350D":[1,[83]],
"ECOSYS FS-1370DN":[1,[83]],
"ECOSYS FS-1500":[1,[83]],
"ECOSYS FS-1920":[1,[83]],
"ECOSYS FS-2000D":[1,[83]],
"ECOSYS FS-2020D":[1,[83]],
"ECOSYS FS-2100D":[1,[83]],
"ECOSYS FS-2100DN":[1,[83]],
"ECOSYS FS-3040MFP":[1,[83]],
"ECOSYS FS-3140MFP":[1,[83]],
"ECOSYS FS-3500":[1,[83]],
"ECOSYS FS-3540MFP":[1,[83]],
"ECOSYS FS-3640MFP":[1,[83]],
"ECOSYS FS-3900DN":[1,[83]],
"ECOSYS FS-3920DN":[1,[83]],
"ECOSYS FS-400":[1,[83]],
"ECOSYS FS-4000DN":[1,[83]],
"ECOSYS FS-4020DN":[1,[83]],
"ECOSYS FS-4100DN":[1,[83]],
"ECOSYS FS-4200DN":[1,[83]],
"ECOSYS FS-4300DN":[1,[83]],
"ECOSYS FS-6025MFP":[1,[83]],
"ECOSYS FS-6030MFP":[1,[83]],
"ECOSYS FS-6525MFP":[1,[83]],
"ECOSYS FS-6530MFP":[1,[83]],
"ECOSYS FS-6970DN":[1,[83]],
"ECOSYS FS-720":[1,[83]],
"ECOSYS FS-820":[1,[83]],
"ECOSYS FS-920":[1,[83]],
"ECOSYS FS-9530DN":[1,[83]],
"ECOSYS FS-C1020MFP":[1,[83]],
"ECOSYS FS-C2026MFP":[1,[83]],
"ECOSYS FS-C2126MFP":[1,[83]],
"ECOSYS FS-C2526MFP":[1,[83]],
"ECOSYS FS-C2626MFP":[1,[83]],
"ECOSYS FS-C5015N":[1,[83]],
"ECOSYS FS-C5020N":[1,[83]],
"ECOSYS FS-C5025N":[1,[83]],
"ECOSYS FS-C5030N":[1,[83]],
"ECOSYS FS-C5100DN":[1,[83]],
"ECOSYS FS-C5150DN":[1,[83]],
"ECOSYS FS-C5200DN":[1,[83]],
"ECOSYS FS-C5250DN":[1,[83]],
"ECOSYS FS-C5300DN":[1,[83]],
"ECOSYS FS-C5350DN":[1,[83]],
"ECOSYS FS-C5400DN":[1,[83]],
"ECOSYS FS-C8008NP":[1,[83]],
"ECOSYS FS-C8020":[1,[83]],
"ECOSYS FS-C8020MFP":[1,[83]],
"ECOSYS FS-C8025":[1,[83]],
"ECOSYS FS-C8025MFP":[1,[83]],
"ECOSYS FS-C8026N":[1,[83]],
"ECOSYS FS-C8100DN":[1,[83]],
"ECOSYS FS-C8500DN":[1,[83]],
"ECOSYS FS-C8520":[1,[83]],
"ECOSYS FS-C8520MFP":[1,[83]],
"ECOSYS FS-C8525":[1,[83]],
"ECOSYS FS-C8525MFP":[1,[83]],
"ECOSYS FS-C8650DN":[1,[83]],
"ECOSYS M2035DN":[1,[83]],
"ECOSYS M2040":[1,[83]],
"ECOSYS M2040DN":[1,[83]],
"ECOSYS M2530DN":[1,[83]],
"ECOSYS M2535DN":[1,[83]],
"ECOSYS M2540":[1,[83]],
"ECOSYS M2540DN":[1,[83]],
"ECOSYS M2635":[1,[83]],
"ECOSYS M2635DN":[1,[83]],
"ECOSYS M2640":[1,[83]],
"ECOSYS M2640IDW":[1,[83]],
"ECOSYS M2735":[1,[83]],
"ECOSYS M2735DW":[1,[83]],
"ECOSYS M3040DN":[1,[83]],
"ECOSYS M3040idn":[1,[83]],
"ECOSYS M3540DN":[1,[83]],
"ECOSYS M3540idn":[1,[83]],
"ECOSYS M3550IDN":[1,[83]],
"ECOSYS M3560IDN":[1,[83]],
"ECOSYS M3645":[1,[83]],
"ECOSYS M3645DN":[1,[83]],
"ECOSYS M3645IDN":[1,[83]],
"ECOSYS M3655IDN":[1,[83]],
"ECOSYS M3860IDN":[1,[83]],
"ECOSYS M4125":[1,[83]],
"ECOSYS M4125IDN":[1,[83]],
"ECOSYS M4132":[1,[83]],
"ECOSYS M4132IDN":[1,[83]],
"ECOSYS M5221CDN":[1,[83]],
"ECOSYS M5221CDW":[1,[83]],
"ECOSYS M5521":[1,[83]],
"ECOSYS M5521CDN":[1,[83]],
"ECOSYS M5521CDW":[1,[83]],
"ECOSYS M5526":[1,[83]],
"ECOSYS M5526CDN":[1,[83]],
"ECOSYS M5526CDW":[1,[83]],
"ECOSYS M5526DN":[1,[83]],
"ECOSYS M6026":[1,[83]],
"ECOSYS M6026CDN":[1,[83]],
"ECOSYS M6030":[1,[83]],
"ECOSYS M6030CDN":[1,[83]],
"ECOSYS M6230":[1,[83]],
"ECOSYS M6230CDN":[1,[83]],
"ECOSYS M6230CIDN":[1,[83]],
"ECOSYS M6526CDN":[1,[83]],
"ECOSYS M6530":[1,[83]],
"ECOSYS M6530CDN":[1,[83]],
"ECOSYS M6535":[1,[83]],
"ECOSYS M6535CDN":[1,[83]],
"ECOSYS M6535CIDN":[1,[83]],
"ECOSYS M6630":[1,[83]],
"ECOSYS M6630CIDN":[1,[83]],
"ECOSYS M6635":[1,[83]],
"ECOSYS M6635CIDN":[1,[83]],
"ECOSYS M8124":[1,[83]],
"ECOSYS M8124CIDN":[1,[83]],
"ECOSYS M8130":[1,[83]],
"ECOSYS M8130CIDN":[1,[83]],
"ECOSYS MA2000W":[1,[83]],
"ECOSYS MA2100CFX":[1,[83]],
"ECOSYS MA2100CWFX":[1,[83]],
"ECOSYS MA2101CFX":[1,[83]],
"ECOSYS MA2101CWFX":[1,[83]],
"ECOSYS MA2600CFX":[1,[83]],
"ECOSYS MA2600CWFX":[1,[83]],
"ECOSYS MA2600CWX":[1,[83]],
"ECOSYS MA3500CIFX":[1,[83]],
"ECOSYS MA3500CIX":[1,[83]],
"ECOSYS MA3501WFX":[1,[83]],
"ECOSYS MA4000CIFX":[1,[83]],
"ECOSYS MA4000FX":[1,[83]],
"ECOSYS MA4000WIFX":[1,[83]],
"ECOSYS MA4000X":[1,[83]],
"ECOSYS MA4500FX":[1,[83]],
"ECOSYS MA4500IFX":[1,[83]],
"ECOSYS MA5500IFX":[1,[83]],
"ECOSYS P2035D":[1,[83]],
"ECOSYS P2040":[1,[83]],
"ECOSYS P2040DN":[1,[83]],
"ECOSYS P2040DW":[1,[83]],
"ECOSYS P2135D":[1,[83]],
"ECOSYS P2135DN":[1,[83]],
"ECOSYS P2235DN":[1,[83]],
"ECOSYS P2235DW":[1,[83]],
"ECOSYS P3045":[1,[83]],
"ECOSYS P3045DN":[1,[83]],
"ECOSYS P3050":[1,[83]],
"ECOSYS P3050DN":[1,[83]],
"ECOSYS P3055":[1,[83]],
"ECOSYS P3055DN":[1,[83]],
"ECOSYS P3060":[1,[83]],
"ECOSYS P3060DN":[1,[83]],
"ECOSYS P3145DN":[1,[83]],
"ECOSYS P3150DN":[1,[83]],
"ECOSYS P3155DN":[1,[83]],
"ECOSYS P3260DN":[1,[83]],
"ECOSYS P4040":[1,[83]],
"ECOSYS P4040DN":[1,[83]],
"ECOSYS P4060":[1,[83]],
"ECOSYS P4060DN":[1,[83]],
"ECOSYS P4140":[1,[83]],
"ECOSYS P4140DN":[1,[83]],
"ECOSYS P5021":[1,[83]],
"ECOSYS P5021CDN":[1,[83]],
"ECOSYS P5021CDW":[1,[83]],
"ECOSYS P5026":[1,[83]],
"ECOSYS P5026CDN":[1,[83]],
"ECOSYS P5026CDW":[1,[83]],
"ECOSYS P5026DN":[1,[83]],
"ECOSYS P6021CDN":[1,[83]],
"ECOSYS P6026CDN":[1,[83]],
"ECOSYS P6030CDN":[1,[83]],
"ECOSYS P6035":[1,[83]],
"ECOSYS P6035CDN":[1,[83]],
"ECOSYS P6130":[1,[83]],
"ECOSYS P6130CDN":[1,[83]],
"ECOSYS P6230":[1,[83]],
"ECOSYS P6230CDN":[1,[83]],
"ECOSYS P6235":[1,[83]],
"ECOSYS P6235CDN":[1,[83]],
"ECOSYS P7035CDN":[1,[83]],
"ECOSYS P7040":[1,[83]],
"ECOSYS P7040CDN":[1,[83]],
"ECOSYS P7240":[1,[83]],
"ECOSYS P7240CDN":[1,[83]],
"ECOSYS P8060":[1,[83]],
"ECOSYS P8060CDN":[1,[83]],
"ECOSYS PA2100CWX":[1,[83]],
"ECOSYS PA2100CX":[1,[83]],
"ECOSYS PA2101CWX":[1,[83]],
"ECOSYS PA2101CX":[1,[83]],
"ECOSYS PA2600CWX":[1,[83]],
"ECOSYS PA2600CX":[1,[83]],
"ECOSYS PA3500CX":[1,[83]],
"ECOSYS PA3500X":[1,[83]],
"ECOSYS PA4000CX":[1,[83]],
"ECOSYS PA4000WX":[1,[83]],
"ECOSYS PA4000X":[1,[83]],
"ECOSYS PA4500CX":[1,[83]],
"ECOSYS PA4500X":[1,[83]],
"ECOSYS PA5000X":[1,[83]],
"ECOSYS PA5500X":[1,[83]],
"ECOSYS PA6000X":[1,[83]],
"KM-1620":[1,[84]],
"KM-1635":[1,[84]],
"KM-1650":[1,[84]],
"KM-2050":[1,[84]],
"KM-2560":[1,[84]],
"KM-3060":[1,[84]],
"KM-4230":[1,[84]],
"KM-4530":[1,[84]],
"KM-4800":[1,[84]],
"KM-4800W":[1,[84]],
"KM-5230":[1,[84]],
"KM-5530":[1,[84]],
"KM-6230":[1,[84]],
"KM-6330":[1,[84]],
"KM-C2520":[1,[84]],
"KM-C2525":[1,[84]],
"KM-C2630D":[1,[84]],
"KM-C3225":[1,[84]],
"KM-C3232":[1,[84]],
"KM-C4035E":[1,[84]],
"MA4500fx":[1,[]],
"MA4500ifx":[1,[]],
"PA4500x":[1,[]],
"TASKalfa 180":[1,[85]],
"TASKalfa 1800":[1,[85]],
"TASKalfa 181":[1,[85]],
"TASKalfa 2020":[1,[85]],
"TASKalfa 221":[1,[85]],
"TASKalfa 250ci":[1,[85]],
"TASKalfa 2550ci":[1,[85]],
"TASKalfa 2551ci":[1,[85]],
"TASKalfa 2552ci":[1,[85]],
"TASKalfa 2553ci":[1,[85]],
"TASKalfa 300ci":[1,[85]],
"TASKalfa 300i":[1,[85]],
"TASKalfa 3010i":[1,[85]],
"TASKalfa 3050ci":[1,[85]],
"TASKalfa 3051ci":[1,[85]],
"TASKalfa 306ci":[1,[85]],
"TASKalfa 307ci":[1,[85]],
"TASKalfa 308ci":[1,[85]],
"TASKalfa 3212i":[1,[85]],
"TASKalfa 3252ci":[1,[85]],
"TASKalfa 3253ci":[1,[85]],
"TASKalfa 3500i":[1,[85]],
"TASKalfa 3501i":[1,[85]],
"TASKalfa 3510i":[1,[85]],
"TASKalfa 352ci":[1,[85]],
"TASKalfa 3550ci":[1,[85]],
"TASKalfa 3551ci":[1,[85]],
"TASKalfa 356ci":[1,[85]],
"TASKalfa 358ci":[1,[85]],
"TASKalfa 4002i":[1,[85]],
"TASKalfa 4012i":[1,[85]],
"TASKalfa 4052ci":[1,[85]],
"TASKalfa 4053ci":[1,[85]],
"TASKalfa 406ci":[1,[85]],
"TASKalfa 408ci":[1,[85]],
"TASKalfa 4500i":[1,[85]],
"TASKalfa 4501i":[1,[85]],
"TASKalfa 4550ci":[1,[85]],
"TASKalfa 4551ci":[1,[85]],
"TASKalfa 5002i":[1,[85]],
"TASKalfa 5003i":[1,[85]],
"TASKalfa 5004i":[1,[85]],
"TASKalfa 5052ci":[1,[85]],
"TASKalfa 5053ci":[1,[85]],
"TASKalfa 5054ci":[1,[85]],
"TASKalfa 5500i":[1,[85]],
"TASKalfa 5501i":[1,[85]],
"TASKalfa 5550ci":[1,[85]],
"TASKalfa 5551ci":[1,[85]],
"TASKalfa 6002i":[1,[85]],
"TASKalfa 6003i":[1,[85]],
"TASKalfa 6004i":[1,[85]],
"TASKalfa 6052ci":[1,[85]],
"TASKalfa 6053ci":[1,[85]],
"TASKalfa 6054ci":[1,[85]],
"TASKalfa 6500i":[1,[85]],
"TASKalfa 6550ci":[1,[85]],
"TASKalfa 6551ci":[1,[85]],
"TASKalfa 7002i":[1,[85]],
"TASKalfa 7003i":[1,[85]],
"TASKalfa 7004i":[1,[85]],
"TASKalfa 7054ci":[1,[85]],
"TASKalfa 7353ci":[1,[85]],
"TASKalfa 7550ci":[1,[85]],
"TASKalfa 7551ci":[1,[85]],
"TASKalfa 8000i":[1,[85]],
"TASKalfa 8001i":[1,[85]],
"TASKalfa 8002i":[1,[85]],
"TASKalfa 8353ci":[1,[85]],
"TASKalfa 9003i":[1,[85]],
"Vi-150":[1,[84]],
"Vi-155":[1,[84]],
"Vi-200":[1,[84]],
"Vi-230L":[1,[84]],
"Vi-310L":[1,[84]],
"Vi-400":[1,[84]],
"Vi-500":[1,[84]]
},
"Lexmark": {
"1000":[0,[92]],
"1020":[0,[92]],
"1100":[0,[92]],
"2030":[0,[92]],
"2050":[0,[92]],
"2055":[0,[92]],
"3000":[0,[92]],
"3200":[0,[]],
"4076":[0,[92]],
"5000":[0,[]],
"5700":[0,[]],
"5770":[0,[]],
"7000":[0,[]],
"7200":[0,[]],
"ApeosPort C3320SD":[1,[87]],
"ApeosPort C3830SD":[1,[87]],
"ApeosPort Print C3320SD":[1,[86]],
"ApeosPort Print C3830SD":[1,[86]],
"B2236":[1,[88]],
"B2236dw":[1,[88]],
"B3442":[1,[88]],
"B3442dw":[1,[88]],
"C1200":[1,[89]],
"C1200N":[1,[89]],
"C2240":[1,[89]],
"C2335":[1,[89]],
"C2425":[1,[89]],
"C2425dw":[1,[89]],
"C3326":[1,[89]],
"C3326dw":[1,[89]],
"C4150":[1,[89]],
"C4342":[1,[89]],
"C500":[1,[89]],
"C500N":[1,[89]],
"C510":[1,[89]],
"C522":[1,[89]],
"C522N":[1,[89]],
"C524":[1,[89]],
"C524N":[1,[89]],
"C532":[1,[89]],
"C532DN":[1,[89]],
"C532N":[1,[89]],
"C534":[1,[89]],
"C534DN":[1,[89]],
"C540":[1,[89]],
"C540N":[1,[89]],
"C543":[1,[89]],
"C543DN":[1,[89]],
"C544":[1,[89]],
"C544D":[1,[89]],
"C544DN":[1,[89]],
"C544DTN":[1,[89]],
"C544DW":[1,[89]],
"C544N":[1,[89]],
"C546":[1,[89]],
"C546DTN":[1,[89]],
"C6160":[1,[89]],
"C720":[1,[89]],
"C734":[1,[89]],
"C734DN":[1,[89]],
"C734DW":[1,[89]],
"C736":[1,[89]],
"C736DN":[1,[89]],
"C746":[1,[89]],
"C746DN":[1,[89]],
"C748":[1,[89]],
"C748DE":[1,[89]],
"C752":[1,[89]],
"C752DN":[1,[89]],
"C752DTN":[1,[89]],
"C752FN":[1,[89]],
"C752LDN":[1,[89]],
"C752LDTN":[1,[89]],
"C752LN":[1,[89]],
"C752N":[1,[89]],
"C760":[1,[89]],
"C762":[1,[89]],
"C770":[1,[89]],
"C772":[1,[89]],
"C780":[1,[89]],
"C780DN":[1,[89]],
"C780DTN":[1,[89]],
"C780N":[1,[89]],
"C782":[1,[89]],
"C782DN":[1,[89]],
"C782DTN":[1,[89]],
"C782N":[1,[89]],
"C792":[1,[89]],
"C792DE":[1,[89]],
"C792DTE":[1,[89]],
"C910":[1,[89]],
"C910DN":[1,[89]],
"C910FN":[1,[89]],
"C910IN":[1,[89]],
"C910N":[1,[89]],
"C912":[1,[89]],
"C912FN":[1,[89]],
"C920":[1,[89]],
"C925":[1,[89]],
"C925DE":[1,[89]],
"C935":[1,[89]],
"C935DN":[1,[89]],
"C935DTN":[1,[89]],
"C935HDN":[1,[89]],
"C950":[1,[89]],
"C950DE":[1,[89]],
"C950DTE":[1,[89]],
"CS310":[1,[90]],
"CS310DN":[1,[90]],
"CS310N":[1,[90]],
"CS410":[1,[90]],
"CS410DN":[1,[90]],
"CS410DTN":[1,[90]],
"CS431":[1,[90]],
"CS510":[1,[90]],
"CS510DE":[1,[90]],
"CS510DTE":[1,[90]],
"CS521":[1,[90]],
"CS521dn":[1,[90]],
"CS531DW":[1,[90]],
"CS622":[1,[90]],
"CS622de":[1,[90]],
"CS632DWE":[1,[90]],
"CS720":[1,[90]],
"CS725":[1,[90]],
"CS725de":[1,[90]],
"CS730":[1,[90]],
"CS730DE":[1,[90]],
"CS748":[1,[90]],
"CS796":[1,[90]],
"CS820":[1,[90]],
"CS820DE":[1,[90]],
"CS820DTE":[1,[90]],
"CS820DTFE":[1,[90]],
"CS923":[1,[90]],
"CS923de":[1,[90]],
"CS943":[1,[90]],
"CS943DE":[1,[90]],
"CS963":[1,[90]],
"CX310":[1,[91]],
"CX310DN":[1,[91]],
"CX331":[1,[91]],
"CX331adwe":[1,[91]],
"CX410":[1,[91]],
"CX410DE":[1,[91]],
"CX431":[1,[91]],
"CX431ADN":[1,[91]],
"CX431adw":[1,[91]],
"CX510":[1,[91]],
"CX510DE":[1,[91]],
"CX510DHE":[1,[91]],
"CX522":[1,[91]],
"CX522ade":[1,[91]],
"CX532ADWE":[1,[91]],
"CX622":[1,[91]],
"CX622ADE":[1,[91]],
"CX625":[1,[91]],
"CX625adhe":[1,[91]],
"CX635adwe":[1,[91]],
"CX725":[1,[91]],
"CX725DHE":[1,[91]],
"CX725de":[1,[91]],
"CX730":[1,[91]],
"CX730DE":[1,[91]],
"CX735":[1,[91]],
"CX735ADSE":[1,[91]],
"CX825":[1,[91]],
"CX825DTE":[1,[91]],
"CX825de":[1,[91]],
"CX833":[1,[91]],
"CX860":[1,[91]],
"CX860DE":[1,[91]],
"CX860DTE":[1,[91]],
"CX920":[1,[91]],
"CX920de":[1,[91]],
"CX921":[1,[91]],
"CX921DE":[1,[91]],
"CX922":[1,[91]],
"CX922de":[1,[91]],
"CX923":[1,[91]],
"CX923DE":[1,[91]],
"CX923DTE":[1,[91]],
"CX923DXE":[1,[91]],
"CX923TE":[1,[91]],
"CX942":[1,[91]],
"CX942adse":[1,[91]],
"CX943":[1,[91]],
"CX943ADTSE":[1,[91]],
"CX943ADXSE":[1,[91]],
"CX944":[1,[91]],
"CX944ADXSE":[1,[91]],
"CX950":[1,[91]],
"CX951":[1,[91]],
"CX961":[1,[91]],
"CX962":[1,[91]],
"CX963":[1,[91]],
"E120":[1,[93]],
"E120N":[1,[93]],
"E210":[1,[93]],
"E230":[1,[93]],
"E232":[1,[93]],
"E232T":[1,[93]],
"E234":[1,[93]],
"E250":[1,[93]],
"E250d":[1,[93]],
"E250dn":[1,[93]],
"E260":[1,[93]],
"E260d":[1,[93]],
"E260dn":[1,[93]],
"E310":[1,[93]],
"E312":[1,[93]],
"E312L":[1,[93]],
"E320":[1,[93]],
"E322":[1,[93]],
"E322n":[1,[93]],
"E323":[1,[93]],
"E330":[1,[93]],
"E332":[1,[93]],
"E332TN":[1,[93]],
"E332n":[1,[93]],
"E340":[1,[93]],
"E342":[1,[93]],
"E342n":[1,[93]],
"E360":[1,[93]],
"E360d":[1,[93]],
"E360dn":[1,[93]],
"E450":[1,[93]],
"E450dn":[1,[93]],
"E460":[1,[93]],
"E460DW":[1,[93]],
"E460dn":[1,[93]],
"E462":[1,[93]],
"E462dtn":[1,[93]],
"M1246":[1,[94]],
"M3150":[1,[94]],
"M3250":[1,[94]],
"M3350":[1,[94]],
"M410":[1,[94]],
"M410N":[1,[94]],
"M412":[1,[94]],
"M412N":[1,[94]],
"M5155":[1,[94]],
"M5163":[1,[94]],
"M5170":[1,[94]],
"M5255":[1,[94]],
"MB2236":[1,[95]],
"MB2236ADWE":[1,[95]],
"MB2236I":[1,[95]],
"MB3442":[1,[95]],
"MB3442ADW":[1,[95]],
"MB3442I":[1,[95]],
"MC2425":[1,[96]],
"MC2425ADW":[1,[96]],
"MC2425DW":[1,[96]],
"MC3326":[1,[96]],
"MC3326ADWE":[1,[96]],
"MC3326I":[1,[96]],
"MC3426":[1,[96]],
"MC3426ADW":[1,[96]],
"MC3426I":[1,[96]],
"MS310":[1,[97]],
"MS310D":[1,[97]],
"MS310DN":[1,[97]],
"MS312":[1,[97]],
"MS312DN":[1,[97]],
"MS331":[1,[97]],
"MS331dn":[1,[97]],
"MS410":[1,[97]],
"MS410DN":[1,[97]],
"MS415":[1,[97]],
"MS415dn":[1,[97]],
"MS421":[1,[97]],
"MS421dn":[1,[97]],
"MS431":[1,[97]],
"MS431dn":[1,[97]],
"MS431dw":[1,[97]],
"MS510":[1,[97]],
"MS510DN":[1,[97]],
"MS521":[1,[97]],
"MS521dn":[1,[97]],
"MS531":[1,[97]],
"MS531DW":[1,[97]],
"MS610":[1,[97]],
"MS610DE":[1,[97]],
"MS610DN":[1,[97]],
"MS622":[1,[97]],
"MS622de":[1,[97]],
"MS631":[1,[97]],
"MS632":[1,[97]],
"MS632DWE":[1,[97]],
"MS639":[1,[97]],
"MS722":[1,[97]],
"MS810":[1,[97]],
"MS810DE":[1,[97]],
"MS810DN":[1,[97]],
"MS810N":[1,[97]],
"MS811":[1,[97]],
"MS811DN":[1,[97]],
"MS812":[1,[97]],
"MS812DE":[1,[97]],
"MS812DN":[1,[97]],
"MS823":[1,[97]],
"MS823dn":[1,[97]],
"MS826":[1,[97]],
"MS826DE":[1,[97]],
"MX310":[1,[98]],
"MX310DN":[1,[98]],
"MX410":[1,[98]],
"MX410DE":[1,[98]],
"MX421":[1,[98]],
"MX421ade":[1,[98]],
"MX431":[1,[98]],
"MX431ADNW":[1,[98]],
"MX431adn":[1,[98]],
"MX431adw":[1,[98]],
"MX511":[1,[98]],
"MX511DE":[1,[98]],
"MX511DHE":[1,[98]],
"MX5170":[1,[98]],
"MX520":[1,[98]],
"MX522":[1,[98]],
"MX522adhe":[1,[98]],
"MX532":[1,[98]],
"MX532adwe":[1,[98]],
"MX610DE":[1,[98]],
"MX611":[1,[98]],
"MX611DE":[1,[98]],
"MX611DHE":[1,[98]],
"MX622":[1,[98]],
"MX622ADHE":[1,[98]],
"MX632":[1,[98]],
"MX632ADWE":[1,[98]],
"MX710":[0,[98]],
"MX710DE":[0,[98]],
"MX710DHE":[0,[98]],
"MX711":[0,[98]],
"MX711DE":[0,[98]],
"MX711DHE":[0,[98]],
"MX721":[1,[98]],
"MX721adhe":[1,[98]],
"MX722":[1,[98]],
"MX722adhe":[1,[98]],
"MX810":[0,[98]],
"MX810DFE":[0,[98]],
"MX810DME":[0,[98]],
"MX810DXFE":[0,[98]],
"MX810DXME":[0,[98]],
"MX811":[0,[98]],
"MX811DFE":[0,[98]],
"MX811DME":[0,[98]],
"MX811DXFE":[0,[98]],
"MX811DXME":[0,[98]],
"MX812":[0,[98]],
"MX812DFE":[0,[98]],
"MX812DME":[0,[98]],
"MX812DXFE":[0,[98]],
"MX812DXME":[0,[98]],
"MX826":[1,[98]],
"MX826ade":[1,[98]],
"MX826adxe":[1,[98]],
"MX910":[1,[98]],
"MX910DE":[1,[98]],
"MX911":[1,[98]],
"MX911DTE":[1,[98]],
"MX912":[1,[98]],
"MX912DXE":[1,[98]],
"MX931":[1,[98]],
"Optra C1200":[1,[99]],
"Optra C1200N":[1,[99]],
"Optra C710":[0,[99]],
"Optra Colour":[1,[99]],
"Optra E310":[1,[99]],
"Optra E312L":[1,[99]],
"Optra K":[1,[99]],
"Optra M410":[1,[99]],
"Optra M410n":[1,[99]],
"Optra M412n":[1,[99]],
"Optra S1250":[1,[99]],
"Optra S1255":[1,[99]],
"Optra S1620":[1,[99]],
"Optra S1625":[1,[99]],
"Optra S1650":[1,[99]],
"Optra S1855":[1,[99]],
"Optra S2420":[1,[99]],
"Optra S2450":[1,[99]],
"Optra S2455":[1,[99]],
"Optra T":[1,[99]],
"Optra T610":[1,[99]],
"Optra T610N":[1,[99]],
"Optra T610SX":[1,[99]],
"Optra T612":[1,[99]],
"Optra T612N":[1,[99]],
"Optra T612SX":[1,[99]],
"Optra T614":[1,[99]],
"Optra T614DX":[1,[99]],
"Optra T614N":[1,[99]],
"Optra T616":[1,[99]],
"P3150":[0,[100]],
"P350":[0,[100]],
"P4350":[0,[100]],
"P6200":[0,[100]],
"P6210":[0,[100]],
"P6250":[0,[100]],
"P6300":[0,[100]],
"P707":[0,[100]],
"P910":[0,[100]],
"P915":[0,[100]],
"Pro4000":[0,[101]],
"Pro5500":[0,[101]],
"Pro715":[0,[101]],
"Pro805":[0,[101]],
"Pro901":[0,[101]],
"Pro905":[0,[101]],
"Pro915":[0,[101]],
"S1250":[1,[102]],
"S1255":[1,[102]],
"S1620":[1,[102]],
"S1625":[1,[102]],
"S1650":[1,[102]],
"S1855":[1,[102]],
"S2420":[1,[102]],
"S2450":[1,[102]],
"S2455":[1,[102]],
"S315":[0,[102]],
"S415":[0,[102]],
"S515":[0,[102]],
"T430":[1,[103]],
"T520":[1,[103]],
"T522":[1,[103]],
"T610":[1,[103]],
"T610N":[1,[103]],
"T610SX":[1,[103]],
"T612":[1,[103]],
"T612N":[1,[103]],
"T612SX":[1,[103]],
"T612V":[1,[103]],
"T614":[1,[103]],
"T614DX":[1,[103]],
"T614N":[1,[103]],
"T616":[1,[103]],
"T630":[1,[103]],
"T632":[1,[103]],
"T634":[1,[103]],
"T640":[1,[103]],
"T642":[1,[103]],
"T642DN":[1,[103]],
"T642DTN":[1,[103]],
"T642N":[1,[103]],
"T644":[1,[103]],
"T644DN":[1,[103]],
"T644DTN":[1,[103]],
"T644N":[1,[103]],
"T650":[1,[103]],
"T650DN":[1,[103]],
"T650DTN":[1,[103]],
"T650N":[1,[103]],
"T652":[1,[103]],
"T652DN":[1,[103]],
"T652DTN":[1,[103]],
"T654":[1,[103]],
"T654DN":[1,[103]],
"T654DTN":[1,[103]],
"T656":[1,[103]],
"T656DNE":[1,[103]],
"TS654":[1,[103]],
"TS656":[1,[103]],
"W840":[1,[104]],
"W840DN":[1,[104]],
"W840N":[1,[104]],
"W850":[1,[104]],
"W850DN":[1,[104]],
"W850N":[1,[104]],
"X1140":[0,[105]],
"X1150":[0,[105]],
"X1170":[0,[105]],
"X1175":[0,[105]],
"X1185":[0,[105]],
"X1195":[0,[105]],
"X1200":[0,[105]],
"X125":[0,[105]],
"X1250":[0,[105]],
"X1270":[0,[105]],
"X1290":[0,[105]],
"X203":[1,[105]],
"X203n":[1,[105]],
"X204":[1,[105]],
"X204n":[1,[105]],
"X215":[1,[105]],
"X2200":[0,[105]],
"X2250":[0,[105]],
"X2330":[0,[105]],
"X2350":[0,[105]],
"X2450":[0,[105]],
"X2470":[0,[105]],
"X2530":[0,[105]],
"X2550":[0,[105]],
"X2630":[0,[105]],
"X264":[1,[105]],
"X264dn":[1,[105]],
"X2650":[0,[105]],
"X2670":[0,[105]],
"X3330":[0,[105]],
"X3350":[0,[105]],
"X342":[1,[105]],
"X342n":[1,[105]],
"X3470":[0,[105]],
"X3550":[0,[105]],
"X363":[1,[105]],
"X363dn":[1,[105]],
"X364":[1,[105]],
"X364DW":[1,[105]],
"X364dn":[1,[105]],
"X422":[1,[105]],
"X422MFP":[1,[105]],
"X4250":[0,[105]],
"X4270":[0,[105]],
"X4500":[0,[105]],
"X4530":[0,[105]],
"X4550":[0,[105]],
"X463":[1,[105]],
"X463de":[1,[105]],
"X464":[1,[105]],
"X464de":[1,[105]],
"X466":[1,[105]],
"X466DTE":[1,[105]],
"X466DWE":[1,[105]],
"X466de":[1,[105]],
"X4850":[0,[105]],
"X4875":[0,[105]],
"X4975":[0,[105]],
"X500":[1,[105]],
"X500N":[1,[105]],
"X502":[1,[105]],
"X502N":[1,[105]],
"X5070":[0,[105]],
"X5150":[0,[105]],
"X520":[1,[105]],
"X5200":[0,[105]],
"X522":[1,[105]],
"X5250":[0,[105]],
"X5270":[0,[105]],
"X5400":[0,[105]],
"X543":[1,[105]],
"X543DN":[1,[105]],
"X544":[1,[105]],
"X544DTN":[1,[105]],
"X544DW":[1,[105]],
"X544dn":[1,[105]],
"X5450":[0,[105]],
"X546":[1,[105]],
"X546dtn":[1,[105]],
"X5470":[0,[105]],
"X548":[1,[105]],
"X548DE":[1,[105]],
"X548DTE":[1,[105]],
"X560":[1,[105]],
"X560N":[1,[105]],
"X5650":[0,[105]],
"X6150":[0,[105]],
"X6170":[0,[105]],
"X63":[0,[105]],
"X632":[1,[105]],
"X634":[1,[105]],
"X634E":[1,[105]],
"X642":[1,[105]],
"X642E":[1,[105]],
"X644E":[1,[105]],
"X646":[1,[105]],
"X646DTE":[1,[105]],
"X646E":[1,[105]],
"X646EF":[1,[105]],
"X651":[1,[105]],
"X652":[1,[105]],
"X652DE":[1,[105]],
"X654":[1,[105]],
"X654DE":[1,[105]],
"X656":[1,[105]],
"X656DTE":[1,[105]],
"X656de":[1,[105]],
"X6570":[0,[105]],
"X6575":[0,[105]],
"X658":[1,[105]],
"X658DFE":[1,[105]],
"X658dme":[1,[105]],
"X6675":[0,[105]],
"X7100":[0,[105]],
"X7170":[0,[105]],
"X73":[0,[105]],
"X7300":[0,[105]],
"X734":[1,[105]],
"X734DE":[1,[105]],
"X7350":[0,[105]],
"X736":[1,[105]],
"X736DE":[1,[105]],
"X738":[1,[105]],
"X738DE":[1,[105]],
"X738DTE":[1,[105]],
"X746":[1,[105]],
"X746DE":[1,[105]],
"X748":[1,[105]],
"X748DE":[1,[105]],
"X748DTE":[1,[105]],
"X75":[0,[105]],
"X762":[1,[105]],
"X762E":[1,[105]],
"X7675":[0,[105]],
"X772e":[1,[105]],
"X782E":[1,[105]],
"X792":[1,[105]],
"X792DE":[1,[105]],
"X792DTE":[1,[105]],
"X83":[0,[105]],
"X830":[1,[105]],
"X8300":[0,[105]],
"X830e":[1,[105]],
"X832":[1,[105]],
"X832e":[1,[105]],
"X8350":[0,[105]],
"X85":[0,[105]],
"X860":[1,[105]],
"X860DHE":[1,[105]],
"X860de":[1,[105]],
"X862":[1,[105]],
"X864":[1,[105]],
"X864DHE":[1,[105]],
"X925":[1,[105]],
"X925DE":[1,[105]],
"X9350":[0,[105]],
"X940":[1,[105]],
"X940e":[1,[105]],
"X945":[1,[105]],
"X945e":[1,[105]],
"X950":[1,[105]],
"X950DE":[1,[105]],
"X950DTE":[1,[105]],
"X952DTE":[1,[105]],
"X954":[1,[105]],
"X954DE":[1,[105]],
"X954DHE":[1,[105]],
"X9575":[0,[105]],
"XC2132":[1,[106]],
"XC2235":[1,[106]],
"XC2335":[1,[106]],
"XC4150":[1,[106]],
"XC4240":[1,[106]],
"XC4342":[1,[106]],
"XC4352":[1,[106]],
"XC8155":[1,[106]],
"XC8160":[1,[106]],
"XC9235":[1,[106]],
"XC9255":[1,[106]],
"XC9525":[1,[106]],
"XC9535":[1,[106]],
"XC9600":[1,[106]],
"XC9635":[1,[106]],
"XC9645":[1,[106]],
"XC9655":[1,[106]],
"XM1242":[1,[107]],
"XM1246":[1,[107]],
"XM3142":[1,[107]],
"XM3150":[1,[107]],
"XM3250":[1,[107]],
"XM3350":[1,[107]],
"XM5163":[1,[107]],
"XM5170":[1,[107]],
"XM5365":[1,[107]],
"XM5370":[1,[107]],
"XM7155":[1,[107]],
"XM7155X":[1,[107]],
"XM7163X":[1,[107]],
"XM7170X":[1,[107]],
"XM7355":[1,[107]],
"XS548DE":[1,[108]],
"XS652":[1,[108]],
"XS654":[1,[108]],
"XS658":[1,[108]],
"XS748":[1,[108]],
"XS796":[1,[108]],
"XS955":[1,[108]],
"Z11":[0,[109]],
"Z12":[0,[109]],
"Z13":[0,[109]],
"Z1300":[0,[109]],
"Z1320":[0,[109]],
"Z1400":[0,[109]],
"Z1420":[0,[109]],
"Z22":[0,[109]],
"Z23":[0,[109]],
"Z25":[0,[109]],
"Z31":[0,[109]],
"Z32":[0,[109]],
"Z33":[0,[109]],
"Z35":[0,[109]],
"Z42":[0,[109]],
"Z43":[0,[109]],
"Z45SE":[0,[109]],
"Z51":[0,[109]],
"Z511":[0,[109]],
"Z513":[0,[109]],
"Z515":[0,[109]],
"Z517":[0,[109]],
"Z52":[0,[109]],
"Z53":[0,[109]],
"Z54":[0,[109]],
"Z54SE":[0,[109]],
"Z55":[0,[109]],
"Z55SE":[0,[109]],
"Z603":[0,[109]],
"Z605":[0,[109]],
"Z613":[0,[109]],
"Z615":[0,[109]],
"Z617":[0,[109]],
"Z65":[0,[109]],
"Z65N":[0,[109]],
"Z65P":[0,[109]],
"Z700":[0,[109]],
"Z705":[0,[109]],
"Z710":[0,[109]],
"Z715":[0,[109]],
"Z730":[0,[109]],
"Z735":[0,[109]],
"Z810":[0,[109]],
"Z815":[0,[109]],
"Z816":[0,[109]],
"Z818":[0,[109]],
"Z82":[0,[109]],
"Z845":[0,[109]]
},
"OKI": {
"B2200":[1,[110]],
"B2400":[1,[110]],
"B401d":[1,[110]],
"B401dn":[1,[110]],
"B411":[1,[110]],
"B411dn":[1,[110]],
"B412":[1,[110]],
"B412dn":[1,[110]],
"B430":[1,[110]],
"B431":[1,[110]],
"B431dn":[1,[110]],
"B432":[1,[110]],
"B432dn":[1,[110]],
"B433dn":[1,[110]],
"B440":[1,[110]],
"B512":[1,[110]],
"B512dn":[1,[110]],
"B513dn":[1,[110]],
"B710":[1,[110]],
"B720":[1,[110]],
"B721":[1,[110]],
"B721dn":[1,[110]],
"B730":[1,[110]],
"B731":[1,[110]],
"B731dn":[1,[110]],
"B820":[1,[110]],
"B820dn":[1,[110]],
"B820n":[1,[110]],
"C110":[1,[111]],
"C130":[1,[111]],
"C130n":[1,[111]],
"C301":[1,[111]],
"C301dn":[1,[111]],
"C310":[1,[111]],
"C3100":[1,[111]],
"C310dn":[1,[111]],
"C3200":[1,[111]],
"C3200n":[1,[111]],
"C321":[1,[111]],
"C321dn":[1,[111]],
"C330":[1,[111]],
"C3300":[1,[111]],
"C330dn":[1,[111]],
"C331":[1,[111]],
"C331dn":[1,[111]],
"C332":[1,[111]],
"C332dn":[1,[111]],
"C3400":[1,[111]],
"C3520":[1,[111]],
"C3520MFP":[1,[111]],
"C3530":[1,[111]],
"C3530MFP":[1,[111]],
"C3600":[1,[111]],
"C3600N":[1,[111]],
"C510":[1,[111]],
"C510dn":[1,[111]],
"C511":[1,[111]],
"C511dn":[1,[111]],
"C530":[1,[111]],
"C530dn":[1,[111]],
"C531":[1,[111]],
"C531dn":[1,[111]],
"C532":[1,[111]],
"C532dn":[1,[111]],
"C5600":[1,[111]],
"C561":[1,[111]],
"C562dnw":[1,[111]],
"C5650":[1,[111]],
"C5700":[1,[111]],
"C5750":[1,[111]],
"C5850":[1,[111]],
"C5950":[1,[111]],
"C610":[1,[111]],
"C610dn":[1,[111]],
"C610n":[1,[111]],
"C612":[1,[111]],
"C612dn":[1,[111]],
"C612n":[1,[111]],
"C650":[1,[111]],
"C650dn":[1,[111]],
"C710":[1,[111]],
"C710N":[1,[111]],
"C711":[1,[111]],
"C711dn":[1,[111]],
"C711n":[1,[111]],
"C711wt":[1,[111]],
"C712":[1,[111]],
"C712cdtn":[1,[111]],
"C712dn":[1,[111]],
"C712dtn":[1,[111]],
"C712n":[1,[111]],
"C810":[1,[111]],
"C810n":[1,[111]],
"C811":[1,[111]],
"C830":[1,[111]],
"C830n":[1,[111]],
"C831":[1,[111]],
"C831N":[1,[111]],
"C831dn":[1,[111]],
"C833":[1,[111]],
"C833dn":[1,[111]],
"C833n":[1,[111]],
"C834":[1,[111]],
"C834dnw":[1,[111]],
"C834ndw":[1,[111]],
"C834nw":[1,[111]],
"C844dnw":[1,[111]],
"C8600":[1,[111]],
"C8800":[1,[111]],
"C900":[1,[111]],
"C910":[1,[111]],
"C910n":[1,[111]],
"C911":[1,[111]],
"C911dn":[1,[111]],
"C9200":[1,[111]],
"C9300":[1,[111]],
"C931":[1,[111]],
"C931dn":[1,[111]],
"C9400":[1,[111]],
"C941":[1,[111]],
"C941dnCL":[1,[111]],
"C941dnWT":[1,[111]],
"C9500":[1,[111]],
"C9600":[1,[111]],
"C9650":[1,[111]],
"C9800":[1,[111]],
"C9850":[1,[111]],
"ES3452":[1,[112]],
"ES3640":[1,[112]],
"ES3640e":[1,[112]],
"ES3640eMFP":[1,[112]],
"ES4131":[1,[112]],
"ES4132":[1,[112]],
"ES4132dn":[1,[112]],
"ES4191":[1,[112]],
"ES4192dn":[1,[112]],
"ES5112dn":[1,[112]],
"ES5162dn":[1,[112]],
"ES5431":[1,[112]],
"ES5442":[1,[112]],
"ES5460":[1,[112]],
"ES5462":[1,[112]],
"ES5473dn":[1,[112]],
"ES5473dnw":[1,[112]],
"ES6410":[1,[112]],
"ES6412":[1,[112]],
"ES6450":[1,[112]],
"ES6450dn":[1,[112]],
"ES7131":[1,[112]],
"ES7170":[1,[112]],
"ES7411":[1,[112]],
"ES7412":[1,[112]],
"ES7470":[1,[112]],
"ES7480":[1,[112]],
"ES8140":[1,[112]],
"ES8431":[1,[112]],
"ES8433":[1,[112]],
"ES8434":[1,[112]],
"ES8434dn":[1,[112]],
"ES8460":[1,[112]],
"ES8462":[1,[112]],
"ES8473":[1,[112]],
"ES8473dn":[1,[112]],
"ES9455":[1,[112]],
"ES9465":[1,[112]],
"ES9466":[1,[112]],
"ES9475":[1,[112]],
"ES9476":[1,[112]],
"MB440":[1,[114]],
"MB451":[1,[114]],
"MB451dnw":[1,[114]],
"MB451w":[1,[114]],
"MB470":[1,[114]],
"MB471":[1,[114]],
"MB471dn":[1,[114]],
"MB472":[1,[114]],
"MB472dnw":[1,[114]],
"MB480":[1,[114]],
"MB491":[1,[114]],
"MB491dn":[1,[114]],
"MB492":[1,[114]],
"MB492dn":[1,[114]],
"MB562":[1,[114]],
"MB562dnw":[1,[114]],
"MB760":[1,[114]],
"MB760dn":[1,[114]],
"MB770":[1,[114]],
"MB770dfn":[1,[114]],
"MC160":[1,[115]],
"MC160n":[1,[115]],
"MC342":[1,[115]],
"MC342dnw":[1,[115]],
"MC361":[1,[115]],
"MC361dn":[1,[115]],
"MC362":[1,[115]],
"MC362dn":[1,[115]],
"MC362dnw":[1,[115]],
"MC362w":[1,[115]],
"MC363":[1,[115]],
"MC363dn":[1,[115]],
"MC554dn":[1,[115]],
"MC554dnw":[1,[115]],
"MC560":[1,[115]],
"MC561":[1,[115]],
"MC562":[1,[115]],
"MC562dn":[1,[115]],
"MC562dnw":[1,[115]],
"MC563":[1,[115]],
"MC563dn":[1,[115]],
"MC573":[1,[115]],
"MC573dn":[1,[115]],
"MC770":[1,[115]],
"MC770dn":[1,[115]],
"MC770dnfax":[1,[115]],
"MC780":[1,[115]],
"MC780dfn":[1,[115]],
"MC780dfnfax":[1,[115]],
"MC852":[1,[115]],
"MC852cdxn":[1,[115]],
"MC852dn":[1,[115]],
"MC853":[1,[115]],
"MC853dn":[1,[115]],
"MC853dnct":[1,[115]],
"MC853dnx":[1,[115]],
"MC860":[1,[115]],
"MC862":[1,[115]],
"MC862cdxn":[1,[115]],
"MC862dn":[1,[115]],
"MC873":[1,[115]],
"MC873dn":[1,[115]],
"MC873dnct":[1,[115]],
"MC873dnv":[1,[115]],
"OF1000":[1,[113]],
"OL400e":[1,[113]],
"OL410e":[1,[113]],
"OL600e":[1,[113]],
"OL610e":[1,[113]],
"OL810e":[1,[113]],
"Pro1040":[1,[116]],
"Pro1050":[1,[116]],
"Pro6410":[1,[116]],
"Pro7411":[1,[116]],
"Pro7411WT":[1,[116]],
"Pro8432WT":[1,[116]],
"Pro9431dn":[1,[116]],
"Pro9541dn":[1,[116]],
"Pro9542dn":[1,[116]]
},
"Samsung": {
"CLP-320":[1,[117]],
"CLP-320N":[1,[117]],
"CLP-325":[1,[117]],
"CLP-325W":[1,[117]],
"CLP-360":[1,[117]],
"CLP-365":[1,[117]],
"CLP-365W":[1,[117]],
"CLP-415N":[1,[117]],
"CLP-415NW":[1,[117]],
"CLP-620ND":[1,[117]],
"CLP-670N":[1,[117]],
"CLP-670ND":[1,[117]],
"CLP-680DW":[1,[117]],
"CLP-680ND":[1,[117]],
"CLX-3180":[1,[118]],
"CLX-3185":[1,[118]],
"CLX-3185FN":[1,[118]],
"CLX-3185FW":[1,[118]],
"CLX-3300":[1,[118]],
"CLX-3305":[1,[118]],
"CLX-3305FN":[1,[118]],
"CLX-3305FW":[1,[118]],
"CLX-4170":[1,[118]],
"CLX-4190":[1,[118]],
"CLX-4195FN":[1,[118]],
"CLX-4195FW":[1,[118]],
"CLX-4195N":[1,[118]],
"CLX-6220FX":[1,[118]],
"CLX-6250FX":[1,[118]],
"CLX-6260FD":[1,[118]],
"CLX-6260FR":[1,[118]],
"CLX-6260FW":[1,[118]],
"CLX-6260ND":[1,[118]],
"CLX9201NA":[1,[118]],
"CLX9251NA":[1,[118]],
"CLX9301NA":[1,[118]],
"ML-1660":[1,[119]],
"ML-1665":[1,[119]],
"ML-1670":[1,[119]],
"ML-1860":[1,[119]],
"ML-1865W":[1,[119]],
"ML-2010":[1,[119]],
"ML-2015":[1,[119]],
"ML-2160":[1,[119]],
"ML-2164":[1,[119]],
"ML-2165":[1,[119]],
"ML-2165W":[1,[119]],
"ML-2510":[1,[119]],
"ML-2570":[1,[119]],
"ML-2571N":[1,[119]],
"MultiXpress SL-K7400LX":[1,[120]],
"MultiXpress SL-K7500LX":[1,[120]],
"MultiXpress SL-K7600LX":[1,[120]],
"MultiXpress X3220NR":[1,[121]],
"MultiXpress X3280NR":[1,[121]],
"SCX-3200":[1,[122]],
"SCX-3400":[1,[122]],
"SCX-3405F":[1,[122]],
"SCX-3405FW":[1,[122]],
"SL-C1810W":[1,[120]],
"SL-C1860FW":[1,[120]],
"SL-C3010":[1,[120]],
"SL-C3010ND":[1,[120]],
"SL-C3060":[1,[120]],
"SL-C3060FR":[1,[120]],
"SL-M2020":[1,[120]],
"SL-M2020W":[1,[120]],
"SL-M2070":[1,[120]],
"SL-M2070FW":[1,[120]],
"SL-X4220RX":[1,[120]],
"SL-X4250LX":[1,[120]],
"SL-X4300LX":[1,[120]],
"SL-X7400":[1,[120]],
"SL-X7400GX":[1,[120]],
"SL-X7400LX":[1,[120]],
"SL-X7500":[1,[120]],
"SL-X7500GX":[1,[120]],
"SL-X7500LX":[1,[120]],
"SL-X7600":[1,[120]],
"SL-X7600GX":[1,[120]],
"SL-X7600LX":[1,[120]],
"SLM2825":[1,[120]],
"SLM2825DW":[1,[120]],
"SLM2835":[1,[120]],
"SLM2835DW":[1,[120]],
"SLM2875":[1,[120]],
"SLM2875FW":[1,[120]],
"SLM2885":[1,[120]],
"SLM2885DW":[1,[120]],
"SLM3820":[1,[120]],
"SLM3820DW":[1,[120]],
"SLM3820ND":[1,[120]],
"SLM3870":[1,[120]],
"SLM3870FD":[1,[120]],
"SLM3870FW":[1,[120]],
"SLM4020":[1,[120]],
"SLM4020ND":[1,[120]],
"SLM4030":[1,[120]],
"SLM4030ND":[1,[120]],
"SLM4070":[1,[120]],
"SLM4080FX":[1,[120]],
"SLX4220RX":[1,[120]],
"SLX4230LX":[1,[120]],
"SLX4250LX":[1,[120]],
"SLX4300LX":[1,[120]],
"SLX4330RX":[1,[120]],
"Samsung CLP680DW":[1,[117]],
"Samsung CLP680ND":[1,[117]],
"Samsung CLX6260FD":[1,[118]],
"Samsung CLX6260FR":[1,[118]],
"Samsung CLX6260FW":[1,[118]],
"Samsung CLX6260ND":[1,[118]],
"Samsung MultiXpress X3220NR":[1,[121]],
"Samsung MultiXpress X3280NR":[1,[121]],
"Samsung SLM4530":[1,[120]],
"Samsung SLM4530ND":[1,[120]]
}
}
};